import { TURKISH_MESSAGES } from "./messages.tr.js";

export const PLATFORM_DEFAULT_LOCALE = "fr-FR";

export const MESSAGES = {
  "fr-FR": {
    bottomNav: {
      client: {
        home: "Accueil",
        cart: "Panier",
        tracking: "Suivis",
        profile: "Profil",
      },
      vendor: {
        dashboard: "Dashboard",
        inventory: "Inventaire",
        orders: "Commandes",
        profile: "Profil",
      },
      courier: {
        dashboard: "Dashboard",
        runs: "Courses",
        route: "Tournee",
        profile: "Profil",
      },
      admin: {
        dashboard: "Dashboard",
        manage: "Gestion",
        notifications: "Notifs",
        profile: "Profil",
      },
      ambassador: {
        dashboard: "Dashboard",
        network: "Reseaux",
        accounts: "Ajouter",
        profile: "Profil",
      },
    },
    desktopShell: {
      brand: "Riveltime",
      tagline: "Console operationnelle",
      nav: {
        ariaLabel: "Navigation principale desktop",
        title: "Navigation",
      },
      platform: {
        tablet: "Tablette",
        desktop: "Ordinateur",
      },
      role: {
        label: "Role",
        client: "Client",
        vendor: "Vendeur",
        courier: "Livreur",
        admin: "Admin",
        guest: "Visiteur",
      },
      connection: {
        label: "Reseau",
      },
      actions: {
        home: "Retour a l'accueil",
      },
      alt: {
        logo: "Logo Riveltime",
      },
    },
    common: {
      delete: "Supprimer",
    },
    supportIssue: {
      title: "Signaler un probleme",
      subtitle: "Reponse visee sous 24h ouvrees. Les infos techniques restent optionnelles.",
      queuedTitle: "Signalement en attente",
      sentTitle: "Signalement envoye",
      queuedBody: "Ticket enregistre hors ligne. Envoi automatique des le retour du reseau.",
      sentBody: "Merci. Ton ticket a bien ete transmis a l'equipe support.",
      dateLabel: "Date",
      localId: "ID local",
      ticketId: "ID ticket",
      close: "Fermer",
      introTitle: "Explique rapidement le probleme",
      introBody: "Decris l'action, ce que tu attendais, et ce qui s'est passe.",
      category: "Categorie",
      impact: "Impact",
      description: "Description",
      descriptionPlaceholder: "Ex: J'ai voulu payer ma commande depuis la vitrine, puis la page est restee bloquee sans confirmer le paiement.",
      descriptionCounter: "{{count}}/{{min}} minimum",
      technicalTitle: "Infos techniques (optionnel)",
      technicalContextLabel: "Joindre le contexte technique (route, appareil, version, reseau).",
      screenshotLabel: "Joindre une capture (bientot disponible, desactive pour l'instant).",
      sensitiveWarning: "N'ajoutez jamais de donnees sensibles (mot de passe, token, donnees de paiement).",
      previewTitle: "Apercu des infos techniques jointes",
      previewRole: "Role",
      previewLocation: "Localisation",
      previewDevice: "Appareil",
      previewEmail: "Email",
      previewPhone: "Numero",
      previewDateTime: "Date / Heure",
      na: "n/a",
      send: "Envoyer le signalement",
      sending: "Envoi...",
      retryIn: "Nouvel envoi possible dans {{seconds}}s.",
      sla: "Temps de reponse vise: 24h ouvrees.",
      locationLoading: "En cours...",
      locationUnavailable: "Indisponible",
      locationDenied: "Non autorisee",
      queueError: "Impossible de mettre le ticket en attente.",
      submitError: "Impossible d'envoyer le signalement.",
      categories: {
        account_auth: "Compte / Connexion",
        orders_delivery: "Commandes / Livraison",
        payments_billing: "Paiement / Facturation",
        map_location: "Carte / Localisation",
        ui_bug: "Bug interface",
        performance: "Performance",
        other: "Autre",
      },
      impacts: {
        blocking: "Bloquant",
        degraded: "Genant",
        minor: "Mineur",
        cosmetic: "Cosmetique",
      },
    },
    verifyEmail: {
      verifiedSessionRefreshing: "Adresse verifiee. Mise a jour de la session...",
      openMailboxToast: "Ouvre ta messagerie habituelle",
      resendThrottled: "Demande envoyee a {{email}}. Auth0 limite le rythme, l'email peut arriver avec un leger delai.",
      verificationLinkReady: "Lien de verification pret pour {{email}}. Ouvre-le pour verifier ton adresse.",
      verificationResent: "E-mail de verification renvoye a {{email}}. Pense a verifier tes spams.",
      requestAcceptedNoConfirmation: "Requete acceptee, mais pas de confirmation cote serveur.",
      tooManyRequests: "Tu as deja demande un e-mail recemment. Reessaie dans quelques minutes.",
      sendError: "Erreur lors de l'envoi de l'e-mail de verification.",
      invalidEmail: "Merci d'entrer une adresse e-mail valide.",
      emailUpdated: "Adresse mise a jour. Un e-mail de verification vient d'etre envoye.",
      emailInUse: "Adresse deja utilisee. Essaie une autre adresse.",
      emailUpdateError: "Impossible de mettre a jour l'adresse e-mail.",
      sessionInvalid: "Session invalide. Reconnecte-toi.",
      deleteFailed: "La suppression a echoue. Reessaie plus tard.",
      alreadyVerified: "Adresse deja verifiee. Vous pouvez acceder a votre espace.",
      title: "Verifie ton e-mail",
      subtitle: "Nous avons envoye un lien de confirmation a",
      sentStep: "Envoye",
      openLinkStep: "Ouvre le lien",
      verifiedStep: "Verifie",
      resendNow: "Renvoyer l'e-mail",
      resendIn: "Renvoyer dans {{seconds}}s",
      openingMailbox: "Ouvrir ma messagerie",
      editEmail: "Modifier l'adresse e-mail",
      logout: "Se deconnecter",
      deleteProfile: "Supprimer mon profil",
      goToSpace: "Acceder a mon espace",
      tipsSpam: "Verifie aussi le dossier indesirables. Le lien expire apres un delai limite.",
      tipsChangeEmail: "Tu peux changer d'adresse ci-dessus : un nouveau lien te sera envoye.",
      helpTitle: "Besoin d'aide ?",
      help1: "Ouvre le lien dans le meme navigateur.",
      help2: "Evite la navigation privee pour la verification.",
      help3: "Si le lien a expire, renvoie un e-mail.",
      modalTitle: "Modifier l'adresse e-mail",
      modalBody: "Une fois modifiee, un nouveau lien de verification sera envoye.",
      modalPlaceholder: "nouvelle-adresse@email.com",
      cancel: "Annuler",
      confirm: "Valider",
      close: "Fermer",
      deleteConfirm: "Cette action est irreversible. Note : si des commandes sont en cours, la suppression sera bloquee.",
      activeOrders_one: "Suppression impossible : {{count}} commande est encore en cours",
      activeOrders_other: "Suppression impossible : {{count}} commandes sont encore en cours",
      activeOrdersGeneric: "Suppression impossible : des commandes sont encore en cours",
      unknownEmail: "-",
      sending: "Envoi...",
    },
    authCallback: {
      loading: "Connexion...",
      bootstrappingProfile: "Preparation de ton espace...",
      bootstrappingProfileHint: "Nous finalisons ta session et recuperons les donnees necessaires avant la redirection.",
      errorTitle: "Echec de la connexion",
      retry: "Relancer la connexion",
      retrying: "Redirection...",
      backHome: "Retour a l'accueil",
      errorCode: "Code: {{code}}",
      recovery: {
        wakingBackend: "Reveil du service en cours...",
        wakingBackendHint: "Le serveur reprend la main. Cela peut prendre quelques secondes sur les offres gratuites.",
        syncingProfile: "Preparation de ton compte...",
        syncingProfileHint: "Nous recuperons ton profil avant de t'envoyer vers ton espace.",
        attempt: "Tentative {{count}}",
      },
      errors: {
        access_denied: "Connexion annulee. Reessaie pour continuer.",
        unauthorized: "Connexion refusee. Verifie ton compte puis reessaie.",
        server_error: "Service de connexion temporairement indisponible. Reessaie dans quelques instants.",
        invalid_state: "La reprise de connexion a expire ou a ete interrompue. Relance la connexion.",
        invalid_request: "La requete de connexion est invalide. Relance la connexion.",
        login_required: "Reconnexion necessaire. Nous n'avons pas trouve de session Auth0 active pour continuer.",
        consent_required: "Reconnexion necessaire. Une autorisation est requise pour continuer.",
        interaction_required: "Reconnexion necessaire. Une etape interactive est requise pour continuer.",
        timeout: "La connexion prend plus de temps que prevu. Reessaie ou retourne a l'accueil.",
        auth_error: "La connexion n'a pas pu etre finalisee. Reessaie.",
      },
    },
    sessionExpiredModal: {
      badges: {
        reconnect: "Reconnexion",
        backend_wakeup: "Reprise en cours",
      },
      title: "Reconnexion necessaire",
      loading: "Tentative de reprise de session...",
      reconnect: "Se reconnecter",
      retry: "Reessayer",
      switchAccount: "Changer de compte",
      footer: "Pour ta securite, les actions sensibles sont bloquees tant que tu ne relances pas une session Auth0.",
      recovery: {
        title: "Nous rétablissons l’accès",
        description: "Cela prend généralement quelques secondes. Tu n’as rien à faire.",
        status: "Reprise automatique en cours...",
        action: "Relancer maintenant",
      },
      messages: {
        missing_refresh_token: "Ta session est restee inactive trop longtemps. Nous n'avons pas pu la renouveler automatiquement.",
        login_required: "Reconnexion necessaire. Nous n'avons pas trouve de session Auth0 active pour continuer.",
        consent_required: "Reconnexion necessaire. Une autorisation est requise pour continuer.",
        interaction_required: "Reconnexion necessaire. Une etape interactive est requise pour continuer.",
        invalid_grant: "Ta session a ete invalidee. Reconnecte-toi pour continuer.",
        session_expired: "Ta session a expire. Recharge une session securisee pour continuer.",
        backend_wakeup: "Le service reprend. Cela prend parfois quelques secondes.",
        default: "Nous n'avons pas pu renouveler ton acces automatiquement. Reconnecte-toi pour reprendre la ou tu t'es arrete.",
      },
    },
    legalViewer: {
      notFoundTitle: "Document introuvable",
      notFoundDescription: "Le document demande n'existe pas. Verifie l'URL.",
      version: "Version {{version}}",
      fileMissing: "Impossible de joindre le fichier PDF. Verifie qu'il est present dans public{{path}}.",
      inlinePreviewUnsupported: "L'aperçu integre n'est pas pleinement pris en charge sur cet appareil. Vous pouvez ouvrir le document :",
      openPdf: "Ouvrir le PDF",
      downloadPdf: "Telecharger",
      pdfTitle: "PDF {{title}}",
      previewError: "Aperçu impossible. Utilise le bouton Ouvrir le PDF.",
      openPdfNewTab: "Ouvrir le PDF dans un nouvel onglet",
      firstNameLabel: "Prenom",
      firstNamePlaceholder: "Entrez votre prenom",
      lastNameLabel: "Nom",
      lastNamePlaceholder: "Entrez votre nom",
      identityRequired: "Le prenom et le nom sont obligatoires pour accepter ces CGU.",
      acceptLabel: "J'ai lu et j'accepte les {{title}} (version {{version}}).",
      acceptSaving: "Enregistrement...",
      acceptCta: "J'accepte",
      acceptError: "Impossible d'enregistrer l'acceptation. Reessaie dans un instant.",
    },
    vitrine: {
      productDetails: "Details du produit",
      noDescription: "Aucune description fournie.",
      basePrice: "Prix de base",
      preparedFast: "Prepare rapidement",
      currentPrice: "Prix actuel",
      optionsIncluded: "Inclus options (+{{amount}})",
      required: "obligatoire",
      maxSelections: "Max {{count}} selection(s)",
      selectionsCount: "{{count}} selection(s)",
      orderTotal: "Total commande",
      addToCart: "Ajouter au panier",
      loadingError: "Erreur lors du chargement des donnees de la boutique.",
      networkTitle: "Connexion indisponible",
      networkDescription: "Verifie ton reseau puis relance le chargement de la vitrine.",
      notFoundTitle: "Boutique introuvable",
      notFoundDescription: "Cette vitrine n'est peut-etre plus disponible pour le moment.",
      unavailableTitle: "Service temporairement indisponible",
      unavailableDescription: "Le service rencontre un ralentissement. Reessaie dans quelques secondes.",
      genericTitle: "Impossible d'afficher cette vitrine",
      genericDescription: "Une erreur est survenue pendant le chargement. Tu peux reessayer maintenant.",
      reloading: "Rechargement...",
      retry: "Reessayer",
      backHome: "Retour a l'accueil",
      searchProduct: "Rechercher un produit",
      searchPlaceholder: "Rechercher un produit...",
      allCollections: "Tous",
      filtersTitle: "Filtres produits",
      collectionsTitle: "Collections",
      viewModeTitle: "Affichage",
      viewModeGrid: "Grille",
      viewModeList: "Liste",
      resetFilters: "Reinitialiser",
      viewDetails: "Voir le detail",
      addedToCart: "{{name}} ajoute au panier",
      seller: "Vendeur",
      delay_day_one: "{{count}} jour",
      delay_day_other: "{{count}} jours",
      delay_hour_one: "{{count}}h",
      delay_hour_other: "{{count}}h",
      delay_minute_one: "{{count}} min",
      delay_minute_other: "{{count}} min",
      quantityTimesUnit: "{{qty}} x {{unitPrice}}",
    },
  },
  "en-US": {
    bottomNav: {
      client: { home: "Home", cart: "Cart", tracking: "Tracking", profile: "Profile" },
      vendor: { dashboard: "Dashboard", inventory: "Inventory", orders: "Orders", profile: "Profile" },
      courier: { dashboard: "Dashboard", runs: "Jobs", route: "Route", profile: "Profile" },
      admin: { dashboard: "Dashboard", manage: "Manage", notifications: "Alerts", profile: "Profile" },
      ambassador: { dashboard: "Dashboard", network: "Network", accounts: "Add", profile: "Profile" },
    },
    desktopShell: {
      brand: "Riveltime",
      tagline: "Operations cockpit",
      nav: {
        ariaLabel: "Main desktop navigation",
        title: "Navigation",
      },
      platform: {
        tablet: "Tablet",
        desktop: "Desktop",
      },
      role: {
        label: "Role",
        client: "Client",
        vendor: "Vendor",
        courier: "Courier",
        admin: "Admin",
        guest: "Guest",
      },
      connection: {
        label: "Network",
      },
      actions: {
        home: "Back to home",
      },
      alt: {
        logo: "Riveltime logo",
      },
    },
    common: {
      delete: "Delete",
    },
    supportIssue: {
      title: "Report an issue",
      subtitle: "Target response within 24 business hours. Technical details are optional.",
      queuedTitle: "Issue queued",
      sentTitle: "Issue sent",
      queuedBody: "Ticket saved offline. It will sync automatically when network is back.",
      sentBody: "Thanks. Your ticket has been sent to support.",
      dateLabel: "Date",
      localId: "Local ID",
      ticketId: "Ticket ID",
      close: "Close",
      introTitle: "Briefly explain the issue",
      introBody: "Describe the action, what you expected, and what happened.",
      category: "Category",
      impact: "Impact",
      description: "Description",
      descriptionPlaceholder: "Example: I tried to pay from the storefront, then the page stayed stuck without confirming payment.",
      descriptionCounter: "{{count}}/{{min}} minimum",
      technicalTitle: "Technical details (optional)",
      technicalContextLabel: "Attach technical context (route, device, app version, network).",
      screenshotLabel: "Attach screenshot (coming soon, currently disabled).",
      sensitiveWarning: "Never include sensitive data (password, token, payment data).",
      previewTitle: "Attached technical details preview",
      previewRole: "Role",
      previewLocation: "Location",
      previewDevice: "Device",
      previewEmail: "Email",
      previewPhone: "Phone",
      previewDateTime: "Date / Time",
      na: "n/a",
      send: "Send report",
      sending: "Sending...",
      retryIn: "You can submit again in {{seconds}}s.",
      sla: "Target response time: 24 business hours.",
      locationLoading: "Loading...",
      locationUnavailable: "Unavailable",
      locationDenied: "Not allowed",
      queueError: "Unable to queue the ticket.",
      submitError: "Unable to send report.",
      categories: {
        account_auth: "Account / Login",
        orders_delivery: "Orders / Delivery",
        payments_billing: "Payments / Billing",
        map_location: "Map / Location",
        ui_bug: "UI bug",
        performance: "Performance",
        other: "Other",
      },
      impacts: {
        blocking: "Blocking",
        degraded: "Degraded",
        minor: "Minor",
        cosmetic: "Cosmetic",
      },
    },
    verifyEmail: {
      verifiedSessionRefreshing: "Email verified. Updating your session...",
      openMailboxToast: "Open your email inbox",
      resendThrottled: "Request sent to {{email}}. Auth0 rate-limits requests, email may be delayed.",
      verificationLinkReady: "Verification link ready for {{email}}. Open it to verify your address.",
      verificationResent: "Verification email resent to {{email}}. Check your spam folder.",
      requestAcceptedNoConfirmation: "Request accepted, but no server confirmation was returned.",
      tooManyRequests: "You already requested an email recently. Try again in a few minutes.",
      sendError: "Error while sending verification email.",
      invalidEmail: "Please enter a valid email address.",
      emailUpdated: "Email updated. A new verification email was sent.",
      emailInUse: "Email already used. Try another address.",
      emailUpdateError: "Unable to update email address.",
      sessionInvalid: "Invalid session. Please sign in again.",
      deleteFailed: "Account deletion failed. Please try again later.",
      alreadyVerified: "Address already verified. You can access your account.",
      title: "Verify your email",
      subtitle: "We sent a confirmation link to",
      sentStep: "Sent",
      openLinkStep: "Open link",
      verifiedStep: "Verified",
      resendNow: "Resend email",
      resendIn: "Resend in {{seconds}}s",
      openingMailbox: "Open mailbox",
      editEmail: "Edit email address",
      logout: "Sign out",
      deleteProfile: "Delete my profile",
      goToSpace: "Go to my space",
      tipsSpam: "Also check your spam folder. The link expires after a limited time.",
      tipsChangeEmail: "You can change your address above: a new link will be sent.",
      helpTitle: "Need help?",
      help1: "Open the link in the same browser.",
      help2: "Avoid private browsing for verification.",
      help3: "If the link expired, resend an email.",
      modalTitle: "Edit email address",
      modalBody: "Once updated, a new verification email will be sent.",
      modalPlaceholder: "new-address@email.com",
      cancel: "Cancel",
      confirm: "Confirm",
      close: "Close",
      deleteConfirm: "This action is irreversible. Note: deletion is blocked while active orders exist.",
      activeOrders_one: "Deletion impossible: {{count}} order is still active",
      activeOrders_other: "Deletion impossible: {{count}} orders are still active",
      activeOrdersGeneric: "Deletion impossible: active orders still exist",
      unknownEmail: "-",
      sending: "Sending...",
    },
    authCallback: {
      loading: "Signing you in...",
      bootstrappingProfile: "Preparing your space...",
      bootstrappingProfileHint: "We are finalizing your session and loading the data needed before redirecting you.",
      errorTitle: "Sign-in failed",
      retry: "Retry sign-in",
      retrying: "Redirecting...",
      backHome: "Back to home",
      errorCode: "Code: {{code}}",
      recovery: {
        wakingBackend: "Waking up the service...",
        wakingBackendHint: "The server is resuming. This can take a few seconds on free hosting tiers.",
        syncingProfile: "Preparing your account...",
        syncingProfileHint: "We are loading your profile before sending you to your space.",
        attempt: "Attempt {{count}}",
      },
      errors: {
        access_denied: "Sign-in was cancelled. Try again to continue.",
        unauthorized: "Sign-in was refused. Check your account and try again.",
        server_error: "Sign-in service is temporarily unavailable. Try again shortly.",
        invalid_state: "The sign-in recovery expired or was interrupted. Start sign-in again.",
        invalid_request: "The sign-in request is invalid. Start sign-in again.",
        login_required: "Sign-in required. We could not find an active Auth0 session to continue.",
        consent_required: "Sign-in required. Additional consent is needed to continue.",
        interaction_required: "Sign-in required. An interactive step is needed to continue.",
        timeout: "Sign-in is taking longer than expected. Retry or go back home.",
        auth_error: "We could not complete sign-in. Try again.",
      },
    },
    sessionExpiredModal: {
      badges: {
        reconnect: "Reconnect",
        backend_wakeup: "Restarting",
      },
      title: "Sign-in required",
      loading: "Trying to restore your session...",
      reconnect: "Sign in again",
      retry: "Try again",
      switchAccount: "Switch account",
      footer: "For your security, sensitive actions stay blocked until you restart an Auth0 session.",
      recovery: {
        title: "Restoring access",
        description: "This usually takes a few seconds. You do not need to do anything.",
        status: "Automatic recovery in progress...",
        action: "Retry now",
      },
      messages: {
        missing_refresh_token: "Your session stayed inactive for too long. We could not renew it automatically.",
        login_required: "Sign-in required. We could not find an active Auth0 session to continue.",
        consent_required: "Sign-in required. Additional consent is needed to continue.",
        interaction_required: "Sign-in required. An interactive step is needed to continue.",
        invalid_grant: "Your session became invalid. Sign in again to continue.",
        session_expired: "Your session expired. Start a secure session again to continue.",
        backend_wakeup: "The service is coming back. It can take a few seconds.",
        default: "We could not renew your access automatically. Sign in again to continue where you left off.",
      },
    },
    legalViewer: {
      notFoundTitle: "Document not found",
      notFoundDescription: "The requested document does not exist. Check the URL.",
      version: "Version {{version}}",
      fileMissing: "Unable to reach the PDF file. Verify it exists in public{{path}}.",
      inlinePreviewUnsupported: "Inline preview is not fully supported on this device. You can open the document:",
      openPdf: "Open PDF",
      downloadPdf: "Download",
      pdfTitle: "PDF {{title}}",
      previewError: "Preview unavailable. Use the Open PDF button.",
      openPdfNewTab: "Open PDF in a new tab",
      firstNameLabel: "First name",
      firstNamePlaceholder: "Enter your first name",
      lastNameLabel: "Last name",
      lastNamePlaceholder: "Enter your last name",
      identityRequired: "First name and last name are required to accept these terms.",
      acceptLabel: "I have read and accept {{title}} (version {{version}}).",
      acceptSaving: "Saving...",
      acceptCta: "I accept",
      acceptError: "Unable to save acceptance. Please try again shortly.",
    },
    vitrine: {
      productDetails: "Product details",
      noDescription: "No description provided.",
      basePrice: "Base price",
      preparedFast: "Quickly prepared",
      currentPrice: "Current price",
      optionsIncluded: "Options included (+{{amount}})",
      required: "required",
      maxSelections: "Max {{count}} selection(s)",
      selectionsCount: "{{count}} selection(s)",
      orderTotal: "Order total",
      addToCart: "Add to cart",
      loadingError: "Error while loading storefront data.",
      networkTitle: "Connection unavailable",
      networkDescription: "Check your network then reload the storefront.",
      notFoundTitle: "Store not found",
      notFoundDescription: "This storefront may no longer be available.",
      unavailableTitle: "Service temporarily unavailable",
      unavailableDescription: "The service is currently slow. Try again in a few seconds.",
      genericTitle: "Unable to display this storefront",
      genericDescription: "An error happened while loading. You can retry now.",
      reloading: "Reloading...",
      retry: "Retry",
      backHome: "Back to home",
      searchProduct: "Search product",
      searchPlaceholder: "Search product...",
      allCollections: "All",
      filtersTitle: "Product filters",
      collectionsTitle: "Collections",
      viewModeTitle: "View mode",
      viewModeGrid: "Grid",
      viewModeList: "List",
      resetFilters: "Reset filters",
      viewDetails: "View details",
      addedToCart: "{{name}} added to cart",
      seller: "Seller",
      delay_day_one: "{{count}} day",
      delay_day_other: "{{count}} days",
      delay_hour_one: "{{count}}h",
      delay_hour_other: "{{count}}h",
      delay_minute_one: "{{count}} min",
      delay_minute_other: "{{count}} min",
      quantityTimesUnit: "{{qty}} x {{unitPrice}}",
    },
  },
  "es-ES": {
    bottomNav: {
      client: { home: "Inicio", cart: "Carrito", tracking: "Seguimiento", profile: "Perfil" },
      vendor: { dashboard: "Panel", inventory: "Inventario", orders: "Pedidos", profile: "Perfil" },
      courier: { dashboard: "Panel", runs: "Repartos", route: "Ruta", profile: "Perfil" },
      admin: { dashboard: "Panel", manage: "Gestion", notifications: "Alertas", profile: "Perfil" },
      ambassador: { dashboard: "Panel", network: "Red", accounts: "Agregar", profile: "Perfil" },
    },
    desktopShell: {
      brand: "Riveltime",
      tagline: "Centro operativo",
      nav: {
        ariaLabel: "Navegacion principal de escritorio",
        title: "Navegacion",
      },
      platform: {
        tablet: "Tableta",
        desktop: "Ordenador",
      },
      role: {
        label: "Rol",
        client: "Cliente",
        vendor: "Vendedor",
        courier: "Repartidor",
        admin: "Admin",
        guest: "Invitado",
      },
      connection: {
        label: "Red",
      },
      actions: {
        home: "Volver al inicio",
      },
      alt: {
        logo: "Logo de Riveltime",
      },
    },
    common: {
      delete: "Eliminar",
    },
    supportIssue: {
      title: "Reportar un problema",
      subtitle: "Respuesta objetivo en 24 horas habiles. Los detalles tecnicos son opcionales.",
      queuedTitle: "Reporte en cola",
      sentTitle: "Reporte enviado",
      queuedBody: "Ticket guardado sin conexion. Se sincronizara cuando vuelva la red.",
      sentBody: "Gracias. Tu ticket fue enviado a soporte.",
      dateLabel: "Fecha",
      localId: "ID local",
      ticketId: "ID ticket",
      close: "Cerrar",
      introTitle: "Explica rapidamente el problema",
      introBody: "Describe la accion, lo esperado y lo que paso.",
      category: "Categoria",
      impact: "Impacto",
      description: "Descripcion",
      descriptionPlaceholder: "Ejemplo: intente pagar desde la vitrina y la pagina se quedo bloqueada sin confirmar el pago.",
      descriptionCounter: "{{count}}/{{min}} minimo",
      technicalTitle: "Informacion tecnica (opcional)",
      technicalContextLabel: "Adjuntar contexto tecnico (ruta, dispositivo, version, red).",
      screenshotLabel: "Adjuntar captura (proximamente, desactivado).",
      sensitiveWarning: "No incluyas datos sensibles (contrasena, token, datos de pago).",
      previewTitle: "Vista previa de informacion tecnica",
      previewRole: "Rol",
      previewLocation: "Ubicacion",
      previewDevice: "Dispositivo",
      previewEmail: "Correo",
      previewPhone: "Telefono",
      previewDateTime: "Fecha / Hora",
      na: "n/a",
      send: "Enviar reporte",
      sending: "Enviando...",
      retryIn: "Nuevo envio disponible en {{seconds}}s.",
      sla: "Tiempo de respuesta objetivo: 24 horas habiles.",
      locationLoading: "Cargando...",
      locationUnavailable: "No disponible",
      locationDenied: "No autorizado",
      queueError: "No se pudo poner el ticket en cola.",
      submitError: "No se pudo enviar el reporte.",
      categories: {
        account_auth: "Cuenta / Acceso",
        orders_delivery: "Pedidos / Entrega",
        payments_billing: "Pagos / Facturacion",
        map_location: "Mapa / Ubicacion",
        ui_bug: "Error de interfaz",
        performance: "Rendimiento",
        other: "Otro",
      },
      impacts: {
        blocking: "Bloqueante",
        degraded: "Degradado",
        minor: "Menor",
        cosmetic: "Cosmetico",
      },
    },
    verifyEmail: {
      verifiedSessionRefreshing: "Correo verificado. Actualizando sesion...",
      openMailboxToast: "Abre tu correo habitual",
      resendThrottled: "Solicitud enviada a {{email}}. Auth0 limita la frecuencia y puede tardar.",
      verificationLinkReady: "Enlace de verificacion listo para {{email}}. Abrelo para verificar tu cuenta.",
      verificationResent: "Correo de verificacion reenviado a {{email}}. Revisa spam.",
      requestAcceptedNoConfirmation: "Solicitud aceptada, pero sin confirmacion del servidor.",
      tooManyRequests: "Ya pediste un correo hace poco. Intentalo en unos minutos.",
      sendError: "Error al enviar el correo de verificacion.",
      invalidEmail: "Introduce un correo valido.",
      emailUpdated: "Correo actualizado. Se envio un nuevo correo de verificacion.",
      emailInUse: "Correo ya en uso. Prueba otra direccion.",
      emailUpdateError: "No se pudo actualizar el correo.",
      sessionInvalid: "Sesion invalida. Vuelve a iniciar sesion.",
      deleteFailed: "La eliminacion fallo. Intentalo mas tarde.",
      alreadyVerified: "Direccion ya verificada. Puedes acceder a tu espacio.",
      title: "Verifica tu correo",
      subtitle: "Hemos enviado un enlace de confirmacion a",
      sentStep: "Enviado",
      openLinkStep: "Abrir enlace",
      verifiedStep: "Verificado",
      resendNow: "Reenviar correo",
      resendIn: "Reenviar en {{seconds}}s",
      openingMailbox: "Abrir mi correo",
      editEmail: "Editar correo",
      logout: "Cerrar sesion",
      deleteProfile: "Eliminar mi perfil",
      goToSpace: "Ir a mi espacio",
      tipsSpam: "Revisa tambien la carpeta de spam. El enlace caduca tras un tiempo.",
      tipsChangeEmail: "Puedes cambiar la direccion arriba y recibiras un nuevo enlace.",
      helpTitle: "Necesitas ayuda?",
      help1: "Abre el enlace en el mismo navegador.",
      help2: "Evita modo privado para la verificacion.",
      help3: "Si el enlace caduco, reenviate un correo.",
      modalTitle: "Editar correo",
      modalBody: "Despues del cambio, se enviara un nuevo enlace de verificacion.",
      modalPlaceholder: "nueva-direccion@email.com",
      cancel: "Cancelar",
      confirm: "Confirmar",
      close: "Cerrar",
      deleteConfirm: "Esta accion es irreversible. Nota: si hay pedidos activos, la eliminacion se bloquea.",
      activeOrders_one: "Eliminacion imposible: {{count}} pedido sigue activo",
      activeOrders_other: "Eliminacion imposible: {{count}} pedidos siguen activos",
      activeOrdersGeneric: "Eliminacion imposible: hay pedidos activos",
      unknownEmail: "-",
      sending: "Enviando...",
    },
    authCallback: {
      loading: "Iniciando sesion...",
      bootstrappingProfile: "Preparando tu espacio...",
      bootstrappingProfileHint: "Estamos finalizando tu sesion y cargando los datos necesarios antes de redirigirte.",
      errorTitle: "Error de inicio de sesion",
      retry: "Reintentar inicio de sesion",
      retrying: "Redirigiendo...",
      backHome: "Volver al inicio",
      errorCode: "Codigo: {{code}}",
      recovery: {
        wakingBackend: "Activando el servicio...",
        wakingBackendHint: "El servidor se esta reanudando. Esto puede tardar unos segundos en los planes gratuitos.",
        syncingProfile: "Preparando tu cuenta...",
        syncingProfileHint: "Estamos cargando tu perfil antes de enviarte a tu espacio.",
        attempt: "Intento {{count}}",
      },
      errors: {
        access_denied: "Se cancelo el inicio de sesion. Intentalo de nuevo para continuar.",
        unauthorized: "Inicio de sesion rechazado. Verifica tu cuenta y vuelve a intentarlo.",
        server_error: "El servicio de acceso no esta disponible temporalmente. Intentalo en unos instantes.",
        invalid_state: "La reanudacion del inicio de sesion expiro o se interrumpio. Inicia sesion de nuevo.",
        invalid_request: "La solicitud de inicio de sesion no es valida. Inicia sesion de nuevo.",
        login_required: "Se requiere iniciar sesion. No encontramos una sesion Auth0 activa para continuar.",
        consent_required: "Se requiere iniciar sesion. Hace falta un consentimiento adicional para continuar.",
        interaction_required: "Se requiere iniciar sesion. Hace falta un paso interactivo para continuar.",
        timeout: "El inicio de sesion tarda mas de lo previsto. Reintenta o vuelve al inicio.",
        auth_error: "No se pudo completar el inicio de sesion. Intentalo de nuevo.",
      },
    },
    sessionExpiredModal: {
      badge: "Sesion expirada",
      badges: {
        reconnect: "Reconectar",
        backend_wakeup: "Reanudando",
      },
      title: "Reconexion necesaria",
      loading: "Intentando recuperar tu sesion...",
      reconnect: "Volver a iniciar sesion",
      retry: "Reintentar",
      switchAccount: "Cambiar de cuenta",
      footer: "Por seguridad, las acciones sensibles quedan bloqueadas hasta que reinicies una sesion Auth0.",
      recovery: {
        title: "Restableciendo el acceso",
        description: "Suele tardar unos segundos. No tienes que hacer nada.",
        status: "Recuperacion automatica en curso...",
        action: "Reintentar ahora",
      },
      messages: {
        missing_refresh_token: "Tu sesion estuvo inactiva demasiado tiempo. No pudimos renovarla automaticamente.",
        login_required: "Se requiere iniciar sesion. No encontramos una sesion Auth0 activa para continuar.",
        consent_required: "Se requiere iniciar sesion. Hace falta una autorizacion adicional para continuar.",
        interaction_required: "Se requiere iniciar sesion. Hace falta una etapa interactiva para continuar.",
        invalid_grant: "Tu sesion se invalido. Vuelve a iniciar sesion para continuar.",
        session_expired: "Tu sesion ha expirado. Inicia una sesion segura de nuevo para continuar.",
        backend_wakeup: "El servicio se esta reanudando. Puede tardar unos segundos.",
        default: "No pudimos renovar tu acceso automaticamente. Vuelve a iniciar sesion para seguir donde lo dejaste.",
      },
    },
    legalViewer: {
      notFoundTitle: "Documento no encontrado",
      notFoundDescription: "El documento solicitado no existe. Revisa la URL.",
      version: "Version {{version}}",
      fileMissing: "No se puede acceder al PDF. Verifica que existe en public{{path}}.",
      inlinePreviewUnsupported: "La vista integrada no esta totalmente soportada en este dispositivo. Puedes abrir el documento:",
      openPdf: "Abrir PDF",
      downloadPdf: "Descargar",
      pdfTitle: "PDF {{title}}",
      previewError: "Vista previa no disponible. Usa el boton Abrir PDF.",
      openPdfNewTab: "Abrir PDF en una nueva pestana",
      firstNameLabel: "Nombre",
      firstNamePlaceholder: "Introduce tu nombre",
      lastNameLabel: "Apellido",
      lastNamePlaceholder: "Introduce tu apellido",
      identityRequired: "El nombre y el apellido son obligatorios para aceptar estos terminos.",
      acceptLabel: "He leido y acepto {{title}} (version {{version}}).",
      acceptSaving: "Guardando...",
      acceptCta: "Acepto",
      acceptError: "No se pudo guardar la aceptacion. Intentalo de nuevo en un momento.",
    },
    vitrine: {
      productDetails: "Detalles del producto",
      noDescription: "No hay descripcion.",
      basePrice: "Precio base",
      preparedFast: "Preparado rapido",
      currentPrice: "Precio actual",
      optionsIncluded: "Opciones incluidas (+{{amount}})",
      required: "obligatorio",
      maxSelections: "Maximo {{count}} seleccion(es)",
      selectionsCount: "{{count}} seleccion(es)",
      orderTotal: "Total del pedido",
      addToCart: "Anadir al carrito",
      loadingError: "Error al cargar la tienda.",
      networkTitle: "Conexion no disponible",
      networkDescription: "Revisa tu red y vuelve a cargar la vitrina.",
      notFoundTitle: "Tienda no encontrada",
      notFoundDescription: "Esta vitrina puede no estar disponible ahora.",
      unavailableTitle: "Servicio temporalmente no disponible",
      unavailableDescription: "El servicio esta lento. Intentalo de nuevo en unos segundos.",
      genericTitle: "No se puede mostrar esta vitrina",
      genericDescription: "Hubo un error al cargar. Puedes reintentar ahora.",
      reloading: "Recargando...",
      retry: "Reintentar",
      backHome: "Volver al inicio",
      searchProduct: "Buscar producto",
      searchPlaceholder: "Buscar producto...",
      allCollections: "Todos",
      filtersTitle: "Filtros de productos",
      collectionsTitle: "Colecciones",
      viewModeTitle: "Vista",
      viewModeGrid: "Cuadricula",
      viewModeList: "Lista",
      resetFilters: "Restablecer",
      viewDetails: "Ver detalle",
      addedToCart: "{{name}} anadido al carrito",
      seller: "Vendedor",
      delay_day_one: "{{count}} dia",
      delay_day_other: "{{count}} dias",
      delay_hour_one: "{{count}}h",
      delay_hour_other: "{{count}}h",
      delay_minute_one: "{{count}} min",
      delay_minute_other: "{{count}} min",
      quantityTimesUnit: "{{qty}} x {{unitPrice}}",
    },
  },
  ar: {
    bottomNav: {
      client: { home: "الرئيسية", cart: "السلة", tracking: "المتابعة", profile: "الملف" },
      vendor: { dashboard: "لوحة التحكم", inventory: "المخزون", orders: "الطلبات", profile: "الملف" },
      courier: { dashboard: "لوحة التحكم", runs: "المهام", route: "المسار", profile: "الملف" },
      admin: { dashboard: "لوحة التحكم", manage: "الادارة", notifications: "الاشعارات", profile: "الملف" },
      ambassador: { dashboard: "لوحة التحكم", network: "الشبكة", accounts: "إضافة", profile: "الملف" },
    },
    desktopShell: {
      brand: "ريڤل تايم",
      tagline: "لوحة عمليات",
      nav: {
        ariaLabel: "التنقل الرئيسي لسطح المكتب",
        title: "التنقل",
      },
      platform: {
        tablet: "جهاز لوحي",
        desktop: "سطح مكتب",
      },
      role: {
        label: "الدور",
        client: "عميل",
        vendor: "بائع",
        courier: "سائق توصيل",
        admin: "مشرف",
        guest: "زائر",
      },
      connection: {
        label: "الشبكة",
      },
      actions: {
        home: "العودة الى الرئيسية",
      },
      alt: {
        logo: "شعار ريفل تايم",
      },
    },
    common: {
      delete: "حذف",
    },
    supportIssue: {
      title: "ابلاغ عن مشكلة",
      subtitle: "الرد المتوقع خلال 24 ساعة عمل. المعلومات التقنية اختيارية.",
      queuedTitle: "تم وضع البلاغ في الانتظار",
      sentTitle: "تم ارسال البلاغ",
      queuedBody: "تم حفظ التذكرة بدون اتصال. ستتم المزامنة عند عودة الشبكة.",
      sentBody: "شكرا. تم ارسال تذكرتك الى الدعم.",
      dateLabel: "التاريخ",
      localId: "معرف محلي",
      ticketId: "معرف التذكرة",
      close: "اغلاق",
      introTitle: "اشرح المشكلة بسرعة",
      introBody: "صف الخطوة المتوقعة وما حدث فعليا.",
      category: "الفئة",
      impact: "التأثير",
      description: "الوصف",
      descriptionPlaceholder: "مثال: حاولت الدفع من واجهة المتجر لكن الصفحة بقيت معلقة بدون تأكيد.",
      descriptionCounter: "{{count}}/{{min}} كحد ادنى",
      technicalTitle: "معلومات تقنية (اختياري)",
      technicalContextLabel: "ارفاق السياق التقني (المسار، الجهاز، الاصدار، الشبكة).",
      screenshotLabel: "ارفاق لقطة شاشة (قريبا، غير مفعلة حاليا).",
      sensitiveWarning: "لا تضف بيانات حساسة (كلمة مرور، رمز، بيانات دفع).",
      previewTitle: "معاينة المعلومات التقنية المرفقة",
      previewRole: "الدور",
      previewLocation: "الموقع",
      previewDevice: "الجهاز",
      previewEmail: "البريد",
      previewPhone: "الهاتف",
      previewDateTime: "التاريخ / الوقت",
      na: "غير متاح",
      send: "ارسال البلاغ",
      sending: "جار الارسال...",
      retryIn: "يمكنك الارسال مجددا خلال {{seconds}} ثانية.",
      sla: "الرد المتوقع: 24 ساعة عمل.",
      locationLoading: "جار التحميل...",
      locationUnavailable: "غير متاح",
      locationDenied: "غير مسموح",
      queueError: "تعذر وضع التذكرة في الانتظار.",
      submitError: "تعذر ارسال البلاغ.",
      categories: {
        account_auth: "الحساب / تسجيل الدخول",
        orders_delivery: "الطلبات / التوصيل",
        payments_billing: "الدفع / الفواتير",
        map_location: "الخريطة / الموقع",
        ui_bug: "خطأ في الواجهة",
        performance: "الاداء",
        other: "اخرى",
      },
      impacts: {
        blocking: "مانع",
        degraded: "متدهور",
        minor: "بسيط",
        cosmetic: "شكلي",
      },
    },
    verifyEmail: {
      verifiedSessionRefreshing: "تم التحقق من البريد. جار تحديث الجلسة...",
      openMailboxToast: "افتح بريدك الالكتروني",
      resendThrottled: "تم ارسال الطلب الى {{email}}. قد يتاخر البريد بسبب حدود Auth0.",
      verificationLinkReady: "رابط التحقق جاهز لـ {{email}}. افتحه لتاكيد البريد.",
      verificationResent: "تم اعادة ارسال بريد التحقق الى {{email}}. راجع الرسائل غير المرغوبة.",
      requestAcceptedNoConfirmation: "تم قبول الطلب لكن بدون تاكيد من الخادم.",
      tooManyRequests: "لقد طلبت بريدا مؤخرا. حاول بعد بضع دقائق.",
      sendError: "حدث خطا اثناء ارسال بريد التحقق.",
      invalidEmail: "ادخل بريدا صحيحا.",
      emailUpdated: "تم تحديث البريد وارسال رابط تحقق جديد.",
      emailInUse: "البريد مستخدم بالفعل. جرب بريدا اخر.",
      emailUpdateError: "تعذر تحديث البريد.",
      sessionInvalid: "الجلسة غير صالحة. سجل الدخول مجددا.",
      deleteFailed: "فشل حذف الحساب. حاول لاحقا.",
      alreadyVerified: "العنوان متحقق منه بالفعل. يمكنك الدخول الى حسابك.",
      title: "تحقق من بريدك",
      subtitle: "ارسالنا رابط تاكيد الى",
      sentStep: "تم الارسال",
      openLinkStep: "افتح الرابط",
      verifiedStep: "تم التحقق",
      resendNow: "اعادة ارسال البريد",
      resendIn: "اعادة الارسال خلال {{seconds}} ث",
      openingMailbox: "فتح البريد",
      editEmail: "تعديل البريد",
      logout: "تسجيل الخروج",
      deleteProfile: "حذف الحساب",
      goToSpace: "الانتقال الى حسابي",
      tipsSpam: "تحقق ايضا من مجلد الرسائل غير المرغوبة. الرابط ينتهي بعد مدة محدودة.",
      tipsChangeEmail: "يمكنك تغيير العنوان اعلاه وسيصلك رابط جديد.",
      helpTitle: "هل تحتاج مساعدة؟",
      help1: "افتح الرابط في نفس المتصفح.",
      help2: "تجنب التصفح الخاص عند التحقق.",
      help3: "اذا انتهت صلاحية الرابط، اعد الارسال.",
      modalTitle: "تعديل البريد",
      modalBody: "بعد التعديل سيتم ارسال رابط تحقق جديد.",
      modalPlaceholder: "new-address@email.com",
      cancel: "الغاء",
      confirm: "تاكيد",
      close: "اغلاق",
      deleteConfirm: "هذا الاجراء لا يمكن التراجع عنه. اذا كانت هناك طلبات نشطة سيتم منع الحذف.",
      activeOrders_one: "لا يمكن الحذف: هناك طلب نشط واحد",
      activeOrders_other: "لا يمكن الحذف: هناك {{count}} طلبات نشطة",
      activeOrdersGeneric: "لا يمكن الحذف: توجد طلبات نشطة",
      unknownEmail: "-",
      sending: "جار الارسال...",
    },
    authCallback: {
      loading: "جار تسجيل الدخول...",
      bootstrappingProfile: "جار تجهيز مساحتك...",
      bootstrappingProfileHint: "نقوم بانهاء جلستك وتحميل البيانات اللازمة قبل اعادة التوجيه.",
      errorTitle: "فشل تسجيل الدخول",
      retry: "اعادة المحاولة",
      retrying: "جار التحويل...",
      backHome: "العودة الى البداية",
      errorCode: "الرمز: {{code}}",
      recovery: {
        wakingBackend: "جار ايقاظ الخدمة...",
        wakingBackendHint: "الخادم يستعيد جاهزيته. قد يستغرق ذلك بضع ثوان على الخطط المجانية.",
        syncingProfile: "جار تجهيز حسابك...",
        syncingProfileHint: "نقوم بتحميل ملفك الشخصي قبل نقلك الى مساحتك.",
        attempt: "المحاولة {{count}}",
      },
      errors: {
        access_denied: "تم الغاء تسجيل الدخول. حاول من جديد للمتابعة.",
        unauthorized: "تم رفض تسجيل الدخول. تحقق من حسابك ثم حاول من جديد.",
        server_error: "خدمة تسجيل الدخول غير متاحة مؤقتا. حاول بعد قليل.",
        invalid_state: "انتهت صلاحية استعادة تسجيل الدخول او تمت مقاطعتها. اعد تسجيل الدخول.",
        invalid_request: "طلب تسجيل الدخول غير صالح. اعد تسجيل الدخول.",
        login_required: "يلزم تسجيل الدخول. لم نعثر على جلسة Auth0 نشطة للمتابعة.",
        consent_required: "يلزم تسجيل الدخول. هناك موافقة اضافية مطلوبة للمتابعة.",
        interaction_required: "يلزم تسجيل الدخول. هناك خطوة تفاعلية مطلوبة للمتابعة.",
        timeout: "يستغرق تسجيل الدخول وقتا اطول من المتوقع. اعد المحاولة او عد الى البداية.",
        auth_error: "تعذر اكمال تسجيل الدخول. حاول من جديد.",
      },
    },
    sessionExpiredModal: {
      badge: "انتهت الجلسة",
      badges: {
        reconnect: "اعادة الاتصال",
        backend_wakeup: "استئناف جار",
      },
      title: "يلزم تسجيل الدخول من جديد",
      loading: "جار محاولة استعادة الجلسة...",
      reconnect: "تسجيل الدخول من جديد",
      retry: "اعادة المحاولة",
      switchAccount: "تبديل الحساب",
      footer: "لحمايتك تبقى الاجراءات الحساسة متوقفة حتى تعيد تشغيل جلسة Auth0.",
      recovery: {
        title: "نستعيد الوصول",
        description: "يستغرق هذا عادة بضع ثوان. لا تحتاج الى فعل شيء.",
        status: "الاستعادة التلقائية جارية...",
        action: "اعادة المحاولة الان",
      },
      messages: {
        missing_refresh_token: "ظلت جلستك غير نشطة لوقت طويل. تعذر تجديدها تلقائيا.",
        login_required: "يلزم تسجيل الدخول. لم نعثر على جلسة Auth0 نشطة للمتابعة.",
        consent_required: "يلزم تسجيل الدخول. توجد موافقة اضافية مطلوبة للمتابعة.",
        interaction_required: "يلزم تسجيل الدخول. توجد خطوة تفاعلية مطلوبة للمتابعة.",
        invalid_grant: "اصبحت جلستك غير صالحة. سجل الدخول من جديد للمتابعة.",
        session_expired: "انتهت جلستك. ابدأ جلسة آمنة من جديد للمتابعة.",
        backend_wakeup: "الخدمة تستعيد نشاطها. قد يستغرق ذلك بضع ثوان.",
        default: "تعذر تجديد الوصول تلقائيا. سجل الدخول من جديد للمتابعة من حيث توقفت.",
      },
    },
    legalViewer: {
      notFoundTitle: "المستند غير موجود",
      notFoundDescription: "المستند المطلوب غير موجود. تحقق من الرابط.",
      version: "الاصدار {{version}}",
      fileMissing: "تعذر الوصول الى ملف PDF. تاكد من وجوده في public{{path}}.",
      inlinePreviewUnsupported: "المعاينة المدمجة غير مدعومة بالكامل على هذا الجهاز. يمكنك فتح المستند:",
      openPdf: "فتح PDF",
      downloadPdf: "تنزيل",
      pdfTitle: "PDF {{title}}",
      previewError: "تعذر عرض المعاينة. استخدم زر فتح PDF.",
      openPdfNewTab: "فتح PDF في تبويب جديد",
      firstNameLabel: "الاسم",
      firstNamePlaceholder: "ادخل الاسم",
      lastNameLabel: "النسب",
      lastNamePlaceholder: "ادخل النسب",
      identityRequired: "الاسم والنسب مطلوبان لقبول هذه الشروط.",
      acceptLabel: "لقد قرات ووافقت على {{title}} (الاصدار {{version}}).",
      acceptSaving: "جار الحفظ...",
      acceptCta: "اوافق",
      acceptError: "تعذر حفظ القبول. حاول مرة اخرى بعد لحظات.",
    },
    vitrine: {
      productDetails: "تفاصيل المنتج",
      noDescription: "لا يوجد وصف.",
      basePrice: "السعر الاساسي",
      preparedFast: "تحضير سريع",
      currentPrice: "السعر الحالي",
      optionsIncluded: "يشمل الاضافات (+{{amount}})",
      required: "الزامي",
      maxSelections: "الحد الاقصى {{count}} اختيار",
      selectionsCount: "{{count}} اختيار",
      orderTotal: "اجمالي الطلب",
      addToCart: "اضف الى السلة",
      loadingError: "خطا اثناء تحميل بيانات المتجر.",
      networkTitle: "الاتصال غير متاح",
      networkDescription: "تحقق من الشبكة ثم اعد تحميل المتجر.",
      notFoundTitle: "المتجر غير موجود",
      notFoundDescription: "قد لا تكون هذه الواجهة متاحة حاليا.",
      unavailableTitle: "الخدمة غير متاحة مؤقتا",
      unavailableDescription: "الخدمة بطيئة حاليا. حاول مجددا بعد ثوان.",
      genericTitle: "تعذر عرض هذه الواجهة",
      genericDescription: "حدث خطا اثناء التحميل. يمكنك المحاولة مجددا.",
      reloading: "جار اعادة التحميل...",
      retry: "اعادة المحاولة",
      backHome: "العودة للرئيسية",
      searchProduct: "ابحث عن منتج",
      searchPlaceholder: "ابحث عن منتج...",
      allCollections: "الكل",
      filtersTitle: "فلاتر المنتجات",
      collectionsTitle: "المجموعات",
      viewModeTitle: "طريقة العرض",
      viewModeGrid: "شبكة",
      viewModeList: "قائمة",
      resetFilters: "اعادة الضبط",
      viewDetails: "عرض التفاصيل",
      addedToCart: "تمت اضافة {{name}} الى السلة",
      seller: "البائع",
      delay_day_one: "{{count}} يوم",
      delay_day_other: "{{count}} ايام",
      delay_hour_one: "{{count}} س",
      delay_hour_other: "{{count}} س",
      delay_minute_one: "{{count}} د",
      delay_minute_other: "{{count}} د",
      quantityTimesUnit: "{{qty}} x {{unitPrice}}",
    },
  },
};

const EXTRA_MESSAGES = {
  "fr-FR": {
    notificationBanner: {
      close: "Fermer",
      updateAvailable: "Nouvelle version disponible. Cliquez pour mettre a jour l'application.",
    },
    header: {
      sections: {
        vendor: {
          dashboard: "Dashboard",
          inventory: "Inventaire",
          orders: "Commandes",
          profile: "Profil",
          messages: "Messages",
        },
        courier: {
          dashboard: "Dashboard",
          runs: "Courses",
          route: "Tournee",
          profile: "Profil",
          messages: "Messages",
        },
        ambassador: {
          dashboard: "Dashboard",
          network: "Reseaux",
          accounts: "Ajouter",
          profile: "Profil",
        },
      },
      labels: {
        deliverTo: "Livrer a",
      },
      connection: {
        connected: "Connecte",
        reconnecting: "Reconnexion...",
        offline: "Hors ligne",
      },
      gps: {
        ok: "GPS OK",
        disabledActivate: "GPS desactive - Activer",
        unavailableRetry: "GPS indisponible - Reessayer",
        locating: "Localisation...",
        retryTitle: "Reessayer la localisation",
        activateTitle: "Activer la localisation",
      },
      boutiques: {
        loading: "Boutiques...",
        count_one: "{{count}} boutique",
        count_other: "{{count}} boutiques",
      },
      address: {
        chooseTitle: "Choisir une adresse de livraison",
        choose: "Choisir une adresse",
        currentSelected: "Adresse actuelle selectionnee : {{label}}",
        undetermined: "non determinee",
      },
      syncBanner: {
        pending_one: "Synchronisation en attente ({{count}} action).",
        pending_other: "Synchronisation en attente ({{count}} actions).",
        syncing: "Synchronisation en cours.",
        retryNeeded_one: "Une action n'a pas pu etre synchronisee.",
        retryNeeded_other: "{{count}} actions n'ont pas pu etre synchronisees.",
        blockedActions_one: "Une action requiert votre attention.",
        blockedActions_other: "{{count}} actions requierent votre attention.",
        viewDetails: "Voir les details",
        retryNow: "Reessayer",
      },
    },
    offlineQueue: {
      title: "Synchronisation",
      description: "Vos changements sont enregistres. Ils seront envoyes automatiquement.",
      summary: {
        title: "Etat actuel",
        upToDate: "Tout est a jour.",
        sending: "Envoi en cours...",
        pending_one: "{{count}} mise a jour en attente d'envoi.",
        pending_other: "{{count}} mises a jour en attente d'envoi.",
        attention_one: "{{count}} mise a jour requiert votre attention.",
        attention_other: "{{count}} mises a jour requierent votre attention.",
      },
      badges: {
        upToDate: "A jour",
        sending: "Envoi en cours",
        pending_one: "{{count}} en attente",
        pending_other: "{{count}} en attente",
        attention_one: "{{count}} a verifier",
        attention_other: "{{count}} a verifier",
      },
      status: {
        pending: "En attente d'envoi",
        sending: "Envoi en cours",
        attention: "Necessite votre attention",
      },
      createdAt: "Enregistre le {{date}}",
      empty: "Aucune mise a jour en attente.",
      error: {
        generic: "Cette mise a jour n'a pas pu etre envoyee pour le moment.",
      },
      cta: {
        sending: "Envoi en cours...",
        retryNow: "Reessayer maintenant",
        retry: "Reessayer",
        removeUpdate: "Supprimer cette mise a jour",
        removeFromList: "Retirer de la liste",
      },
      actions: {
        preparing: "Commande: preparation",
        markOnTheWay: "Commande: en livraison",
        delay: "Commande: ajustement du delai",
        cancel: "Commande: annulation",
        markDelivered: "Commande: validation de livraison",
        supportTicket: "Support: nouveau signalement",
        updateProfile: "Profil: mise a jour",
        generic: "Mise a jour",
      },
      technical: {
        toggle: "Details techniques",
        itemToggle: "Details techniques de cette mise a jour",
        pendingCount_one: "En attente: {{count}}",
        pendingCount_other: "En attente: {{count}}",
        failedCount_one: "En echec temporaire: {{count}}",
        failedCount_other: "En echec temporaire: {{count}}",
        blockedCount_one: "Bloquee: {{count}}",
        blockedCount_other: "Bloquees: {{count}}",
        successRate: "Taux de reussite: {{value}}%",
        attempts: "Tentatives: {{attempts}}/{{maxAttempts}}",
        priority: "Priorite: {{value}}",
        aggregateId: "Reference: {{value}}",
        lastError: "Erreur technique: {{value}}",
        stripeNotice: "Paiements Stripe: envoi en ligne requis.",
      },
      na: "n/a",
    },
    magicImport: {
      entry: {
        title: "Gagner du temps sur votre catalogue",
        subtitle: "Importez une photo, un PDF ou un CSV puis validez le brouillon.",
        cta: "Importer une boutique",
      },
      title: "Generer ma boutique",
      subtitle: "Assistant de creation rapide avec verification avant publication.",
      currentStep: "Etape: {{step}}",
      steps: {
        source: "Choix de la source",
        upload: "Import du fichier",
        processing: "Analyse",
        review: "Relecture",
        publish: "Publication",
      },
      source: {
        description: "Choisissez votre source de donnees.",
        photo: {
          label: "Photo",
          hint: "Menu, carte ou ticket en image",
        },
        pdf: {
          label: "PDF",
          hint: "Catalogue ou menu en PDF",
        },
        csv: {
          label: "CSV",
          hint: "Export tableur ou caisse",
        },
      },
      upload: {
        description: "Importez un fichier, puis lancez l'analyse automatique.",
        selectedSource: "Source selectionnee: {{source}}",
        fileAria: "Selection du fichier a analyser",
        noFile: "Aucun fichier ajoute pour le moment.",
        fileMeta: "Taille approx. {{size}} Ko",
        previewAlt: "Apercu du document importe",
      },
      processing: {
        description: "Nous preparons un brouillon de produits. Vous validerez avant publication.",
        progressLabel: "Progression: {{value}}%",
        currentStage: "Sous-etape: {{stage}}",
        etaSec: "Temps estime restant: {{value}} s",
        stages: {
          upload: "Preparation du fichier",
          ocr: "Lecture OCR",
          structuring: "Structuration IA",
          reviewPrep: "Verification finale",
          review: "Relecture prete",
        },
      },
      review: {
        itemsCount_one: "{{count}} produit a verifier",
        itemsCount_other: "{{count}} produits a verifier",
        blockingCount: "{{count}} point(s) a corriger avant validation",
        noBlockingIssues: "Aucun blocage detecte. Vous pouvez valider.",
        requiredMissingTitle: "Informations obligatoires manquantes",
        blockingRow: "Correction requise",
        needsReview: "A verifier",
        boutique: {
          title: "Boutique a creer",
          subtitle: "Verifiez les informations de la boutique avant publication.",
          fields: {
            name: "Nom de la boutique",
            category: "Categorie boutique",
            address: "Adresse boutique",
            longitude: "Longitude",
            latitude: "Latitude",
          },
          locationReady: "Position: lon {{lon}}, lat {{lat}}",
          locationMissing: "Position manquante: completez l'adresse vendeur pour continuer.",
        },
        required: {
          missing_name: "Nom requis.",
          missing_category: "Categorie requise.",
          invalid_category: "Categorie boutique invalide.",
          missing_address: "Adresse boutique requise.",
          missing_location: "Position boutique requise.",
          invalid_price: "Prix produit invalide.",
          missing_collection_name: "Categorie/collection produit requise.",
          invalid_currency: "Devise non supportee (EUR ou MAD).",
          price_unparsed: "Prix non interprete automatiquement.",
        },
        fields: {
          name: "Nom",
          price: "Prix",
          category: "Collection produit",
          description: "Description",
        },
        options: {
          title: "Options suggerees",
          single: "Choix unique",
          multiple: "Choix multiple",
          required: "Obligatoire",
          optional: "Optionnel",
          maxSelections: "Max {{count}} selection(s)",
        },
      },
      publish: {
        readyTitle: "Pret a publier",
        readyDescription_one: "Le brouillon contient {{count}} produit. Vous pouvez publier.",
        readyDescription_other: "Le brouillon contient {{count}} produits. Vous pouvez publier.",
        successTitle: "Brouillon publie",
        successDescription_one: "{{count}} produit est pret dans votre catalogue.",
        successDescription_other: "{{count}} produits sont prets dans votre catalogue.",
        publishedAt: "Publie a {{value}}",
      },
      actions: {
        close: "Fermer",
        back: "Retour",
        startAnalysis: "Lancer l'analyse",
        retry: "Reessayer",
        readyToPublish: "Valider la relecture",
        publish: "Publier",
        publishing: "Publication...",
        newImport: "Nouvel import",
      },
      status: {
        analyzing: "Analyse en cours",
        review: "A verifier",
        readyToPublish: "Pret a publier",
        publishing: "Publication en cours",
        published: "Publie",
        failed: "Analyse interrompue",
      },
      errors: {
        sourceRequired: "Choisissez une source avant de continuer.",
        fileRequired: "Ajoutez un fichier pour demarrer.",
        offline: "Connexion requise pour lancer ou publier l'import.",
        adapterUnavailable: "Le module d'import est indisponible.",
        analysisFailed: "L'analyse n'a pas abouti. Reessayez.",
        analysisTooNoisy: "L'analyse est trop bruitee pour proposer un brouillon fiable. Essayez un fichier plus net.",
        reviewFailed: "La validation de la relecture a echoue.",
        reviewBlockingRequired: "Corrigez les champs obligatoires avant de valider la relecture.",
        publishFailed: "La publication n'a pas abouti.",
        publishUnavailable: "Ce brouillon n'est pas publiable.",
        publishBlockingRequired: "La publication est bloquee tant que les champs obligatoires ne sont pas corriges.",
        fileTypeMismatch: "Le fichier ne correspond pas a la source choisie.",
        fileUnreadable: "Le fichier importe n'est plus accessible. Relancez l'import avec le document original.",
        quotaExceeded: "Quota d'import atteint pour aujourd'hui.",
        noItemsDetected: "Aucune ligne exploitable detectee dans ce fichier.",
        generic: "Une erreur est survenue pendant l'import.",
      },
      confidence: {
        high: "Confiance elevee ({{value}}%)",
        medium: "Confiance moyenne ({{value}}%)",
        low: "Confiance faible ({{value}}%)",
      },
      banner: {
        offline: "Vous etes hors ligne. L'import reprendra quand la connexion reviendra.",
      },
    },
    gestionProduits: {
      hiddenBadge: "Masque",
      defaultStoreName: "Votre boutique",
      loadingProducts: "Chargement des produits",
      search: {
        label: "Rechercher un produit",
        placeholder: "Rechercher un produit...",
      },
      filters: {
        all: "Tous",
      },
      empty: {
        searchNoMatch: "Aucun produit ne correspond a votre recherche.",
        noProductsYet: "Aucun produit pour cette boutique pour l'instant.",
        noStoreSelectedTitle: "Aucune boutique selectionnee",
        noStoreSelectedSubtitle: "Choisissez une boutique ci-dessus pour gerer vos produits.",
        noStoreImageAlt: "Aucune boutique",
      },
      actions: {
        addStore: "Ajouter une boutique",
        createStore: "Creer une boutique",
        editStore: "Modifier la boutique",
        addProduct: "Ajouter un produit",
        editProduct: "Modifier",
        showOnStorefront: "Afficher sur la vitrine",
        hideFromStorefront: "Masquer de la vitrine",
        toggleView: "Changer d'affichage",
      },
      selector: {
        deselectStore: "Deselectionner {{name}}",
        storeImageAlt: "Image de {{name}}",
        deselectStoreAvatar: "Deselectionner {{name}} (avatar)",
        vendorFallback: "Vendeur",
        avatarAlt: "Avatar de {{name}}",
        storeAria: "Boutique {{name}}",
      },
      confirm: {
        deleteStoreMessage: "Cette action supprimera definitivement la boutique. Confirmer ?",
        deleteStore: "Supprimer la boutique",
        deleting: "Suppression...",
      },
      errors: {
        loadingProducts: "Erreur de chargement des produits.",
        unknown: "Une erreur inattendue est survenue.",
        saveStoreFailed: "Echec de la sauvegarde de la boutique.",
        deleteStoreFailed: "Erreur lors de la suppression de la boutique.",
        saveProductFailed: "Erreur lors de la sauvegarde du produit.",
        deleteProductFailed: "Erreur lors de la suppression du produit.",
        updateVisibilityFailed: "Impossible de mettre a jour la visibilite.",
        missingLocalProduct: "Produit introuvable localement. Recharge la liste puis reessaie.",
      },
      notifications: {
        reconnect: "Se reconnecter",
        retry: "Reessayer",
        addressSelectionRequired: "Choisissez une adresse valide dans la liste pour localiser la boutique.",
        addressAmbiguous: "Adresse ambigue : selectionnez une suggestion precise.",
        addressNotFound: "Adresse introuvable : selectionnez une suggestion ou reessayez.",
        storeSaved: "Boutique enregistree avec succes.",
        storeDeleted: "Boutique supprimee.",
        productUpdated: "Produit modifie.",
        productAdded: "Produit ajoute.",
        productDeleted: "Produit supprime.",
        productHidden: "Produit masque de la vitrine.",
        productVisible: "Produit rendu visible.",
        savePrefix: "Echec de la sauvegarde",
        networkOrServerError: "Erreur reseau ou serveur.",
      },
    },
    checkout: {
      saveAddressError: "Impossible d'enregistrer l'adresse. Réessaie dans un instant.",
      estimateUpdateError: "Impossible de mettre a jour le devis.",
      loadingUser: "Chargement de vos informations",
      missingData: "Impossible de valider la commande : donnees manquantes.",
      successPaid: "Paiement valide. Merci pour votre commande.",
      title: "Confirmation de votre commande",
      deliveryAddress: "Adresse de livraison",
      chooseAddress: "Choisir une adresse",
      estimateUpdating: "Mise a jour du devis...",
      changeAddress: "Changer",
      orderDetails: "Details de la commande",
      deliveryFeeLabel: "Frais de livraison {{vehicle}} - {{boutique}}",
      storeFallback: "Boutique",
      participationLabel: "Participation de {{boutique}}",
      totalToPay: "Total a payer",
      saveAddressPromptTitle: "Commande confirmee - enregistrer cette adresse ?",
      saveAddressPromptDescription: "Pour la retrouver en 1 clic la prochaine fois",
      home: "Maison",
      work: "Travail",
      later: "Plus tard",
    },
    checkoutForm: {
      paymentGenericError: "Une erreur de paiement est survenue.",
      cardInsufficientFunds: "Carte refusee : fonds insuffisants.",
      cardDeclined: "Carte refusee par votre etablissement bancaire.",
      cardInvalidCvc: "Le CVC est incorrect. Merci de verifier et reessayer.",
      cardExpired: "Cette carte a expire.",
      processingGenericError: "Une erreur de traitement est survenue.",
      preparePaymentError: "Erreur lors de la preparation du paiement.",
      missingPrerequisites: "Informations manquantes ou Stripe non pret.",
      addressRequired: "Choisis une adresse de livraison pour continuer.",
      cardFieldMissing: "Champ de carte introuvable.",
      paymentIntentMissing: "Stripe n'a pas renvoye d'identifiant de paiement.",
      unexpectedConfirmError: "Une erreur inattendue est survenue pendant la confirmation du paiement.",
      createOrderError: "Erreur lors de la creation de la commande.",
      orderConfirmed: "Commande validee avec succes.",
      processing: "Traitement...",
      chooseAddress: "Choisir une adresse",
      pay: "Payer",
    },
    deliveryClient: {
      justNow: "a l'instant",
      secondsSuffix: "s",
      minutesSuffix: "min",
      hoursSuffix: "h",
      ordersCountLabel: "commandes",
      emptyOrdersForStatus: "Aucune commande {{status}}.",
      orderNumber: "Commande n° {{number}}",
      placedOn: "Passee le {{date}}",
      placedOnLabel: "Passee le : {{date}}",
      orderPaused: "Commande en pause : traitement temporairement suspendu.",
      deliverBefore: "A livrer avant {{time}}",
      driverDelay: "{{value}} min signale",
      preparationEstimated: "Preparation estimee",
      minutesValue: "{{value}} min",
      products: "Produits",
      deliveryFee: "Frais de livraison",
      totalPaid: "Total paye",
      lastPositionReceived: "Derniere position recue il y a {{age}}.",
      deliveryCode: "Code de livraison",
      cancel: "Annuler la commande",
      cancelling: "Annulation...",
      cancelQueued: "Annulation en attente de synchronisation.",
      cancelImpossible: "Annulation impossible.",
      cancelSuccess: "Commande annulee.",
      tabs: {
        inProgress: "En cours",
        history: "Historique",
      },
    },
    deliveryCourier: {
      noCurrentDelivery: "Aucune livraison en cours",
      noCurrentDeliveryDescription: "Les livraisons assignees apparaitront ici des qu'une commande sera disponible.",
      noDeliveryAlt: "Aucune livraison",
      goToCourses: "Aller aux courses",
      noDeliveryForStatus: "Aucune livraison pour ce statut",
      noDeliveryForStatusDescription: "Aucune livraison ne correspond a ce filtre pour le moment.",
      badges: {
        toPickup: "A recuperer",
        toDeliver: "Livraison a effectuer",
        paused: "En pause",
      },
      orderNumber: "Commande n° {{number}}",
      status: {
        accepted: "Acceptee",
        preparing: "Preparation",
        onTheWay: "En cours de livraison",
        onHold: "En pause",
      },
      syncPending: "Synchronisation en attente",
      onHoldNotice: "Commande en pause : aucune action possible tant qu'elle n'est pas reactivee ou reassignee par l'admin.",
      preparationEstimated: "Preparation estimee",
      minutesValue: "{{value}} min",
      readyAround: "prete vers {{time}}",
      address: "Adresse",
      totalLabel: "Total :",
      store: "Boutique",
      client: "Client",
      unknownNumber: "Numero inconnu",
      unknownTime: "inconnue",
      deliverBefore: "A livrer avant {{time}}",
      delayReported: "{{value}} min signale",
      delayQuestion: "Retard ?",
      minutesPlus: "+{{value}} min",
      processing: "Traitement...",
      orderPickedUp: "Commande recuperee",
      validationCodePlaceholder: "Code de validation",
      deliver: "Livrer",
      tabs: {
        inProgress: "En cours",
        history: "Historique",
      },
      deliveryCount_one: "livraison",
      deliveryCount_other: "livraisons",
      validationCodeRequired: "Veuillez saisir le code de validation.",
      actionQueuedOffline: "Action enregistree hors ligne. Synchronisation automatique.",
      orderPickupSuccess: "Commande recuperee avec succes",
      actionImpossible: "Action impossible.",
      deliveryQueued: "Livraison en attente de synchronisation.",
      deliveryConfirmed: "Livraison confirmee",
      validationImpossible: "Validation impossible.",
      paymentUnavailableDoNotDeliver: "Paiement indisponible. Ne livrez pas. Merci de retourner le colis au magasin, le support vous remunerera apres confirmation.",
      unexpectedError: "Erreur : {{message}}",
      etaSavedQueued: "ETA enregistre ({{value}} min), en attente de sync.",
      etaAdjusted: "ETA ajuste ({{value}} min)",
      adjustImpossible: "Ajustement impossible",
      incidentTitle: "Commande annulee - paiement indisponible",
      todoTitle: "A faire",
      todoNoDeliver: "Ne pas livrer le client.",
      todoReturnPackage: "Retourner le colis a la boutique.",
      todoSupportCompensation: "Le support vous remunerera apres confirmation du magasin.",
      reportSent: "Signalement envoye au support.",
      reportError: "Erreur lors du signalement.",
      reportSentDone: "Signalement envoye",
      sending: "Envoi...",
      reportIncident: "Signaler l'incident",
      backToFlow: "Retourner au parcours",
      storeLabel: "Boutique : {{value}}",
      clientLabel: "Client : {{value}}",
      courierTotal: "Total livreur : {{amount}}",
      avatarAltStore: "Avatar de {{value}}",
      avatarAltClient: "Avatar de {{value}}",
    },
    deliveryVendor: {
      justNow: "a l'instant",
      secondsSuffix: "s",
      minutesSuffix: "min",
      hoursSuffix: "h",
      status: {
        accepted: "Acceptee",
        onHold: "En pause",
        preparing: "Preparee",
        onTheWay: "En livraison",
        delivered: "Livree",
        cancelled: "Annulee",
      },
      incidentTitle: "Commande annulee",
      incidentDefaultMessage: "Paiement indisponible. Ne pas preparer la commande.",
      todoTitle: "A faire",
      todoNoPrepare: "Ne pas preparer / ne pas expedier.",
      todoInformCourier: "Informer si necessaire le livreur que la commande est annulee.",
      understood: "Compris",
      preparationTime: "Temps de preparation",
      preparationHint: "Indique une estimation pour le client et le livreur.",
      cancel: "Annuler",
      actionQueuedOffline: "Action enregistree hors ligne. Synchronisation automatique.",
      incidentPaymentUnavailable: "Commande annulee : paiement indisponible. Ne pas preparer.",
      actionImpossible: "Action impossible.",
      validate: "Valider",
      emptyForStatus: "Aucune commande {{status}}",
      emptyText: {
        accepted: "Les commandes apparaitront ici des qu'un client aura passe commande.",
        onHold: "Les commandes mises en pause apparaitront ici.",
        preparing: "Vous n'avez encore marque aucune commande comme etant en preparation.",
        onTheWay: "Les commandes en cours de livraison apparaitront ici.",
        delivered: "Aucune commande n'a encore ete marquee comme livree.",
        cancelled: "Vous n'avez annule aucune commande recemment.",
      },
      noOrderAlt: "Aucune commande",
      orderNumber: "Commande n° {{number}}",
      unknownStatus: "Statut inconnu",
      syncPending: "Synchronisation en attente",
      lastPositionReceived: "Derniere position recue il y a {{age}}.",
      onHoldNotice: "Commande en pause : traitement suspendu (compte inactif ou reassignment en cours).",
      clientPromise: "Promesse client : {{time}}",
      driverDelay: "{{value}} min signale",
      preparationEstimated: "Preparation estimee",
      minutesValue: "{{value}} min",
      readyAround: "prete vers {{time}}",
      products: "Produits",
      deliveryFee: "Frais de livraison",
      riveltimeCommission: "Commission Riveltime",
      vendorNet: "Net vendeur",
      deliverer: "Livreur",
      avatarAlt: "Avatar de {{value}}",
      client: "Client",
      cancelQueued: "Annulation en attente de synchronisation.",
      cancelImpossible: "Annulation impossible.",
      markPreparing: "En preparation",
      storeFilterLabel: "Boutique",
      storeFilterAll: "Toutes",
      unknownStore: "Boutique inconnue",
    },
    orderCard: {
      orderNumber: "Commande #{{id}}",
      placedOn: "Passee le {{date}}",
      store: "Boutique",
      deliveryFee: "Frais de livraison",
      vendorContribution: "Participation vendeur",
      storeTotal: "Total boutique",
      paymentStatusLabel: "Statut paiement :",
      deliveryStatusLabel: "Statut livraison :",
      orderTotal: "Total commande :",
      paymentStatus: {
        authorized: "Autorise",
        succeeded: "Payee",
        canceled: "Annulee",
        failed: "Echouee",
        unknown: "Inconnu",
      },
      deliveryStatus: {
        pending: "En attente",
        accepted: "Acceptee",
        preparing: "En preparation",
        on_the_way: "En cours de livraison",
        delivered: "Livree",
        cancelled: "Annulee",
        on_hold: "En pause",
        unknown: "Inconnu",
      },
    },
    userForm: {
      fullname: "Nom complet",
      phone: "Telephone",
      phoneTitle: "Entrez un numero de telephone valide (7 a 15 chiffres)",
      fullAddress: "Adresse complete",
      addressPlaceholder: "Saisissez une adresse",
      category: "Categorie",
      selectCategory: "-- Selectionnez une categorie --",
      categories: {
        alimentation: "Alimentation",
        mobiliteElectrique: "Mobilite electrique",
        pretAPorter: "Pret-a-porter",
        informatique: "Informatique",
        restaurantTraiteur: "Restaurant / Traiteur",
        pharmacieSante: "Pharmacie / Sante",
        bricolageMaison: "Bricolage / Maison",
        fleuristeJardin: "Fleuriste / Jardin",
      },
      transportType: "Type de transport",
      selectTransport: "-- Choisissez un transport --",
      transports: {
        bike: "Velo",
        scooter: "Scooter",
        car: "Voiture",
        truck: "Camion",
        walk: "A pied",
      },
      save: "Enregistrer mes informations",
      errors: {
        noAddressSuggestion: "Aucune suggestion trouvee",
        searchError: "Erreur de recherche",
      },
    },
    orderMutations: {
      actionQueuedOffline: "Action enregistree hors ligne.",
      orderNotFound: "Commande introuvable.",
      preparingError: "Erreur lors du passage en preparation",
      onTheWayError: "Erreur lors du passage en livraison",
      invalidDelta: "Delta invalide",
      adjustEtaError: "Erreur lors de l'ajustement du delai",
      missingCode: "Code manquant",
      deliveryQueued: "Livraison en attente de synchronisation.",
      deliveryError: "Erreur lors de la livraison",
      cancelError: "Erreur lors de l'annulation",
    },
    orderQueries: {
      adminOrdersLoadError: "Erreur lors du chargement des commandes admin.",
      ordersLoadError: "Erreur lors du chargement des commandes.",
      driverAssignedLoadError: "Erreur lors du chargement des livraisons.",
      syncWarnings: {
        adminOrdersSessionExpired:
          "Session expiree : impossible de mettre a jour les commandes. Reconnecte-toi.",
        adminOrdersCache: "Impossible de mettre a jour les commandes (affichage en cache).",
        vendorOrdersSessionExpired:
          "Session expiree : impossible de mettre a jour les commandes. Reconnecte-toi.",
        vendorOrdersCache: "Impossible de mettre a jour les commandes (affichage en cache).",
        clientOrdersSessionExpired:
          "Session expiree : impossible de mettre a jour tes commandes. Reconnecte-toi.",
        clientOrdersCache: "Impossible de mettre a jour tes commandes (affichage en cache).",
        driverAssignedSessionExpired:
          "Session expiree : impossible de mettre a jour tes livraisons. Reconnecte-toi.",
        driverAssignedCache:
          "Impossible de mettre a jour tes livraisons (affichage en cache).",
      },
    },
    adminCatalogue: {
      title: "Boutiques & Produits",
      subtitle: "Catalogue global avec filtres et actions rapides.",
      tabs: {
        stores: "Boutiques",
        products: "Produits",
      },
      searchPlaceholder: "Rechercher (nom, boutique, vendeur, email)",
      loading: "Chargement",
      vendorFallback: "Vendeur",
      storeFallback: "Boutique",
      storeClosure: "Fermeture",
      hidden: "Masque",
      emptyStores: "Aucune boutique.",
      emptyProducts: "Aucun produit.",
      errors: {
        load: "Impossible de charger le catalogue.",
        updateStore: "Impossible de mettre a jour la boutique.",
        updateProduct: "Impossible de mettre a jour le produit.",
      },
    },
    liveSocket: {
      inactiveVendor: "Compte inactif : vos boutiques sont masquees et les commandes sont bloquees.",
      inactiveCourier: "Compte inactif : aucune course disponible tant que le compte n'est pas reactive.",
      reactivated: "Compte reactive.",
      deactivated: "Compte desactive.",
      originHintNetlify: "Le front tourne sur {{origin}}. Verifie la variable URL API et les regles CORS.",
      inferred: {
        blockedOrNoResponse: "Aucune reponse du backend (reseau, proxy ou CORS).",
        endpointNotFound: "Endpoint Socket introuvable (chemin/proxy).",
        forbidden: "Acces refuse (CORS ou regle de securite).",
        unauthorized: "Authentification refusee (token invalide/expire).",
        proxyUnavailable: "Serveur indisponible temporairement (5xx).",
      },
      realtimeUnavailableSubscription: "Temps reel indisponible (abonnement positions)",
      retry: "Reessayer",
      diagnosticCopied: "Diagnostic copie",
      copyDiagnosticPrompt: "Copie ce diagnostic :",
      diagnosticTitle: "Diagnostic Socket.IO",
      diagnosticDescription: "Partage ce bloc (capture ou copie) pour identifier pourquoi le polling echoue.",
      close: "Fermer",
      copy: "Copier",
      ok: "OK",
    },
    userStore: {
      emailAlreadyLinkedOtherAccount: "Cette adresse e-mail est deja associee a un autre compte. Connecte-toi avec la bonne methode ou demande un lien de connexion.",
      unableToFetchProfile: "Impossible de recuperer le profil.",
      invalidSessionReconnect: "Session invalide. Reconnecte-toi.",
      deleteAccountFailed: "Echec de la suppression du compte.",
      unexpectedError: "Erreur inattendue.",
    },
    apiErrors: {
      unknown: "Une erreur est survenue.",
      codes: {
        ACTIVE_ORDERS: "Suppression impossible: des commandes sont encore en cours.",
        ACCOUNT_DELETED_OR_MISSING: "Compte introuvable ou supprime. Reconnecte-toi.",
        EMAIL_NOT_VERIFIED: "Verifie ton adresse e-mail pour continuer.",
        INVALID_TOKEN: "Session invalide. Reconnecte-toi.",
        SESSION_EXPIRED: "Session expiree. Reconnecte-toi.",
        SUPPORT_COOLDOWN: "Tu envoies trop vite. Reessaie dans quelques secondes.",
        SUPPORT_RATE_LIMIT_USER: "Trop de signalements recents. Reessaie plus tard.",
        SUPPORT_RATE_LIMIT_IP: "Limite de signalements atteinte pour cette connexion. Reessaie plus tard.",
        PRELAUNCH_EMAIL_INVALID: "Adresse e-mail invalide.",
        PRELAUNCH_SUBSCRIBE_FAILED: "Impossible de vous inscrire pour le moment.",
        LINK_SESSION_INVALID: "Session de liaison invalide.",
        LINK_SESSION_EXPIRED: "Session de liaison expiree. Relancez la liaison.",
        LINK_CONFIRMATION_REQUIRED: "Confirmation requise pour lier ces methodes de connexion.",
        LINK_FORBIDDEN: "Liaison de compte refusee pour cette demande.",
        LINK_FAILED: "Impossible de finaliser la liaison des methodes de connexion.",
        LINK_ALREADY_DONE: "Ces methodes de connexion sont deja liees.",
        LINK_RATE_LIMITED: "Trop de tentatives de liaison. Reessaie dans quelques instants.",
        AMBASSADOR_DETACH_FAILED: "Impossible de finaliser la suppression: reessaie ou contacte l'administration.",
        INVALID_TARGET_AMBASSADOR: "Ambassadeur cible invalide ou indisponible.",
        VENDOR_ALREADY_ASSIGNED_TO_TARGET: "Ce vendeur est deja rattache a cet ambassadeur.",
        VENDOR_IDS_REQUIRED: "Selection de vendeurs requise pour le transfert.",
        VENDOR_BULK_LIMIT_EXCEEDED: "Trop de vendeurs selectionnes pour un transfert groupé.",
        VENDOR_REASSIGN_BULK_FAILED: "Le transfert groupé a echoue.",
        ORDER_CANCEL_CLIENT_PENDING_ONLY: "Tu peux annuler uniquement une commande en attente.",
        ORDER_PAYMENT_CAPTURED_CANCEL_IMPOSSIBLE: "Paiement deja capture: annulation impossible.",
        ORDER_CANCEL_FORBIDDEN: "Acces non autorise pour annuler cette commande.",
        ORDER_CANCEL_VENDOR_INACTIVE: "Compte inactif: annulation bloquee.",
        ORDER_CANCEL_SERVER_ERROR: "Erreur serveur lors de l'annulation.",
      },
    },
    boutiqueStore: {
      sessionDesyncedReconnectRequired: "Session desynchronisee. Reconnexion requise.",
      accountSyncInProgressRetry: "Compte en cours de synchronisation. Reessaie dans quelques secondes ou reconnecte-toi.",
      unableToLoadYourStores: "Impossible de charger vos boutiques.",
      storeDeleted: "Boutique supprimee.",
      unableToDeleteStore: "Impossible de supprimer la boutique.",
    },
    cityStore: {
      defaultCity: "Votre ville",
      geolocationUnsupported: "Geolocalisation non supportee par ce navigateur.",
      invalidCoords: "Coordonnees invalides retournees par le GPS.",
      reverseGeocodeFailed: "Impossible de recuperer le nom de la ville.",
      geolocationError: "Erreur de geolocalisation.",
      permissionDenied:
        "Permission refusee. Active la localisation dans les reglages puis reessaie.",
      positionUnavailable: "Position indisponible (GPS/reseau). Essaie pres d une fenetre.",
      timeout: "Delai depasse. Reessaie.",
    },
    deliveryAdmin: {
      adminView: "Vue administrateur",
      activeOrders: "Commandes actives",
      sidebarTitle: "Mes commandes",
      scopeTitle: "Suivis",
      total: "Total",
      order: "Commande",
      details: "Details",
      unknown: "Inconnu",
      dash: "-",
      paymentLabel: "Paiement :",
      tabs: {
        inProgress: "En cours",
        history: "Historique",
      },
      captureStatus: {
        authorized: "Autorise",
        succeeded: "Reussi",
        captured: "Capture",
        canceled: "Annule",
        failed: "Echoue",
      },
      emptyOrdersForStatus: "Aucune commande {{status}}.",
      storeFallback: "Boutique non renseignee",
      clientFallback: "Client non renseigne",
      operationalStatus: "Statut operationnel",
      newStatus: "Nouveau statut",
      assignDelivererBeforeStatusChange: "Attribue un livreur avant de changer ce statut.",
      apply: "Appliquer",
      deliverer: "Livreur",
      assignOrReassign: "Assigner ou reassigner",
      loadingDeliverers: "Chargement des livreurs",
      updateDeliverer: "Mettre a jour le livreur",
      systemActions: "Actions systeme",
      resetToPending: "Repasser en attente",
      cancelOrder: "Annuler la commande",
      forceCaptureTitle: "Forcer la capture du paiement",
      forceCaptureDescription: "Capture le paiement et marque la commande comme livree.",
      reasonPlaceholder: "Raison (optionnel)",
      captureAndDeliver: "Capturer et livrer",
      manageOrder: "Gerer la commande",
      actionImpossible: "Action impossible pour cette commande.",
      loadError: "Impossible de charger les commandes admin.",
      orderPausedWithReason: "Commande en pause{{reason}}",
      toasts: {
        statusUpdated: "Statut mis a jour.",
        orderResetPending: "Commande repassee en attente.",
        delivererUpdated: "Livreur mis a jour.",
        orderCancelled: "Commande annulee.",
        paymentCapturedDelivered: "Paiement capture et commande livree.",
      },
    },
    courses: {
      tabs: {
        aroundMe: "Autour de moi",
        route: "Itineraire",
      },
      adsLabel: "Annonces disponibles",
      placeholders: {
        addressAround: "Adresse autour de moi",
        departureAddress: "Adresse de depart",
        arrivalAddress: "Adresse d'arrivee",
        radiusKm: "Rayon",
      },
      banners: {
        connectionRequired: "Connexion requise pour accepter une commande.",
        orderAccepted: "Commande acceptee.",
        orderUnavailable: "Cette commande n'est plus disponible.",
        acceptNetworkError: "Erreur reseau pendant l'acceptation.",
      },
      emptyPendingOrders: "Aucune commande en attente.",
      modal: {
        orderDetails: "Details de la commande",
        noImage: "Aucune image",
        itemsCount: "{{count}} article(s)",
        store: "Boutique",
        delivery: "Livraison",
        storePhotoAlt: "Photo de {{store}}",
      },
      aria: {
        radiusInKm: "Rayon en kilometres",
        deliveryPrice: "Prix de livraison",
        estimatedDelay: "Delai estime",
        distance: "Distance",
        recommendedVehicle: "Vehicule recommande",
        totalWeight: "Poids total",
        totalVolume: "Volume total",
        billedWeight: "Poids facture",
        store: "Boutique",
        storeAddress: "Adresse boutique",
        storePhone: "Telephone boutique",
        client: "Client",
        deliveryAddress: "Adresse de livraison",
        clientPhone: "Telephone client",
      },
      notProvidedFemale: "Non renseignee",
      notProvidedMale: "Non renseigne",
      skip: "Passer",
      accept: "Accepter",
      loading: "Chargement",
      km: "km",
      kg: "kg",
      m3: "m3",
    },
    gestionModal: {
      create: "Creer",
      edit: "Modifier",
      store: "boutique",
      product: "produit",
      deleteItem: "Supprimer",
      storeName: "Nom de la boutique",
      storeNamePlaceholder: "Nom de la boutique",
      category: "Categorie",
      selectCategory: "Selectionner une categorie",
      categories: {
        alimentation: "Alimentation",
        restaurant: "Restaurant",
        sante: "Sante",
        mobilite: "Mobilite",
        pretAPorter: "Pret-a-porter",
        informatique: "Informatique",
        bricolage: "Bricolage",
        jardin: "Jardin",
      },
      fullAddress: "Adresse complete",
      address: "Adresse",
      defineOpeningHours: "Definir les horaires d'ouverture",
      exceptionalClosure: "Fermeture exceptionnelle",
      deliveryFeeParticipationTitle: "Participation aux frais de livraison",
      enableParticipation: "Activer",
      enableParticipationAria: "Activer la participation aux frais de livraison",
      participationShareLabel: "Part des frais prise en charge",
      participationHelp: "Pourcentage des frais de livraison pris en charge par votre boutique.",
      participationOptions: {
        25: "25 % des frais",
        50: "50 % des frais",
        75: "75 % des frais",
        100: "100 % des frais",
      },
      contributionCapLabel: "Plafond max (en % du panier)",
      contributionOptions: {
        10: "10 % du panier max",
        20: "20 % du panier max",
        30: "30 % du panier max",
      },
      contributionHelp: "Limite maximale pour proteger votre marge.",
      participationPreview: "Exemple: frais {{deliveryFee}} EUR, panier {{cartAmount}} EUR -> vous prenez {{amount}} EUR.",
      coverImage: "Image de couverture",
      image: "Image",
      imageConstraints: "Formats acceptes: JPG, PNG. Taille recommandee inferieure a 2 Mo.",
      collection: "Collection",
      productName: "Nom du produit",
      name: "Nom",
      price: "Prix",
      description: "Description",
      selectShippingFormat: "Selectionner un format de transport",
      shippingGroups: {
        smallPackages: "Petits colis",
        mediumPackages: "Colis moyens",
        largeObjects: "Objets volumineux",
      },
      shippingOptions: {
        petit_colis: "Petit colis",
        sac_ou_vetement: "Sac ou vetement",
        carton_moyen: "Carton moyen",
        fragile: "Fragile",
        meuble: "Meuble",
        gros_objet: "Gros objet",
      },
      preparingProductOptions: "Preparation des options produit...",
      save: "Enregistrer",
      saving: "Enregistrement...",
    },
    variableEditor: {
      productOptionsAria: "Edition des options produit",
      productOptionsTitle: "Options du produit",
      addOption: "Ajouter une option",
      emptyHelpPrefix: "Tu peux creer des options comme",
      emptyHelpSuffix: "pour personnaliser le produit.",
      examples: {
        size: "Taille",
        dough: "Pate",
        supplements: "Supplements",
      },
      optionLegend: "Option {{index}}",
      optionName: "Nom de l'option",
      optionNamePlaceholder: "Ex: Taille",
      type: "Type",
      singleChoice: "Choix unique",
      multipleChoice: "Choix multiple",
      required: "Obligatoire",
      hideDetails: "Masquer les details",
      showDetails: "Afficher les details",
      deleteOptionAria: "Supprimer l'option {{index}}",
      examplePrefix: "Exemple :",
      exampleSingleRequired: "choix unique obligatoire",
      or: "ou",
      exampleMultipleMax: "choix multiple avec maximum",
      groupHelpSrOnly: "Configure les options avancees de ce groupe.",
      advancedOptionsAria: "Options avancees",
      advancedOptions: "Options avancees",
      hideAdvancedOptions: "Masquer les options avancees",
      max: "Max",
      maxSelectionsAria: "Nombre maximal de selections",
      technicalKey: "Cle technique",
      technicalKeyPlaceholder: "Ex: size",
      groupKeyAria: "Cle technique du groupe",
      choiceLabel: "Libelle du choix",
      choiceLabelPlaceholder: "Ex: Grand",
      extraCost: "Supplement",
      extraCostHelpSrOnly: "Montant ajoute au prix de base.",
      defaultChoiceSingle: "Choix par defaut",
      deleteChoiceAria: "Supprimer le choix {{value}}",
      addChoiceAria: "Ajouter un choix",
      addChoice: "Ajouter un choix",
      footerHelp: "Les options s'appliqueront a ce produit uniquement.",
      defaultOptionLabel: "Option",
    },
    panier: {
      title: "Panier",
      modalDescription_one: "{{count}} article dans ton panier",
      modalDescription_other: "{{count}} articles dans ton panier",
      emptyCartDescription: "Ton panier est vide.",
      emptyCart: "Aucun article pour le moment.",
      discoverStores: "Decouvrir les boutiques",
      atStore: "Chez",
      quantityForProductAria: "Quantite pour {{name}}",
      removeOneAria: "Retirer un article de {{name}}",
      addOneAria: "Ajouter un article de {{name}}",
      products: "Produits",
      delivery: "Livraison",
      participationOf: "Participation de {{store}}",
      deliveryEstimateLoading: "Calcul des frais de livraison...",
      chooseAddressForEstimate: "Choisis une adresse pour estimer la livraison.",
      loginToEstimate: "Connecte-toi pour obtenir une estimation.",
      login: "Se connecter",
      estimatedTotal: "Total estime",
      doubleDash: "--",
      selectAddressPrompt: "Selectionne une adresse",
      defaultRotatingMessage: "On calcule le meilleur tarif pour toi.",
      preparing: "Preparation...",
      order: "Commander",
      chooseAddress: "Choisir une adresse",
      estimateError: "Impossible d'estimer la livraison.",
      authRequiredToPay: "Connexion requise pour payer.",
      serverError: "Erreur serveur.",
      storeFallback: "Boutique",
      noPaymentPrepared: "Aucun paiement n'a ete prepare.",
      paymentInfoUnavailable: "Informations de paiement indisponibles.",
      preparePaymentError: "Erreur pendant la preparation du paiement.",
      messages: {
        1: "On prepare ta commande...",
        2: "Le meilleur itineraire est en cours de calcul.",
        3: "Tes produits arrivent bientot.",
        4: "On optimise les frais de livraison.",
        5: "Encore un instant...",
        6: "Ton panier est entre de bonnes mains.",
        7: "On verifie la disponibilite des articles.",
        8: "Les boutiques se preparent.",
        9: "Merci pour ta patience.",
        10: "On finalise ton estimation.",
        11: "Presque termine.",
        12: "Ton checkout sera pret dans un instant.",
        13: "On synchronise les informations de paiement.",
        14: "Dernieres verifications en cours.",
      },
    },
    addressSheet: {
      home: "Maison",
      work: "Travail",
      searchError: "Impossible de chercher une adresse. Verifie ta connexion.",
      geoUnavailable: "Position introuvable - saisis une adresse.",
      geoDenied: "Localisation refusee - tu peux saisir une adresse.",
      myLocation: "Ma position",
      myLocationFast: "Ma position (le plus rapide)",
      addressFallback: "Adresse",
      mapSelectedPoint: "Point selectionne",
      mapUnavailable: "Carte indisponible sur cet appareil.",
      searchPlaceholder: "Adresse, ville, pays",
      searchAria: "Rechercher une adresse",
      searching: "Recherche...",
      noResults: "Aucun resultat. Essaie avec numero + rue + ville.",
      locating: "Localisation...",
      howToEnable: "Comment activer ?",
      adjustMap: "Ajuster sur la carte",
      title: "Adresse de livraison",
      description: "Pour voir les frais et le delai.",
      currentAddress: "Actuelle : {{label}}",
      chooseForEstimate: "Choisis une adresse pour estimer la livraison",
      emptyRecents: "Tes adresses apparaitront ici.",
      mapLoadingAria: "Chargement de la carte",
      back: "Revenir",
      confirmPoint: "Valider ce point",
    },
    locationModal: {
      title: "Activer la localisation",
      body: "Pour utiliser \"Ma position\", autorise la localisation. Sinon, saisis une adresse.",
      iosTitle: "iPhone (PWA / Safari / Chrome)",
      iosStep1: "Ouvre Reglages.",
      iosStep2: "Choisis Safari ou Chrome selon ton navigateur.",
      iosStep3: "Va dans Localisation.",
      iosStep4: "Selectionne \"Lorsque l'app est active\".",
      iosStep5: "Reviens sur Riveltime et reessaie.",
      androidTitle: "Android / Desktop",
      androidStep1: "Clique l'icone cadenas dans la barre d'adresse.",
      androidStep2: "Ouvre Parametres du site.",
      androidStep3: "Mets Localisation sur Autoriser.",
      androidStep4: "Recharge la page si besoin.",
      later: "Plus tard",
      wait: "Patiente...",
      retry: "Reessayer",
    },
    admin: {
      pageTitle: "Comptes",
      pageSubtitle: "Clients, vendeurs, livreurs : validation et controle.",
      emptyTitle: "Aucun utilisateur",
      emptySubtitle: "Ajuste la recherche ou les filtres.",
      retry: "Reessayer",
      searchPlaceholder: "Rechercher un compte (nom ou email)...",
      searchAria: "Rechercher un compte",
      clearSearch: "Effacer la recherche",
      deleteConfirm: "Cette action est irreversible. Confirmer la suppression du compte ?",
      unknownName: "Nom inconnu",
      identity: {
        title: "Identite de connexion",
        subtitle: "Details envoyes par le fournisseur d'identite quand ils existent.",
        provider: "Fournisseur",
        providerUnknown: "Fournisseur inconnu",
        displayName: "Nom",
        nickname: "Pseudo",
        email: "Email",
        emailUnavailable: "Email indisponible",
        providerUserId: "ID fournisseur",
        auth0Id: "ID Auth0",
        notProvided: "Non renseigne",
      },
      providers: {
        google: "Google",
        auth0: "Auth0",
        apple: "Apple",
        facebook: "Facebook",
        linkedin: "LinkedIn",
        other: "Autre",
      },
      accountValidated: "Compte valide",
      account: "Compte",
      close: "Fermer",
      closeAria: "Fermer la modale du compte",
      activeStatus: "Statut actif",
      activeToggleAria: "Activer ou desactiver ce compte",
      active: "Actif",
      inactive: "Inactif",
      createdOn: "Cree le",
      phone: "Telephone",
      approving: "Validation...",
      updating: "Mise a jour...",
      deleteDisabledForAdmin: "Suppression admin bloquee.",
      feedback: {
        approveSuccess: "Compte valide avec succes.",
        activateSuccess: "Compte active avec succes.",
        deactivateSuccess: "Compte desactive avec succes.",
      },
      accountHolder: {
        title: "Titulaire du compte",
        subtitle: "Saisis le prenom et le nom du titulaire.",
        firstName: "Prenom",
        lastName: "Nom",
        firstNamePlaceholder: "Ex: Amira",
        lastNamePlaceholder: "Ex: Fkir",
        firstNameRequired: "Le prenom est obligatoire.",
        lastNameRequired: "Le nom est obligatoire.",
        save: "Enregistrer",
        saving: "Enregistrement...",
        updateSuccess: "Titulaire du compte mis a jour.",
        updateError: "Impossible de mettre a jour le titulaire du compte.",
      },
      approve: "Valider",
      ok: "OK",
      delete: "Supprimer",
      transfer: {
        title: "Transferer des vendeurs",
        subtitle: "Reattribuez un vendeur a un autre ambassadeur avec un motif obligatoire.",
        actions: {
          enableMode: "Mode transferer",
          disableMode: "Quitter le mode",
          processing: "Traitement...",
        },
        filters: {
          sourceAmbassador: "Ambassadeur source",
          sourceAll: "Tous les ambassadeurs",
          sourceUnassigned: "Vendeurs non rattaches",
          handover: "Handover",
          handoverAll: "Tous",
          handoverPending: "En attente",
          handoverNotPending: "Traites",
        },
        bulk: {
          targetLabel: "Nouvel ambassadeur",
          targetPlaceholder: "Choisir un ambassadeur",
          reasonLabel: "Motif du transfert",
          reasonPlaceholder: "Ex: continuité commerciale locale",
          selectAllVisible: "Selectionner les visibles",
          clearSelection: "Vider la selection",
          submit: "Transferer ({{count}})",
          selectVendor: "Selectionner le vendeur",
          unselectVendor: "Retirer de la selection",
        },
        single: {
          title: "Transferer ce vendeur",
          subtitle: "Le transfert met a jour le reseau sans changer le statut de verification.",
          currentAmbassador: "Ambassadeur actuel",
          targetLabel: "Ambassadeur cible",
          targetPlaceholder: "Choisir un ambassadeur",
          reasonLabel: "Motif",
          reasonPlaceholder: "Motif obligatoire",
          submit: "Transferer le vendeur",
          noAmbassadorAvailable: "Aucun ambassadeur disponible pour ce transfert.",
        },
        labels: {
          unassigned: "Non rattache",
        },
        errors: {
          targetRequired: "Selectionnez un ambassadeur cible.",
          reasonRequired: "Le motif est obligatoire (3 caracteres minimum).",
        },
        confirm: {
          message: "Confirmer le transfert de {{count}} vendeur(s) ? Motif: {{reason}}",
          confirm: "Confirmer",
          cancel: "Annuler",
          processing: "Transfert...",
        },
        feedback: {
          selectionRequired: "Selectionnez au moins un vendeur.",
          targetRequired: "Selectionnez un ambassadeur cible.",
          singleSuccess: "Vendeur transfere avec succes.",
          singleError: "Impossible de transferer ce vendeur.",
          bulkSuccess: "{{count}} vendeur(s) transferes avec succes.",
          bulkPartial: "{{success}} transfert(s) reussis, {{failed}} echec(s).",
          bulkError: "Le transfert en masse a echoue.",
        },
      },
      roles: {
        all: "Tous",
        client: "Clients",
        vendeur: "Vendeurs",
        livreur: "Livreurs",
        admin: "Admin",
        ambassadeur: "Ambassadeurs",
        unknown: "Inconnu",
      },
      status: {
        approved: "Valide",
        pending: "A valider",
        suspended: "Suspendu",
        unknown: "Inconnu",
      },
      errors: {
        loadUsers: "Impossible de charger les utilisateurs. Reessaie.",
        approveUser: "Erreur validation utilisateur.",
        toggleActive: "Impossible de changer le statut actif/inactif de l'utilisateur.",
        deleteUser: "Erreur suppression utilisateur.",
      },
    },
    ambassador: {
      dashboard: {
        title: "Tableau ambassadeur",
        subtitle: "Suivez la performance de votre reseau local.",
        kpis: {
          sectionTitle: "KPI globaux",
          monthlyRevenue: "CA mensuel",
          ordersCount: "Nombre de commandes",
          averageBasket: "Panier moyen",
          growthRate: "Taux de croissance",
          ambassadorCommission: "Commission generee (4%)",
          total: "Total reseau",
          inReview: "En revue",
          certified: "Certifies",
          restricted: "Restreints",
        },
        period: {
          label: "Periode",
        },
        search: {
          label: "Recherche rapide",
          placeholder: "Nom, email ou telephone",
          cta: "Chercher dans les comptes",
        },
        actions: {
          refresh: "Actualiser",
          openNetwork: "Integrer un vendeur",
          manageNetwork: "Gerer mon reseau",
        },
        activity: {
          title: "Activite recente",
          empty: "Aucune activite recente pour le moment.",
          statusPrefix: "Action: {{status}}",
        },
        activityKinds: {
          preparing: "Profil en preparation",
          in_review: "Compte en revue",
          certified: "Vendeur certifie",
          restricted: "Compte restreint",
          unknown: "Mise a jour",
        },
        states: {
          loading: "Chargement des indicateurs...",
          retry: "Reessayer",
        },
        labels: {
          na: "Non renseigne",
          unknownDate: "Date indisponible",
        },
        feedback: {
          loadError: "Impossible de charger les indicateurs du dashboard.",
        },
      },
      network: {
        title: "Reseaux vendeurs",
        subtitle: "Saisissez uniquement le code d'integration reseau du vendeur.",
        form: {
          title: "Ajouter un vendeur a votre reseau",
          whereToFind: "Le vendeur trouve ce code dans son profil, section Generer code.",
          claimCodeLabel: "Code vendeur (6 chiffres)",
          claimCodePlaceholder: "Ex: 493821",
          claimCodeHint: "Saisissez uniquement les 6 chiffres.",
          resolve: "Valider le code",
          resolving: "Verification...",
        },
        states: {
          loading: "Verification du code en cours...",
          success: "Code valide. Vendeur pret a certifier.",
          error: "Impossible de valider ce code.",
          expired: "Code expire. Demandez une regeneration.",
          used: "Code deja utilise. Demandez un nouveau code.",
        },
        preview: {
          title: "Apercu vendeur",
          vendorLabel: "Vendeur",
          emailLabel: "Email",
          phoneLabel: "Telephone",
          accountStatusLabel: "Statut compte",
          verificationStatusLabel: "Statut verification",
          activityLabel: "Visibilite",
          mainBoutiqueLabel: "Boutique principale",
          completenessLabel: "Completude",
          claimExpiresAtLabel: "Expiration code",
          resolutionExpiresAtLabel: "Expiration session",
        },
        labels: {
          na: "Non renseigne",
        },
        activity: {
          active: "Actif",
          inactive: "Inactif",
        },
        verificationStatus: {
          preparing: "En preparation",
          in_review: "En revue",
          certified: "Certifie",
          restricted: "Restreint",
          unknown: "Inconnu",
        },
        accountStatus: {
          pending: "En attente",
          approved: "Approuve",
          suspended: "Suspendu",
          unknown: "Inconnu",
        },
        actions: {
          certify: "Certifier",
          certifying: "Certification...",
          requestCorrection: "Demander correction",
          requestingCorrection: "Demande en cours...",
          restrict: "Restreindre",
          restricting: "Restriction...",
        },
        restrict: {
          reasonLabel: "Motif de restriction",
          reasonPlaceholder: "Expliquez pourquoi ce compte doit etre restreint",
        },
        feedback: {
          codeRequired: "Saisissez un code vendeur pour continuer.",
          resolveSuccess: "Vendeur trouve. Vous pouvez maintenant valider la certification.",
          resolveError: "Impossible de resoudre ce code vendeur.",
          certifySuccess: "Vendeur certifie et active dans votre reseau.",
          certifyError: "La certification a echoue.",
          correctionSuccess: "Compte place en correction en attente de mise a jour vendeur.",
          correctionError: "Impossible de demander une correction.",
          restrictSuccess: "Compte restreint avec succes.",
          restrictError: "Impossible de restreindre ce compte.",
          restrictReasonRequired: "Le motif de restriction est obligatoire.",
          vendorMissing: "Aucun vendeur selectionne.",
        },
      },
      accounts: {
        title: "Mon reseau",
        subtitle: "Gerez vos vendeurs avec des actions simples et rapides.",
        count: "{{count}} vendeurs",
        scopeNotice: "Vous voyez uniquement les vendeurs de votre reseau.",
        filters: {
          searchLabel: "Recherche vendeur",
          searchPlaceholder: "Nom, email ou telephone",
          quick: {
            all: "Tous",
            in_review: "En revue",
            certified: "Certifies",
            restricted: "Restreints",
            inactive: "Inactifs",
          },
          statusLabel: "Statut compte",
          verificationLabel: "Statut verification",
          activeLabel: "Etat actif",
          status: {
            all: "Tous",
            pending: "En attente",
            approved: "Approuves",
            suspended: "Suspendus",
          },
          verification: {
            all: "Tous",
            preparing: "En preparation",
            inReview: "En revue",
            certified: "Certifies",
            restricted: "Restreints",
          },
          active: {
            all: "Tous",
            active: "Actifs",
            inactive: "Inactifs",
          },
        },
        actions: {
          applyFilters: "Appliquer",
          resetFilters: "Reinitialiser",
          refresh: "Actualiser",
          reactivate: "Reactiver le compte",
          suspend: "Suspendre le compte",
          activate: "Activer le compte",
          deactivate: "Desactiver le compte",
          unrestrict: "Lever la restriction",
          details: "Details",
          hideDetails: "Masquer",
          restrict: "Restreindre le compte",
          consequences: {
            reactivate: "Le vendeur redevient visible.",
            suspend: "Le compte est suspendu jusqu'a correction.",
            activate: "Le vendeur redevient visible.",
            deactivate: "Le vendeur devient invisible.",
            unrestrict: "Le vendeur redevient operationnel.",
            restrict: "Le compte est suspendu jusqu'a correction.",
          },
        },
        list: {
          title: "Vendeurs du reseau",
          statusLine: "{{status}} • {{verification}}",
          mainBoutiqueFallback: "Boutique non renseignee",
        },
        states: {
          loading: "Chargement des comptes...",
          empty: "Aucun vendeur trouve avec ces filtres.",
          emptyDescription: "Votre reseau est vide pour le moment. Ajoutez des vendeurs pour commencer.",
          emptyAlt: "Aucun vendeur",
          emptyCta: "Ajouter un vendeur",
          retry: "Reessayer",
        },
        details: {
          title: "Detail compte",
          sheetTitle: "Details vendeur",
          sheetSubtitle: "Verifiez les informations avant de confirmer une action.",
          identityBlock: "Identite vendeur",
          restrictionBlock: "Contexte restriction",
          vendorId: "Email",
          phone: "Telephone",
          mainBoutique: "Boutique principale",
          name: "Nom",
          status: "Statut compte",
          verification: "Verification",
          activity: "Etat actif",
          lastUpdate: "Derniere mise a jour",
          restrictReason: "Motif de restriction",
          restrictReasonNone: "Aucun motif de restriction actif.",
        },
        restrict: {
          reasonLabel: "Motif de restriction",
          reasonPlaceholder: "Precisez le motif pour ce compte",
          templates: {
            missingInfo: "Informations manquantes",
            lowQuality: "Qualite insuffisante",
            prohibited: "Produits interdits",
          },
        },
        confirm: {
          actionMessage: "Confirmer l'action pour {{vendor}} ? {{consequence}}",
          restrictMessage: "Confirmer la restriction pour {{vendor}} ? {{consequence}} Motif: {{reason}}",
          confirm: "Confirmer",
          cancel: "Annuler",
          processing: "Traitement...",
        },
        badges: {
          status: {
            pending: "En attente",
            approved: "Approuve",
            suspended: "Suspendu",
            unknown: "Inconnu",
          },
          verification: {
            preparing: "En preparation",
            in_review: "En revue",
            certified: "Certifie",
            restricted: "Restreint",
            unknown: "Inconnu",
          },
          active: {
            active: "Actif",
            inactive: "Inactif",
          },
        },
        labels: {
          na: "Non renseigne",
          unknownDate: "Date indisponible",
        },
        feedback: {
          loadError: "Impossible de charger les comptes reseau.",
          reactivateSuccess: "Compte reactive avec succes.",
          reactivateError: "Impossible de reactiver ce compte.",
          suspendSuccess: "Compte suspendu avec succes.",
          suspendError: "Impossible de suspendre ce compte.",
          activateSuccess: "Compte active avec succes.",
          deactivateSuccess: "Compte desactive avec succes.",
          unrestrictSuccess: "Restriction levee avec succes.",
          activeError: "Impossible de changer l'etat actif.",
          restrictReasonRequired: "Le motif de restriction est obligatoire.",
          restrictSuccess: "Compte restreint avec succes.",
          restrictError: "Impossible de restreindre ce compte.",
        },
      },
    },
    profile: {
      syncQueuedOffline: "Mise a jour enregistree hors ligne, synchronisation automatique.",
      updateSuccess: "Profil mis a jour avec succes.",
      updateFailed: "La mise a jour a echoue.",
      addressNotFound: "Adresse non trouvee. Saisis une adresse plus precise ou choisis une suggestion.",
      geocodeFailed: "Erreur de geocodage. Verifie ta connexion internet.",
      languageQueuedOffline: "Langue mise a jour localement. Synchronisation automatique au retour reseau.",
      languageUpdated: "Langue mise a jour.",
      languageUpdateFailed: "Impossible de mettre a jour la langue.",
      redirecting: "Redirection...",
      sessionInvalid: "Session invalide - reconnecte-toi.",
      incompleteWarning: "Votre profil est incomplet. Veuillez le completer.",
      fullnamePlaceholder: "Nom complet",
      phonePlaceholder: "Telephone",
      phoneTitle: "Entrez un numero de telephone valide (7 a 15 chiffres, espaces et tirets autorises)",
      addressPlaceholder: "Adresse complete",
      transportPlaceholder: "-- Choisissez un transport --",
      save: "Sauvegarder",
      edit: "Modifier",
      complete: "Completer",
      editInfo: "Modifier mes informations",
      infoTitleCompact: "Infos",
      notificationsByEmail: "Recevoir les alertes e-mail",
      languageHint: "Choisissez la langue de l'application.",
      languageUpdating: "Mise a jour en cours...",
      languageImmediate: "Le changement est applique immediatement sur cet appareil.",
      supportDescription: "Signalez un probleme en moins de 30 secondes. Reponse visee sous 24h ouvrees.",
      supportCta: "Signaler un probleme",
      securityChangePassword: "Modifier mon mot de passe",
      passwordResetRequesting: "Envoi en cours...",
      passwordResetRequestSent: "Un e-mail de reinitialisation a ete envoye.",
      passwordResetRequestFailed: "Impossible d'envoyer l'e-mail de reinitialisation.",
      passwordResetMissingEmail: "Adresse e-mail indisponible.",
      accepted: "Accepte",
      onDate: "le {{date}}",
      viewOnly: "Consultation",
      supportTicketSent: "Ticket support #{{id}} envoye.",
      notProvided: "Non renseigne",
      fullnameLockedByLegal: "Nom complet verrouille apres signature des CGU.",
      emailManagedByProvider: "Cette adresse e-mail est geree par votre fournisseur de connexion.",
      infoStatus: {
        complete: "Profil complet",
        incomplete: "Informations manquantes",
        actionRequired: "Action requise",
      },
      emailStatus: {
        verified: "E-mail verifie",
        pending: "E-mail a verifier",
        provider: "E-mail gere par fournisseur",
      },
      infoLabels: {
        fullname: "Nom complet",
        email: "Adresse e-mail",
        phone: "Telephone",
        address: "Adresse",
        transport: "Transport",
        certificationStatus: "Statut certification vendeur",
      },
      infoSheet: {
        title: "Modifier mes informations",
        description: "Ces informations sont utilisees pour la livraison et la securite de votre compte.",
        save: "Enregistrer",
        saving: "Enregistrement...",
      },
      validation: {
        fullnameRequired: "Le nom complet est obligatoire.",
        phoneRequired: "Le telephone est obligatoire.",
        phoneInvalid: "Entrez un numero valide.",
        addressRequired: "L'adresse est obligatoire.",
        transportRequired: "Le type de transport est obligatoire.",
      },
      avatarUploadFailed: "Echec de l'upload de l'avatar",
      editAvatar: "Modifier votre avatar",
      avatarAlt: "Avatar utilisateur",
      greeting: "Bonjour {{name}} !",
      userFallback: "Utilisateur",
      desktopSidebarTitle: "Navigation profil",
      desktopSidebarDescription: "Accedez rapidement aux sections de votre compte.",
      desktopSidebarAria: "Navigation des sections du profil",
      desktopSidebarCompletionLabel: "Completion",
      desktopSidebarCompletionValue: "{{percent}}%",
      desktopQuickActionsTitle: "Actions rapides",
      desktopQuickSupport: "Ouvrir le support",
      desktopQuickSecurity: "Aller a la securite",
      desktopWorkspaceTitle: "Espace profil",
      desktopWorkspaceSubtitle: "Pilotez vos reglages personnels depuis un tableau de bord clair.",
      desktopTileCompletion: "Profil",
      desktopCompletionReady: "Profil complet et operationnel.",
      desktopTileLanguage: "Langue active",
      desktopLanguageHint: "Utilisee pour l'interface et les messages.",
      desktopTileNotifications: "Notifications",
      desktopTileSync: "Synchronisation",
      desktopStateEnabled: "Activees",
      desktopStateDisabled: "Desactivees",
      desktopStateOnline: "En ligne",
      desktopStateOffline: "Hors ligne",
      desktopSyncHintOnline: "Les changements sont envoyes immediatement.",
      desktopSyncHintOffline: "Les changements sont mis en file puis synchronises.",
      sections: {
        info: "Mes informations",
        claimCode: "Generer code",
        certification: "Certification vendeur",
        notifications: "Notifications",
        language: "Langue",
        support: "Aide & support",
        legals: "Documents legaux",
        security: "Securite",
      },
      transport: {
        bike: "Velo",
        scooter: "Scooter",
        car: "Voiture",
        truck: "Camion",
        walk: "A pied",
      },
      supportClaim: {
        description: "Utilisez ce code pour une identification rapide avec le support.",
        codeLabel: "Code support",
        noCodeHint: "Aucun code actif. Generez-en un pour commencer.",
        activeCodeHint: "Un code est deja actif. Regenerez-en un pour afficher un nouveau code.",
        expiresAt: "Expire le: {{date}}",
        generate: "Generer le code",
        regenerate: "Regenerer",
        generating: "Generation...",
        copyCta: "Copier le code",
        feedback: {
          generateSuccess: "Code support genere avec succes.",
          generateFailed: "Impossible de generer le code support.",
          copySuccess: "Code copie.",
          copyFailed: "Impossible de copier le code.",
        },
      },
      certification: {
        statusLabel: "Statut de verification",
        ambassadorClaimDescription: "Generez le code vendeur pour integration dans le reseau ambassadeur.",
        ambassadorLabel: "Ambassadeur",
        certifiedByLabel: "Certifie par",
        certifiedAtLabel: "Certifie le",
        restrictedReasonLabel: "Motif de restriction",
        seeDetails: "Voir details",
        codeLabel: "Code integration reseau",
        noCodeHint: "Aucun code actif. Generez-en un pour commencer.",
        activeCodeHint: "Un code est deja actif. Regenerez-en un pour afficher un nouveau code.",
        expiresAt: "Expire le: {{date}}",
        generate: "Generer le code",
        regenerate: "Regenerer",
        generating: "Generation...",
        copyCta: "Copier le code",
        feedback: {
          generateSuccess: "Code integration genere avec succes.",
          generateFailed: "Impossible de generer le code integration.",
          copySuccess: "Code copie.",
          copyFailed: "Impossible de copier le code.",
        },
        status: {
          preparing: "En preparation",
          in_review: "En revue",
          certified: "Certifie",
          restricted: "Restreint",
          unknown: "Inconnu",
        },
      },
      roleSubtitle: {
        client: "Bienvenue parmi nos fideles clients",
        vendeur: "Cher commercant, merci de faire vivre nos quartiers",
        livreur: "Livrer, c'est aussi creer du lien",
        ambassadeur: "Vous developpez le reseau local Riveltime",
        admin: "Vous pilotez les operations de la plateforme",
      },
    },
    stripe: {
      redirectError: "Erreur lors de la redirection Stripe.",
      genericError: "Une erreur est survenue.",
      sessionExpired: "Session expiree. Reconnecte-toi pour continuer.",
      emailNotVerifiedSync: "Ton e-mail vient d'etre verifie ? Patiente quelques secondes puis reessaie.",
      reconnectActionRequired: "Compte Stripe inaccessible avec l'environnement courant. Clique sur Activer Stripe pour reconnecter.",
      serverUnreachable: "Impossible de contacter le serveur.",
      reconnectRequired: "Compte Stripe inaccessible avec l'environnement courant. Reconnexion requise.",
      manageAccountAria: "Gerer mon compte Stripe",
      manageAccount: "Gerer mon compte Stripe",
      loadingAria: "Chargement Stripe",
      connecting: "Connexion...",
      activateAria: "Activer Stripe",
      activate: "Activer Stripe",
      dashboardLoadError: "Erreur lors du chargement des donnees Stripe.",
      connected: "Compte Stripe connecte",
      connectTitle: "Connexion a Stripe",
      connectDescription: "Connecte ton compte Stripe pour suivre tes soldes et virements.",
      summaryTitle: "Resume financier",
      availableBalance: "Solde disponible",
      pendingAmount: "Montant a venir",
      payoutFrequency: "Frequence des virements",
      bankAccount: "Compte bancaire associe",
      lastPayouts: "Derniers virements",
      statusLabel: "Statut",
      statusPaid: "Paye",
      statusPending: "En attente",
      feesLabel: "Frais Stripe",
      transferDestination: "Transfere vers votre compte bancaire",
      bankAccountMasked: "•••• •••• 1234",
      na: "N/A",
      frequency: {
        daily: "quotidien",
        weekly: "hebdomadaire",
        monthly: "mensuel",
        unknown: "inconnu",
      },
    },
    paymentMethods: {
      card: "Carte bancaire",
      cash: "Especes",
      applePay: "Apple Pay",
      googlePay: "Google Pay",
      mealVoucher: "Ticket resto",
      save: "Enregistrer",
    },
    home: {
      welcomeTitle: "Bienvenue sur Riveltime",
      welcomeSubtitle: "La marketplace locale pour commander en quelques secondes.",
      sessionReturn: {
        title: "Heureux de te revoir",
        body: "On t'a ramene ici pour reprendre tranquillement. Si ta session est encore active, tu retourneras directement a ton espace.",
        cta: "Reprendre ma session",
      },
      order: "Commander",
      continueWithoutAccount: "Continuer sans compte",
      proQuestion: "Vous etes commercant ou livreur ?",
      accessVendor: "Acces vendeur",
      accessCourier: "Acces livreur",
      hello: "Bonjour {{name}}",
      yourRole: "Ton role :",
      preparingSpace: "Preparation de ton espace...",
      goToMySpace: "Acceder a mon espace",
      logout: "Se deconnecter",
      installPrompt: "Installe Riveltime pour un acces plus rapide",
      install: "Installer",
      androidInstallTitle: "Installation sur Android",
      androidInstallHintGeneric: "Ouvre le menu du navigateur puis appuie sur Installer l application ou Ajouter a l ecran d accueil.",
      androidInstallHintSamsung: "Dans Samsung Internet, ouvre le menu puis choisis Installer l application ou Ajouter la page a l ecran d accueil.",
      androidInstallHintXiaomi: "Dans Mi Browser, ouvre le menu puis choisis Ajouter a l ecran d accueil ou Installer l application.",
      iosInstallTitle: "Installation sur iPhone",
      iosInstallStep1: "Appuie sur",
      iosInstallShare: "Partager",
      iosInstallStep2: "puis",
      iosInstallHomeScreen: "Sur l'ecran d'accueil",
      close: "Fermer",
      logoAlt: "Logo Riveltime",
      roles: {
        client: "Client",
        vendeur: "Vendeur",
        livreur: "Livreur",
      },
      notProvided: "Non renseignee",
      storeFallback: "Commerce",
      visual: "visuel",
      lastVisit: "Derniere visite",
      closed: "Ferme",
      open: "Ouvert",
      distanceAria: "Distance {{value}} kilometres",
      featuredBadge: "Selection",
      categoryFallback: "cette categorie",
      discoverInCategory: "A decouvrir dans {{category}}",
      view: "Voir",
      featuredProductSubtitle: "Coup de coeur en promo sur Riveltime",
      discover: "Decouvrir",
      offer: "Offre",
      sections: {
        recents: "Vos visites recentes",
        discoverForYou: "A decouvrir pour vous",
        bestSellers: "Best-sellers locaux",
        allStores: "Tous les commerces",
      },
      categories: {
        food: "Alimentation",
        restaurant: "Restaurant",
        fashion: "Pret-a-porter",
        health: "Sante",
        tech: "Informatique",
        mobility: "Mobilite",
        diy: "Bricolage",
        garden: "Jardin",
      },
      filters: {
        quickTitle: "Action Rapide",
        openNow: "Ouvert maintenant",
        popular: "Populaire",
        delivery: "Livraison",
        free: "gratuite",
        nearby: "A proximite",
        categoriesTitle: "Categories",
        distanceOption: "≤ {{km}} km",
      },
      search: {
        defaultPlaceholder: "Rechercher une boutique ou un produit...",
        morningPlaceholder: "Besoin de quelque chose ce matin ?",
        dayPlaceholder: "Trouvez ce qu'il vous faut pres de chez vous",
        eveningPlaceholder: "Faites-vous plaisir sans bouger",
        aria: "Rechercher une boutique ou un produit",
      },
      featuredMessages: {
        1: "Une pepite locale a decouvrir absolument",
        2: "Artisanat passionne, selection soignee",
        3: "Ce n'est pas une boutique comme les autres...",
        4: "Entrez, explorez, regalez-vous",
        5: "Les clients adorent, vous allez comprendre pourquoi",
        6: "Rien que pour vous aujourd'hui",
        7: "Et si vous tombiez sur votre prochain coup de coeur ?",
      },
      announcement: {
        sunny: { title: "Il fait beau aujourd'hui", subtitle: "Profitez des bonnes adresses locales" },
        rainy: { title: "Il pleut aujourd'hui", subtitle: "Faites-vous livrer bien au chaud" },
        cold: { title: "Il fait froid dehors", subtitle: "Restez au chaud, on s'occupe de tout" },
        morning: { title: "Bonjour", subtitle: "Commencez la journee avec une bonne adresse" },
        evening: { title: "Une soiree tranquille ?", subtitle: "Commandez depuis votre canape" },
      },
      prelaunch: {
        badge: "Arrive bientot",
        title: "Riveltime arrive bientot",
        description: "Nous finalisons le reseau de vendeurs et de livreurs dans votre zone.",
        bannerText: "Riveltime arrive bientot",
        bannerAction: "En savoir plus",
        orderDisabled: "Commander (bientot)",
        modalHeader: "Riveltime arrive bientot",
        modalTitle: "Plus que quelques pas avant l'ouverture",
        modalDescription: "Ouverture progressive",
        modalBody: "Nous finalisons actuellement le reseau de vendeurs et de livreurs pres de chez vous.",
        waitlistLabel: "Inscription",
        waitlistPlaceholder: "Votre adresse e-mail",
        waitlistHint: "Recevez une alerte dès l’ouverture.",
        waitlistSubmit: "S'inscrire",
        waitlistSubmitting: "Inscription...",
        waitlistInvalidEmail: "Entrez une adresse e-mail valide.",
        waitlistSuccessFallback: "Merci, vous serez informe du lancement.",
        waitlistErrorFallback: "Impossible de vous inscrire pour le moment.",
        ctaPrimary: "Voir la version publique",
        ctaSecondary: "Je suis vendeur",
        illustrationAlt: "Illustration pre-lancement Riveltime",
      },
      accountLink: {
        close: "Fermer",
        modalHeader: "Riveltime arrive bientot",
        modalTitle: "Ce mail est deja lie a un compte",
        modalBody: "Pour garder un seul profil, liez vos methodes de connexion en toute securite.",
        emailLabel: "Adresse detectee",
        linkCta: "Lier mes methodes de connexion",
        signInExistingCta: "Se connecter avec la methode existante",
        processing: "Verification en cours...",
        success: "Liaison reussie. Reconnectez-vous pour continuer.",
        errorFallback: "Impossible de lier ces methodes de connexion pour le moment.",
      },
    },
    clientHome: {
      prelaunch: {
        badge: "Arrive bientot",
        title: "Riveltime arrive bientot dans votre zone",
        description: "Aucune boutique active pour le moment. Nous ouvrons progressivement, revenez tres bientot.",
        ctaPrimary: "Retour a l'accueil",
        ctaSecondary: "Je veux rejoindre le reseau",
        illustrationAlt: "Illustration attente ouverture du reseau",
      },
    },
  },
  "en-US": {
    notificationBanner: {
      close: "Close",
      updateAvailable: "New version available. Click to update the app.",
    },
    header: {
      sections: {
        vendor: {
          dashboard: "Dashboard",
          inventory: "Inventory",
          orders: "Orders",
          profile: "Profile",
          messages: "Messages",
        },
        courier: {
          dashboard: "Dashboard",
          runs: "Runs",
          route: "Route",
          profile: "Profile",
          messages: "Messages",
        },
        ambassador: {
          dashboard: "Dashboard",
          network: "Network",
          accounts: "Add",
          profile: "Profile",
        },
      },
      labels: {
        deliverTo: "Deliver to",
      },
      connection: {
        connected: "Connected",
        reconnecting: "Reconnecting...",
        offline: "Offline",
      },
      gps: {
        ok: "GPS OK",
        disabledActivate: "GPS disabled - Enable",
        unavailableRetry: "GPS unavailable - Retry",
        locating: "Locating...",
        retryTitle: "Retry location",
        activateTitle: "Enable location",
      },
      boutiques: {
        loading: "Stores...",
        count_one: "{{count}} store",
        count_other: "{{count}} stores",
      },
      address: {
        chooseTitle: "Choose a delivery address",
        choose: "Choose an address",
        currentSelected: "Current selected address: {{label}}",
        undetermined: "not set",
      },
      syncBanner: {
        pending_one: "Sync pending ({{count}} action).",
        pending_other: "Sync pending ({{count}} actions).",
        syncing: "Synchronization in progress.",
        retryNeeded_one: "One action could not be synchronized.",
        retryNeeded_other: "{{count}} actions could not be synchronized.",
        blockedActions_one: "One action needs your attention.",
        blockedActions_other: "{{count}} actions need your attention.",
        viewDetails: "View details",
        retryNow: "Retry",
      },
    },
    offlineQueue: {
      title: "Synchronization",
      description: "Your changes are saved. They will be sent automatically.",
      summary: {
        title: "Current status",
        upToDate: "Everything is up to date.",
        sending: "Sending in progress...",
        pending_one: "{{count}} update is waiting to be sent.",
        pending_other: "{{count}} updates are waiting to be sent.",
        attention_one: "{{count}} update needs your attention.",
        attention_other: "{{count}} updates need your attention.",
      },
      badges: {
        upToDate: "Up to date",
        sending: "Sending",
        pending_one: "{{count}} waiting",
        pending_other: "{{count}} waiting",
        attention_one: "{{count}} to review",
        attention_other: "{{count}} to review",
      },
      status: {
        pending: "Waiting to be sent",
        sending: "Sending in progress",
        attention: "Needs your attention",
      },
      createdAt: "Saved on {{date}}",
      empty: "No update is waiting.",
      error: {
        generic: "This update could not be sent right now.",
      },
      cta: {
        sending: "Sending...",
        retryNow: "Retry now",
        retry: "Retry",
        removeUpdate: "Remove this update",
        removeFromList: "Remove from list",
      },
      actions: {
        preparing: "Order: preparation",
        markOnTheWay: "Order: delivery started",
        delay: "Order: ETA adjustment",
        cancel: "Order: cancellation",
        markDelivered: "Order: delivery confirmation",
        supportTicket: "Support: new report",
        updateProfile: "Profile: update",
        generic: "Update",
      },
      technical: {
        toggle: "Technical details",
        itemToggle: "Technical details for this update",
        pendingCount_one: "Pending: {{count}}",
        pendingCount_other: "Pending: {{count}}",
        failedCount_one: "Temporary failures: {{count}}",
        failedCount_other: "Temporary failures: {{count}}",
        blockedCount_one: "Blocked: {{count}}",
        blockedCount_other: "Blocked: {{count}}",
        successRate: "Success rate: {{value}}%",
        attempts: "Attempts: {{attempts}}/{{maxAttempts}}",
        priority: "Priority: {{value}}",
        aggregateId: "Reference: {{value}}",
        lastError: "Technical error: {{value}}",
        stripeNotice: "Stripe payments: online confirmation required.",
      },
      na: "n/a",
    },
    magicImport: {
      entry: {
        title: "Save time on your catalog",
        subtitle: "Import a photo, PDF, or CSV then review the draft.",
        cta: "Import a store",
      },
      title: "Generate my store",
      subtitle: "Fast creation assistant with mandatory review before publish.",
      currentStep: "Step: {{step}}",
      steps: {
        source: "Choose source",
        upload: "Upload file",
        processing: "Analysis",
        review: "Review",
        publish: "Publish",
      },
      source: {
        description: "Choose where your product data comes from.",
        photo: {
          label: "Photo",
          hint: "Menu, receipt, or picture",
        },
        pdf: {
          label: "PDF",
          hint: "Catalog or menu in PDF",
        },
        csv: {
          label: "CSV",
          hint: "Spreadsheet or POS export",
        },
      },
      upload: {
        description: "Upload one file, then launch automatic analysis.",
        selectedSource: "Selected source: {{source}}",
        fileAria: "Select file to analyze",
        noFile: "No file selected yet.",
        fileMeta: "Approx. size {{size}} KB",
        previewAlt: "Imported document preview",
      },
      processing: {
        description: "We are preparing a product draft. You will approve it before publish.",
        progressLabel: "Progress: {{value}}%",
        currentStage: "Sub-step: {{stage}}",
        etaSec: "Estimated time left: {{value}} s",
        stages: {
          upload: "File preparation",
          ocr: "OCR reading",
          structuring: "AI structuring",
          reviewPrep: "Final checks",
          review: "Review ready",
        },
      },
      review: {
        itemsCount_one: "{{count}} product to review",
        itemsCount_other: "{{count}} products to review",
        blockingCount: "{{count}} item(s) must be fixed before confirmation",
        noBlockingIssues: "No blocking issue detected. You can confirm review.",
        requiredMissingTitle: "Missing required information",
        blockingRow: "Fix required",
        needsReview: "Needs review",
        boutique: {
          title: "Store draft",
          subtitle: "Review store information before publishing products.",
          fields: {
            name: "Store name",
            category: "Store category",
            address: "Store address",
            longitude: "Longitude",
            latitude: "Latitude",
          },
          locationReady: "Location: lon {{lon}}, lat {{lat}}",
          locationMissing: "Location is missing. Complete vendor address settings to continue.",
        },
        required: {
          missing_name: "Name is required.",
          missing_category: "Category is required.",
          invalid_category: "Invalid store category.",
          missing_address: "Store address is required.",
          missing_location: "Store location is required.",
          invalid_price: "Invalid product price.",
          missing_collection_name: "Product category/collection is required.",
          invalid_currency: "Unsupported currency (EUR or MAD).",
          price_unparsed: "Price could not be parsed automatically.",
        },
        fields: {
          name: "Name",
          price: "Price",
          category: "Product collection",
          description: "Description",
        },
        options: {
          title: "Suggested options",
          single: "Single choice",
          multiple: "Multiple choice",
          required: "Required",
          optional: "Optional",
          maxSelections: "Max {{count}} selection(s)",
        },
      },
      publish: {
        readyTitle: "Ready to publish",
        readyDescription_one: "The draft contains {{count}} product. You can publish now.",
        readyDescription_other: "The draft contains {{count}} products. You can publish now.",
        successTitle: "Draft published",
        successDescription_one: "{{count}} product is ready in your catalog.",
        successDescription_other: "{{count}} products are ready in your catalog.",
        publishedAt: "Published at {{value}}",
      },
      actions: {
        close: "Close",
        back: "Back",
        startAnalysis: "Start analysis",
        retry: "Retry",
        readyToPublish: "Confirm review",
        publish: "Publish",
        publishing: "Publishing...",
        newImport: "New import",
      },
      status: {
        analyzing: "Analysis in progress",
        review: "Needs review",
        readyToPublish: "Ready to publish",
        publishing: "Publishing",
        published: "Published",
        failed: "Analysis stopped",
      },
      errors: {
        sourceRequired: "Choose a source before continuing.",
        fileRequired: "Add a file to start.",
        offline: "Connection required to analyze or publish this import.",
        adapterUnavailable: "Import module is unavailable.",
        analysisFailed: "Analysis failed. Please retry.",
        analysisTooNoisy: "Analysis is too noisy to build a reliable draft. Please try a clearer file.",
        reviewFailed: "Review confirmation failed.",
        reviewBlockingRequired: "Fix required fields before confirming review.",
        publishFailed: "Publish failed.",
        publishUnavailable: "This draft is not ready to publish.",
        publishBlockingRequired: "Publishing is blocked until required fields are fixed.",
        fileTypeMismatch: "Uploaded file type does not match selected source.",
        fileUnreadable: "Imported file is no longer accessible. Please restart with the original document.",
        quotaExceeded: "Daily import quota reached.",
        noItemsDetected: "No usable rows were detected in this file.",
        generic: "An import error occurred.",
      },
      confidence: {
        high: "High confidence ({{value}}%)",
        medium: "Medium confidence ({{value}}%)",
        low: "Low confidence ({{value}}%)",
      },
      banner: {
        offline: "You are offline. Import actions resume when connection is back.",
      },
    },
    gestionProduits: {
      hiddenBadge: "Hidden",
      defaultStoreName: "Your store",
      loadingProducts: "Loading products",
      search: {
        label: "Search product",
        placeholder: "Search product...",
      },
      filters: {
        all: "All",
      },
      empty: {
        searchNoMatch: "No product matches your search.",
        noProductsYet: "No products for this store yet.",
        noStoreSelectedTitle: "No store selected",
        noStoreSelectedSubtitle: "Choose a store above to manage your products.",
        noStoreImageAlt: "No store selected",
      },
      actions: {
        addStore: "Add store",
        createStore: "Create store",
        editStore: "Edit store",
        addProduct: "Add product",
        editProduct: "Edit",
        showOnStorefront: "Show on storefront",
        hideFromStorefront: "Hide from storefront",
        toggleView: "Toggle view",
      },
      selector: {
        deselectStore: "Deselect {{name}}",
        storeImageAlt: "Image of {{name}}",
        deselectStoreAvatar: "Deselect {{name}} (avatar)",
        vendorFallback: "Vendor",
        avatarAlt: "Avatar of {{name}}",
        storeAria: "Store {{name}}",
      },
      confirm: {
        deleteStoreMessage: "This action will permanently delete the store. Confirm?",
        deleteStore: "Delete store",
        deleting: "Deleting...",
      },
      errors: {
        loadingProducts: "Error while loading products.",
        unknown: "An unexpected error occurred.",
        saveStoreFailed: "Store save failed.",
        deleteStoreFailed: "Error while deleting store.",
        saveProductFailed: "Error while saving product.",
        deleteProductFailed: "Error while deleting product.",
        updateVisibilityFailed: "Unable to update visibility.",
        missingLocalProduct: "Product not found locally. Refresh the list and try again.",
      },
      notifications: {
        reconnect: "Reconnect",
        retry: "Retry",
        addressSelectionRequired: "Choose a valid address from the list to locate the store.",
        addressAmbiguous: "Address is ambiguous. Please choose a precise suggestion.",
        addressNotFound: "Address not found. Choose a suggestion or retry.",
        storeSaved: "Store saved successfully.",
        storeDeleted: "Store deleted.",
        productUpdated: "Product updated.",
        productAdded: "Product added.",
        productDeleted: "Product deleted.",
        productHidden: "Product hidden from storefront.",
        productVisible: "Product is visible again.",
        savePrefix: "Save failed",
        networkOrServerError: "Network or server error.",
      },
    },
    checkout: {
      saveAddressError: "Unable to save this address. Please try again shortly.",
      estimateUpdateError: "Unable to refresh delivery estimate.",
      loadingUser: "Loading your account details",
      missingData: "Unable to confirm this order: missing data.",
      successPaid: "Payment confirmed. Thanks for your order.",
      title: "Order confirmation",
      deliveryAddress: "Delivery address",
      chooseAddress: "Choose an address",
      estimateUpdating: "Updating estimate...",
      changeAddress: "Change",
      orderDetails: "Order details",
      deliveryFeeLabel: "Delivery fee {{vehicle}} - {{boutique}}",
      storeFallback: "Store",
      participationLabel: "{{boutique}} contribution",
      totalToPay: "Total to pay",
      saveAddressPromptTitle: "Order confirmed - save this address?",
      saveAddressPromptDescription: "So you can reuse it in one tap next time",
      home: "Home",
      work: "Work",
      later: "Later",
    },
    checkoutForm: {
      paymentGenericError: "A payment error occurred.",
      cardInsufficientFunds: "Card declined: insufficient funds.",
      cardDeclined: "Card declined by your bank.",
      cardInvalidCvc: "Invalid CVC. Please check and retry.",
      cardExpired: "This card has expired.",
      processingGenericError: "A processing error occurred.",
      preparePaymentError: "Error while preparing payment.",
      missingPrerequisites: "Missing information or Stripe is not ready.",
      addressRequired: "Choose a delivery address to continue.",
      cardFieldMissing: "Card input is missing.",
      paymentIntentMissing: "Stripe did not return a payment intent id.",
      unexpectedConfirmError: "Unexpected error during payment confirmation.",
      createOrderError: "Error while creating order.",
      orderConfirmed: "Order confirmed successfully.",
      processing: "Processing...",
      chooseAddress: "Choose address",
      pay: "Pay",
    },
    deliveryClient: {
      justNow: "just now",
      secondsSuffix: "s",
      minutesSuffix: "min",
      hoursSuffix: "h",
      ordersCountLabel: "orders",
      emptyOrdersForStatus: "No {{status}} orders.",
      orderNumber: "Order #{{number}}",
      placedOn: "Placed on {{date}}",
      placedOnLabel: "Placed on: {{date}}",
      orderPaused: "Order paused: processing is temporarily suspended.",
      deliverBefore: "Deliver before {{time}}",
      driverDelay: "{{value}} min reported",
      preparationEstimated: "Estimated preparation",
      minutesValue: "{{value}} min",
      products: "Products",
      deliveryFee: "Delivery fee",
      totalPaid: "Total paid",
      lastPositionReceived: "Last position received {{age}} ago.",
      deliveryCode: "Delivery code",
      cancel: "Cancel order",
      cancelling: "Cancelling...",
      cancelQueued: "Cancellation queued for sync.",
      cancelImpossible: "Cancellation unavailable.",
      cancelSuccess: "Order cancelled.",
      tabs: {
        inProgress: "In progress",
        history: "History",
      },
    },
    deliveryCourier: {
      noCurrentDelivery: "No current delivery",
      noCurrentDeliveryDescription: "Assigned deliveries will appear here as soon as an order is available.",
      noDeliveryAlt: "No delivery",
      goToCourses: "Go to runs",
      noDeliveryForStatus: "No delivery for this status",
      noDeliveryForStatusDescription: "No delivery matches this filter yet.",
      badges: {
        toPickup: "To pick up",
        toDeliver: "To deliver",
        paused: "Paused",
      },
      orderNumber: "Order #{{number}}",
      status: {
        accepted: "Accepted",
        preparing: "Preparing",
        onTheWay: "On the way",
        onHold: "Paused",
      },
      syncPending: "Sync pending",
      onHoldNotice: "Order is paused: no action is possible until it is reactivated or reassigned by admin.",
      preparationEstimated: "Estimated preparation",
      minutesValue: "{{value}} min",
      readyAround: "ready around {{time}}",
      address: "Address",
      totalLabel: "Total:",
      store: "Store",
      client: "Client",
      unknownNumber: "Unknown number",
      unknownTime: "unknown",
      deliverBefore: "Deliver before {{time}}",
      delayReported: "{{value}} min reported",
      delayQuestion: "Delay?",
      minutesPlus: "+{{value}} min",
      processing: "Processing...",
      orderPickedUp: "Order picked up",
      validationCodePlaceholder: "Validation code",
      deliver: "Deliver",
      tabs: {
        inProgress: "In progress",
        history: "History",
      },
      deliveryCount_one: "delivery",
      deliveryCount_other: "deliveries",
      validationCodeRequired: "Please enter the validation code.",
      actionQueuedOffline: "Action saved offline. Automatic sync enabled.",
      orderPickupSuccess: "Order picked up successfully",
      actionImpossible: "Action unavailable.",
      deliveryQueued: "Delivery queued for sync.",
      deliveryConfirmed: "Delivery confirmed",
      validationImpossible: "Validation failed.",
      paymentUnavailableDoNotDeliver: "Payment unavailable. Do not deliver. Return the package to the store; support will compensate after confirmation.",
      unexpectedError: "Error: {{message}}",
      etaSavedQueued: "ETA saved ({{value}} min), waiting sync.",
      etaAdjusted: "ETA adjusted ({{value}} min)",
      adjustImpossible: "Adjustment unavailable",
      incidentTitle: "Order cancelled - payment unavailable",
      todoTitle: "To do",
      todoNoDeliver: "Do not deliver to the customer.",
      todoReturnPackage: "Return the package to the store.",
      todoSupportCompensation: "Support will compensate after store confirmation.",
      reportSent: "Report sent to support.",
      reportError: "Error while reporting.",
      reportSentDone: "Report sent",
      sending: "Sending...",
      reportIncident: "Report incident",
      backToFlow: "Back to flow",
      storeLabel: "Store: {{value}}",
      clientLabel: "Client: {{value}}",
      courierTotal: "Courier total: {{amount}}",
      avatarAltStore: "Avatar of {{value}}",
      avatarAltClient: "Avatar of {{value}}",
    },
    deliveryVendor: {
      justNow: "just now",
      secondsSuffix: "s",
      minutesSuffix: "min",
      hoursSuffix: "h",
      status: {
        accepted: "Accepted",
        onHold: "On hold",
        preparing: "Prepared",
        onTheWay: "Out for delivery",
        delivered: "Delivered",
        cancelled: "Cancelled",
      },
      incidentTitle: "Order cancelled",
      incidentDefaultMessage: "Payment unavailable. Do not prepare the order.",
      todoTitle: "To do",
      todoNoPrepare: "Do not prepare / do not ship.",
      todoInformCourier: "Inform the courier if needed that the order is cancelled.",
      understood: "Understood",
      preparationTime: "Preparation time",
      preparationHint: "Set an estimate for the client and courier.",
      cancel: "Cancel",
      actionQueuedOffline: "Action saved offline. Automatic sync.",
      incidentPaymentUnavailable: "Order cancelled: payment unavailable. Do not prepare.",
      actionImpossible: "Action unavailable.",
      validate: "Confirm",
      emptyForStatus: "No {{status}} order",
      emptyText: {
        accepted: "Orders will appear here as soon as a client places one.",
        onHold: "Paused orders will appear here.",
        preparing: "You have not marked any order as preparing yet.",
        onTheWay: "Orders out for delivery will appear here.",
        delivered: "No order has been marked as delivered yet.",
        cancelled: "You have not cancelled any order recently.",
      },
      noOrderAlt: "No order",
      orderNumber: "Order #{{number}}",
      unknownStatus: "Unknown status",
      syncPending: "Sync pending",
      lastPositionReceived: "Last position received {{age}} ago.",
      onHoldNotice: "Order paused: processing is suspended (inactive account or reassignment in progress).",
      clientPromise: "Client ETA promise: {{time}}",
      driverDelay: "{{value}} min reported",
      preparationEstimated: "Estimated preparation",
      minutesValue: "{{value}} min",
      readyAround: "ready around {{time}}",
      products: "Products",
      deliveryFee: "Delivery fee",
      riveltimeCommission: "Riveltime commission",
      vendorNet: "Vendor net",
      deliverer: "Courier",
      avatarAlt: "Avatar of {{value}}",
      client: "Client",
      cancelQueued: "Cancellation queued for sync.",
      cancelImpossible: "Cancellation unavailable.",
      markPreparing: "Mark preparing",
      storeFilterLabel: "Store",
      storeFilterAll: "All",
      unknownStore: "Unknown store",
    },
    orderCard: {
      orderNumber: "Order #{{id}}",
      placedOn: "Placed on {{date}}",
      store: "Store",
      deliveryFee: "Delivery fee",
      vendorContribution: "Seller contribution",
      storeTotal: "Store total",
      paymentStatusLabel: "Payment status:",
      deliveryStatusLabel: "Delivery status:",
      orderTotal: "Order total:",
      paymentStatus: {
        authorized: "Authorized",
        succeeded: "Paid",
        canceled: "Canceled",
        failed: "Failed",
        unknown: "Unknown",
      },
      deliveryStatus: {
        pending: "Pending",
        accepted: "Accepted",
        preparing: "Preparing",
        on_the_way: "On the way",
        delivered: "Delivered",
        cancelled: "Canceled",
        on_hold: "On hold",
        unknown: "Unknown",
      },
    },
    userForm: {
      fullname: "Full name",
      phone: "Phone",
      phoneTitle: "Enter a valid phone number (7 to 15 digits)",
      fullAddress: "Full address",
      addressPlaceholder: "Enter an address",
      category: "Category",
      selectCategory: "-- Select a category --",
      categories: {
        alimentation: "Food",
        mobiliteElectrique: "Electric mobility",
        pretAPorter: "Fashion",
        informatique: "IT",
        restaurantTraiteur: "Restaurant / Catering",
        pharmacieSante: "Pharmacy / Health",
        bricolageMaison: "DIY / Home",
        fleuristeJardin: "Florist / Garden",
      },
      transportType: "Transport type",
      selectTransport: "-- Choose transport --",
      transports: {
        bike: "Bike",
        scooter: "Scooter",
        car: "Car",
        truck: "Truck",
        walk: "On foot",
      },
      save: "Save my information",
      errors: {
        noAddressSuggestion: "No suggestion found",
        searchError: "Search error",
      },
    },
    orderMutations: {
      actionQueuedOffline: "Action saved offline.",
      orderNotFound: "Order not found.",
      preparingError: "Failed to mark as preparing",
      onTheWayError: "Failed to mark as on the way",
      invalidDelta: "Invalid delta",
      adjustEtaError: "Failed to adjust ETA",
      missingCode: "Missing code",
      deliveryQueued: "Delivery queued for synchronization.",
      deliveryError: "Delivery failed",
      cancelError: "Cancellation failed",
    },
    orderQueries: {
      adminOrdersLoadError: "Unable to load admin orders.",
      ordersLoadError: "Unable to load orders.",
      driverAssignedLoadError: "Unable to load deliveries.",
      syncWarnings: {
        adminOrdersSessionExpired:
          "Session expired: unable to refresh orders. Sign in again.",
        adminOrdersCache: "Unable to refresh orders (showing cached data).",
        vendorOrdersSessionExpired:
          "Session expired: unable to refresh orders. Sign in again.",
        vendorOrdersCache: "Unable to refresh orders (showing cached data).",
        clientOrdersSessionExpired:
          "Session expired: unable to refresh your orders. Sign in again.",
        clientOrdersCache: "Unable to refresh your orders (showing cached data).",
        driverAssignedSessionExpired:
          "Session expired: unable to refresh your deliveries. Sign in again.",
        driverAssignedCache:
          "Unable to refresh your deliveries (showing cached data).",
      },
    },
    adminCatalogue: {
      title: "Stores & Products",
      subtitle: "Global catalog with filters and quick actions.",
      tabs: {
        stores: "Stores",
        products: "Products",
      },
      searchPlaceholder: "Search (name, store, seller, email)",
      loading: "Loading",
      vendorFallback: "Seller",
      storeFallback: "Store",
      storeClosure: "Closure",
      hidden: "Hidden",
      emptyStores: "No store.",
      emptyProducts: "No product.",
      errors: {
        load: "Unable to load catalog.",
        updateStore: "Unable to update store.",
        updateProduct: "Unable to update product.",
      },
    },
    liveSocket: {
      inactiveVendor: "Inactive account: your stores are hidden and orders are blocked.",
      inactiveCourier: "Inactive account: no runs available until account is reactivated.",
      reactivated: "Account reactivated.",
      deactivated: "Account deactivated.",
      realtimeUnavailableSubscription: "Realtime unavailable (positions subscription)",
      retry: "Retry",
      diagnosticCopied: "Diagnostic copied",
      copyDiagnosticPrompt: "Copy this diagnostic:",
      diagnosticTitle: "Socket.IO Diagnostic",
      diagnosticDescription: "Share this block (screenshot or copy) to identify why polling fails.",
      close: "Close",
      copy: "Copy",
      ok: "OK",
    },
    userStore: {
      emailAlreadyLinkedOtherAccount: "This email address is already linked to another account. Sign in with the right method or request a login link.",
    },
    apiErrors: {
      unknown: "An unexpected error occurred.",
      codes: {
        ACTIVE_ORDERS: "Deletion blocked: active orders still exist.",
        ACCOUNT_DELETED_OR_MISSING: "Account missing or deleted. Sign in again.",
        EMAIL_NOT_VERIFIED: "Verify your email address to continue.",
        INVALID_TOKEN: "Invalid session. Sign in again.",
        SESSION_EXPIRED: "Session expired. Sign in again.",
        SUPPORT_COOLDOWN: "You are sending too fast. Try again in a few seconds.",
        SUPPORT_RATE_LIMIT_USER: "Too many recent reports. Please retry later.",
        SUPPORT_RATE_LIMIT_IP: "Report limit reached for this connection. Please retry later.",
        PRELAUNCH_EMAIL_INVALID: "Invalid email address.",
        PRELAUNCH_SUBSCRIBE_FAILED: "Unable to subscribe right now.",
        LINK_SESSION_INVALID: "Invalid linking session.",
        LINK_SESSION_EXPIRED: "Linking session expired. Start again.",
        LINK_CONFIRMATION_REQUIRED: "Confirmation is required to link these sign-in methods.",
        LINK_FORBIDDEN: "Account linking is not allowed for this request.",
        LINK_FAILED: "Unable to complete sign-in methods linking.",
        LINK_ALREADY_DONE: "These sign-in methods are already linked.",
        LINK_RATE_LIMITED: "Too many linking attempts. Try again shortly.",
        AMBASSADOR_DETACH_FAILED: "Unable to complete account deletion right now. Please try again or contact admin support.",
        INVALID_TARGET_AMBASSADOR: "Target ambassador is invalid or unavailable.",
        VENDOR_ALREADY_ASSIGNED_TO_TARGET: "This vendor is already linked to this ambassador.",
        VENDOR_IDS_REQUIRED: "Vendor selection is required for transfer.",
        VENDOR_BULK_LIMIT_EXCEEDED: "Too many vendors selected for bulk transfer.",
        VENDOR_REASSIGN_BULK_FAILED: "Bulk transfer failed.",
        ORDER_CANCEL_CLIENT_PENDING_ONLY: "You can only cancel an order that is still pending.",
        ORDER_PAYMENT_CAPTURED_CANCEL_IMPOSSIBLE: "Payment already captured: cancellation is unavailable.",
        ORDER_CANCEL_FORBIDDEN: "You are not allowed to cancel this order.",
        ORDER_CANCEL_VENDOR_INACTIVE: "Inactive account: cancellation is blocked.",
        ORDER_CANCEL_SERVER_ERROR: "Server error while cancelling the order.",
      },
    },
    addressSheet: {
      home: "Home",
      work: "Work",
      searchError: "Unable to search address. Check your connection.",
      geoUnavailable: "Location unavailable - type an address.",
      geoDenied: "Location denied - you can type an address.",
      myLocation: "My location",
      myLocationFast: "My location (fastest)",
      addressFallback: "Address",
      mapSelectedPoint: "Selected point",
      mapUnavailable: "Map is unavailable on this device.",
      searchPlaceholder: "Address, city, country",
      searchAria: "Search an address",
      searching: "Searching...",
      noResults: "No result. Try number + street + city.",
      locating: "Locating...",
      howToEnable: "How to enable?",
      adjustMap: "Adjust on map",
      title: "Delivery address",
      description: "Required to compute fee and ETA.",
      currentAddress: "Current: {{label}}",
      chooseForEstimate: "Choose an address to estimate delivery",
      emptyRecents: "Your saved addresses will appear here.",
      mapLoadingAria: "Loading map",
      back: "Back",
      confirmPoint: "Confirm this point",
    },
    cityStore: {
      defaultCity: "Your city",
      geolocationUnsupported: "Geolocation is not supported by this browser.",
      invalidCoords: "Invalid coordinates were returned by GPS.",
      reverseGeocodeFailed: "Unable to resolve the city name.",
      geolocationError: "Geolocation error.",
      permissionDenied:
        "Permission denied. Enable location in settings, then try again.",
      positionUnavailable: "Position unavailable (GPS/network). Try near a window.",
      timeout: "Request timed out. Try again.",
    },
    locationModal: {
      title: "Enable location",
      body: "To use \"My location\", allow location access. Otherwise, type an address.",
      iosTitle: "iPhone (PWA / Safari / Chrome)",
      iosStep1: "Open Settings.",
      iosStep2: "Choose Safari or Chrome.",
      iosStep3: "Open Location.",
      iosStep4: "Select \"While Using the App\".",
      iosStep5: "Return to Riveltime and retry.",
      androidTitle: "Android / Desktop",
      androidStep1: "Click the lock icon in the address bar.",
      androidStep2: "Open site settings.",
      androidStep3: "Set location to allow.",
      androidStep4: "Reload the page if needed.",
      later: "Later",
      wait: "Please wait...",
      retry: "Retry",
    },
    admin: {
      pageTitle: "Accounts",
      pageSubtitle: "Clients, vendors, couriers: approval and control.",
      emptyTitle: "No users",
      emptySubtitle: "Adjust search or filters.",
      retry: "Retry",
      searchPlaceholder: "Search account (name or email)...",
      searchAria: "Search account",
      clearSearch: "Clear search",
      deleteConfirm: "This action is irreversible. Confirm account deletion?",
      unknownName: "Unknown name",
      identity: {
        title: "Sign-in identity",
        subtitle: "Details sent by the identity provider when available.",
        provider: "Provider",
        providerUnknown: "Unknown provider",
        displayName: "Name",
        nickname: "Nickname",
        email: "Email",
        emailUnavailable: "Email unavailable",
        providerUserId: "Provider ID",
        auth0Id: "Auth0 ID",
        notProvided: "Not provided",
      },
      providers: {
        google: "Google",
        auth0: "Auth0",
        apple: "Apple",
        facebook: "Facebook",
        linkedin: "LinkedIn",
        other: "Other",
      },
      accountValidated: "Account approved",
      account: "Account",
      close: "Close",
      closeAria: "Close account modal",
      activeStatus: "Active status",
      activeToggleAria: "Enable or disable this account",
      active: "Active",
      inactive: "Inactive",
      createdOn: "Created on",
      phone: "Phone",
      approving: "Approving...",
      updating: "Updating...",
      deleteDisabledForAdmin: "Admin deletion is blocked.",
      feedback: {
        approveSuccess: "Account approved successfully.",
        activateSuccess: "Account activated successfully.",
        deactivateSuccess: "Account deactivated successfully.",
      },
      accountHolder: {
        title: "Account holder",
        subtitle: "Enter the account holder first and last name.",
        firstName: "First name",
        lastName: "Last name",
        firstNamePlaceholder: "Ex: Amira",
        lastNamePlaceholder: "Ex: Fkir",
        firstNameRequired: "First name is required.",
        lastNameRequired: "Last name is required.",
        save: "Save",
        saving: "Saving...",
        updateSuccess: "Account holder updated.",
        updateError: "Unable to update account holder.",
      },
      approve: "Approve",
      ok: "OK",
      delete: "Delete",
      transfer: {
        title: "Transfer vendors",
        subtitle: "Reassign a vendor to another ambassador with a mandatory reason.",
        actions: {
          enableMode: "Transfer mode",
          disableMode: "Exit mode",
          processing: "Processing...",
        },
        filters: {
          sourceAmbassador: "Source ambassador",
          sourceAll: "All ambassadors",
          sourceUnassigned: "Unassigned vendors",
          handover: "Handover",
          handoverAll: "All",
          handoverPending: "Pending",
          handoverNotPending: "Processed",
        },
        bulk: {
          targetLabel: "New ambassador",
          targetPlaceholder: "Select an ambassador",
          reasonLabel: "Transfer reason",
          reasonPlaceholder: "Ex: local business continuity",
          selectAllVisible: "Select visible vendors",
          clearSelection: "Clear selection",
          submit: "Transfer ({{count}})",
          selectVendor: "Select vendor",
          unselectVendor: "Remove vendor from selection",
        },
        single: {
          title: "Transfer this vendor",
          subtitle: "Transfer updates the network link without changing verification status.",
          currentAmbassador: "Current ambassador",
          targetLabel: "Target ambassador",
          targetPlaceholder: "Select an ambassador",
          reasonLabel: "Reason",
          reasonPlaceholder: "Mandatory reason",
          submit: "Transfer vendor",
          noAmbassadorAvailable: "No ambassador is available for this transfer.",
        },
        labels: {
          unassigned: "Unassigned",
        },
        errors: {
          targetRequired: "Please select a target ambassador.",
          reasonRequired: "Reason is required (minimum 3 characters).",
        },
        confirm: {
          message: "Confirm transfer of {{count}} vendor(s)? Reason: {{reason}}",
          confirm: "Confirm",
          cancel: "Cancel",
          processing: "Transferring...",
        },
        feedback: {
          selectionRequired: "Select at least one vendor.",
          targetRequired: "Select a target ambassador.",
          singleSuccess: "Vendor transferred successfully.",
          singleError: "Unable to transfer this vendor.",
          bulkSuccess: "{{count}} vendor(s) transferred successfully.",
          bulkPartial: "{{success}} transfer(s) succeeded, {{failed}} failed.",
          bulkError: "Bulk transfer failed.",
        },
      },
      roles: {
        all: "All",
        client: "Clients",
        vendeur: "Vendors",
        livreur: "Couriers",
        admin: "Admin",
        ambassadeur: "Ambassadors",
        unknown: "Unknown",
      },
      status: {
        approved: "Approved",
        pending: "Pending",
        suspended: "Suspended",
        unknown: "Unknown",
      },
      errors: {
        loadUsers: "Unable to load users. Please retry.",
        approveUser: "Error approving user.",
        toggleActive: "Unable to change active status.",
        deleteUser: "Error deleting user.",
      },
    },
    ambassador: {
      dashboard: {
        title: "Ambassador dashboard",
        subtitle: "Track your local network performance.",
        kpis: {
          sectionTitle: "Global KPIs",
          monthlyRevenue: "Monthly revenue",
          ordersCount: "Orders count",
          averageBasket: "Average basket",
          growthRate: "Growth rate",
          ambassadorCommission: "Generated commission (4%)",
          total: "Total network",
          inReview: "In review",
          certified: "Certified",
          restricted: "Restricted",
        },
        period: {
          label: "Period",
        },
        search: {
          label: "Quick search",
          placeholder: "Name, email or phone",
          cta: "Search in accounts",
        },
        actions: {
          refresh: "Refresh",
          openNetwork: "Integrate a vendor",
          manageNetwork: "Manage my network",
        },
        activity: {
          title: "Recent activity",
          empty: "No recent activity yet.",
          statusPrefix: "Action: {{status}}",
        },
        activityKinds: {
          preparing: "Profile preparing",
          in_review: "Account in review",
          certified: "Vendor certified",
          restricted: "Account restricted",
          unknown: "Update",
        },
        states: {
          loading: "Loading KPI data...",
          retry: "Retry",
        },
        labels: {
          na: "Not provided",
          unknownDate: "Date unavailable",
        },
        feedback: {
          loadError: "Unable to load dashboard KPIs.",
        },
      },
      network: {
        title: "Vendor network",
        subtitle: "Use only the vendor network integration code.",
        form: {
          title: "Add a vendor to your network",
          whereToFind: "The vendor can find this code in Profile, Generate code section.",
          claimCodeLabel: "Vendor code (6 digits)",
          claimCodePlaceholder: "Ex: 493821",
          claimCodeHint: "Enter only the 6 digits.",
          resolve: "Validate code",
          resolving: "Validating...",
        },
        states: {
          loading: "Checking code...",
          success: "Code is valid. Vendor is ready for certification.",
          error: "Unable to validate this code.",
          expired: "Code expired. Ask vendor to regenerate it.",
          used: "Code already used. Ask for a new code.",
        },
        preview: {
          title: "Vendor preview",
          vendorLabel: "Vendor",
          emailLabel: "Email",
          phoneLabel: "Phone",
          accountStatusLabel: "Account status",
          verificationStatusLabel: "Verification status",
          activityLabel: "Visibility",
          mainBoutiqueLabel: "Main store",
          completenessLabel: "Completeness",
          claimExpiresAtLabel: "Code expires",
          resolutionExpiresAtLabel: "Session expires",
        },
        labels: {
          na: "Not provided",
        },
        activity: {
          active: "Active",
          inactive: "Inactive",
        },
        verificationStatus: {
          preparing: "Preparing",
          in_review: "In review",
          certified: "Certified",
          restricted: "Restricted",
          unknown: "Unknown",
        },
        accountStatus: {
          pending: "Pending",
          approved: "Approved",
          suspended: "Suspended",
          unknown: "Unknown",
        },
        actions: {
          certify: "Certify",
          certifying: "Certifying...",
          requestCorrection: "Request correction",
          requestingCorrection: "Requesting...",
          restrict: "Restrict",
          restricting: "Restricting...",
        },
        restrict: {
          reasonLabel: "Restriction reason",
          reasonPlaceholder: "Explain why this account should be restricted",
        },
        feedback: {
          codeRequired: "Enter a vendor code to continue.",
          resolveSuccess: "Vendor found. You can now confirm certification.",
          resolveError: "Unable to resolve this vendor code.",
          certifySuccess: "Vendor certified and activated in your network.",
          certifyError: "Certification failed.",
          correctionSuccess: "Account set to correction pending vendor updates.",
          correctionError: "Unable to request correction.",
          restrictSuccess: "Account restricted successfully.",
          restrictError: "Unable to restrict this account.",
          restrictReasonRequired: "Restriction reason is required.",
          vendorMissing: "No vendor selected.",
        },
      },
      accounts: {
        title: "My network",
        subtitle: "Manage your vendors with simple and fast actions.",
        count: "{{count}} vendors",
        scopeNotice: "You only see vendors in your own network.",
        filters: {
          searchLabel: "Vendor search",
          searchPlaceholder: "Name, email or phone",
          quick: {
            all: "All",
            in_review: "In review",
            certified: "Certified",
            restricted: "Restricted",
            inactive: "Inactive",
          },
          statusLabel: "Account status",
          verificationLabel: "Verification status",
          activeLabel: "Active state",
          status: {
            all: "All",
            pending: "Pending",
            approved: "Approved",
            suspended: "Suspended",
          },
          verification: {
            all: "All",
            preparing: "Preparing",
            inReview: "In review",
            certified: "Certified",
            restricted: "Restricted",
          },
          active: {
            all: "All",
            active: "Active",
            inactive: "Inactive",
          },
        },
        actions: {
          applyFilters: "Apply",
          resetFilters: "Reset",
          refresh: "Refresh",
          reactivate: "Reactivate account",
          suspend: "Suspend account",
          activate: "Activate account",
          deactivate: "Deactivate account",
          unrestrict: "Lift restriction",
          details: "Details",
          hideDetails: "Hide",
          restrict: "Restrict account",
          consequences: {
            reactivate: "Vendor becomes visible again.",
            suspend: "Account is suspended until correction.",
            activate: "Vendor becomes visible again.",
            deactivate: "Vendor becomes hidden.",
            unrestrict: "Vendor becomes operational again.",
            restrict: "Account is suspended until correction.",
          },
        },
        list: {
          title: "Network vendors",
          statusLine: "{{status}} • {{verification}}",
          mainBoutiqueFallback: "Main store not provided",
        },
        states: {
          loading: "Loading accounts...",
          empty: "No vendors match these filters.",
          emptyDescription: "Your network is empty for now. Add vendors to get started.",
          emptyAlt: "No vendor",
          emptyCta: "Add a vendor",
          retry: "Retry",
        },
        details: {
          title: "Account details",
          sheetTitle: "Vendor details",
          sheetSubtitle: "Review information before confirming an action.",
          identityBlock: "Vendor identity",
          restrictionBlock: "Restriction context",
          vendorId: "Email",
          phone: "Phone",
          mainBoutique: "Main store",
          name: "Name",
          status: "Account status",
          verification: "Verification",
          activity: "Active state",
          lastUpdate: "Last update",
          restrictReason: "Restriction reason",
          restrictReasonNone: "No active restriction reason.",
        },
        restrict: {
          reasonLabel: "Restriction reason",
          reasonPlaceholder: "Provide the reason for this account",
          templates: {
            missingInfo: "Missing information",
            lowQuality: "Low quality",
            prohibited: "Prohibited products",
          },
        },
        confirm: {
          actionMessage: "Confirm action for {{vendor}}? {{consequence}}",
          restrictMessage: "Confirm restriction for {{vendor}}? {{consequence}} Reason: {{reason}}",
          confirm: "Confirm",
          cancel: "Cancel",
          processing: "Processing...",
        },
        badges: {
          status: {
            pending: "Pending",
            approved: "Approved",
            suspended: "Suspended",
            unknown: "Unknown",
          },
          verification: {
            preparing: "Preparing",
            in_review: "In review",
            certified: "Certified",
            restricted: "Restricted",
            unknown: "Unknown",
          },
          active: {
            active: "Active",
            inactive: "Inactive",
          },
        },
        labels: {
          na: "Not provided",
          unknownDate: "Date unavailable",
        },
        feedback: {
          loadError: "Unable to load network accounts.",
          reactivateSuccess: "Account reactivated successfully.",
          reactivateError: "Unable to reactivate this account.",
          suspendSuccess: "Account suspended successfully.",
          suspendError: "Unable to suspend this account.",
          activateSuccess: "Account activated successfully.",
          deactivateSuccess: "Account deactivated successfully.",
          unrestrictSuccess: "Restriction removed successfully.",
          activeError: "Unable to change active state.",
          restrictReasonRequired: "Restriction reason is required.",
          restrictSuccess: "Account restricted successfully.",
          restrictError: "Unable to restrict this account.",
        },
      },
    },
    profile: {
      syncQueuedOffline: "Update saved offline. It will sync automatically.",
      updateSuccess: "Profile updated successfully.",
      updateFailed: "Profile update failed.",
      addressNotFound: "Address not found. Please enter a more precise address or pick a suggestion.",
      geocodeFailed: "Geocoding error. Check your internet connection.",
      languageQueuedOffline: "Language updated locally. It will sync once online.",
      languageUpdated: "Language updated.",
      languageUpdateFailed: "Unable to update language.",
      redirecting: "Redirecting...",
      sessionInvalid: "Invalid session - sign in again.",
      incompleteWarning: "Your profile is incomplete. Please complete it.",
      fullnamePlaceholder: "Full name",
      phonePlaceholder: "Phone",
      phoneTitle: "Enter a valid phone number (7 to 15 digits, spaces and dashes allowed)",
      addressPlaceholder: "Full address",
      transportPlaceholder: "-- Choose transport --",
      save: "Save",
      edit: "Edit",
      complete: "Complete",
      editInfo: "Edit my information",
      infoTitleCompact: "Info",
      notificationsByEmail: "Receive email notifications",
      languageHint: "Choose application language.",
      languageUpdating: "Updating...",
      languageImmediate: "Change is applied immediately on this device.",
      supportDescription: "Report an issue in less than 30 seconds. Target reply within 24 business hours.",
      supportCta: "Report an issue",
      securityChangePassword: "Change my password",
      passwordResetRequesting: "Sending...",
      passwordResetRequestSent: "A password reset email has been sent.",
      passwordResetRequestFailed: "Unable to send password reset email.",
      passwordResetMissingEmail: "Email address unavailable.",
      accepted: "Accepted",
      onDate: "on {{date}}",
      viewOnly: "Viewed",
      supportTicketSent: "Support ticket #{{id}} sent.",
      notProvided: "Not provided",
      fullnameLockedByLegal: "Full name is locked after legal terms signature.",
      emailManagedByProvider: "This email address is managed by your login provider.",
      infoStatus: {
        complete: "Profile complete",
        incomplete: "Missing information",
        actionRequired: "Action required",
      },
      emailStatus: {
        verified: "Email verified",
        pending: "Email to verify",
        provider: "Email managed by provider",
      },
      infoLabels: {
        fullname: "Full name",
        email: "Email address",
        phone: "Phone",
        address: "Address",
        transport: "Transport",
        certificationStatus: "Vendor certification status",
      },
      infoSheet: {
        title: "Edit my information",
        description: "This information is used for delivery and account security.",
        save: "Save",
        saving: "Saving...",
      },
      validation: {
        fullnameRequired: "Full name is required.",
        phoneRequired: "Phone is required.",
        phoneInvalid: "Enter a valid phone number.",
        addressRequired: "Address is required.",
        transportRequired: "Transport type is required.",
      },
      avatarUploadFailed: "Avatar upload failed",
      editAvatar: "Edit your avatar",
      avatarAlt: "User avatar",
      greeting: "Hello {{name}}!",
      userFallback: "User",
      desktopSidebarTitle: "Profile navigation",
      desktopSidebarDescription: "Jump quickly between your account sections.",
      desktopSidebarAria: "Profile sections navigation",
      desktopSidebarCompletionLabel: "Completion",
      desktopSidebarCompletionValue: "{{percent}}%",
      desktopQuickActionsTitle: "Quick actions",
      desktopQuickSupport: "Open support",
      desktopQuickSecurity: "Go to security",
      desktopWorkspaceTitle: "Profile workspace",
      desktopWorkspaceSubtitle: "Manage your personal settings from a clear desktop dashboard.",
      desktopTileCompletion: "Profile",
      desktopCompletionReady: "Profile is complete and ready.",
      desktopTileLanguage: "Active language",
      desktopLanguageHint: "Used for interface and messages.",
      desktopTileNotifications: "Notifications",
      desktopTileSync: "Sync",
      desktopStateEnabled: "Enabled",
      desktopStateDisabled: "Disabled",
      desktopStateOnline: "Online",
      desktopStateOffline: "Offline",
      desktopSyncHintOnline: "Changes are sent immediately.",
      desktopSyncHintOffline: "Changes are queued and synced later.",
      sections: {
        info: "My information",
        claimCode: "Generate code",
        certification: "Vendor certification",
        notifications: "Notifications",
        language: "Language",
        support: "Help & support",
        legals: "Legal documents",
        security: "Security",
      },
      transport: {
        bike: "Bike",
        scooter: "Scooter",
        car: "Car",
        truck: "Truck",
        walk: "On foot",
      },
      supportClaim: {
        description: "Use this code for quick identity checks with support.",
        codeLabel: "Support code",
        noCodeHint: "No active code yet. Generate one to start.",
        activeCodeHint: "A code is already active. Regenerate to display a new one.",
        expiresAt: "Expires on: {{date}}",
        generate: "Generate code",
        regenerate: "Regenerate",
        generating: "Generating...",
        copyCta: "Copy code",
        feedback: {
          generateSuccess: "Support code generated successfully.",
          generateFailed: "Unable to generate support code.",
          copySuccess: "Code copied.",
          copyFailed: "Unable to copy code.",
        },
      },
      certification: {
        statusLabel: "Verification status",
        ambassadorClaimDescription: "Generate the vendor code used for ambassador network linking.",
        ambassadorLabel: "Ambassador",
        certifiedByLabel: "Certified by",
        certifiedAtLabel: "Certified on",
        restrictedReasonLabel: "Restriction reason",
        seeDetails: "View details",
        codeLabel: "Network integration code",
        noCodeHint: "No active code yet. Generate one to start.",
        activeCodeHint: "A code is already active. Regenerate to display a new one.",
        expiresAt: "Expires on: {{date}}",
        generate: "Generate code",
        regenerate: "Regenerate",
        generating: "Generating...",
        copyCta: "Copy code",
        feedback: {
          generateSuccess: "Integration code generated successfully.",
          generateFailed: "Unable to generate integration code.",
          copySuccess: "Code copied.",
          copyFailed: "Unable to copy code.",
        },
        status: {
          preparing: "Preparing",
          in_review: "In review",
          certified: "Certified",
          restricted: "Restricted",
          unknown: "Unknown",
        },
      },
      roleSubtitle: {
        client: "Welcome to your customer space",
        vendeur: "Thanks for supporting your local neighborhood",
        livreur: "Delivery also creates local connections",
        ambassadeur: "You are building the local Riveltime network",
        admin: "You are managing platform operations",
      },
    },
    stripe: {
      redirectError: "Stripe redirect failed.",
      genericError: "An unexpected error occurred.",
      sessionExpired: "Session expired. Please sign in again.",
      emailNotVerifiedSync: "Email just verified? Please wait a few seconds and retry.",
      reconnectActionRequired: "Stripe account is unavailable in this environment. Click Activate Stripe to reconnect.",
      serverUnreachable: "Unable to reach the server.",
      reconnectRequired: "Stripe account unavailable in this environment. Reconnection required.",
      manageAccountAria: "Manage my Stripe account",
      manageAccount: "Manage my Stripe account",
      loadingAria: "Stripe loading",
      connecting: "Connecting...",
      activateAria: "Activate Stripe",
      activate: "Activate Stripe",
      dashboardLoadError: "Error while loading Stripe data.",
      connected: "Stripe account connected",
      connectTitle: "Connect to Stripe",
      connectDescription: "Connect your Stripe account to track balances and payouts.",
      summaryTitle: "Financial summary",
      availableBalance: "Available balance",
      pendingAmount: "Pending amount",
      payoutFrequency: "Payout frequency",
      bankAccount: "Linked bank account",
      lastPayouts: "Latest payouts",
      statusLabel: "Status",
      statusPaid: "Paid",
      statusPending: "Pending",
      feesLabel: "Stripe fees",
      transferDestination: "Transferred to your bank account",
      bankAccountMasked: "•••• •••• 1234",
      na: "N/A",
      frequency: {
        daily: "daily",
        weekly: "weekly",
        monthly: "monthly",
        unknown: "unknown",
      },
    },
    paymentMethods: {
      card: "Card",
      cash: "Cash",
      applePay: "Apple Pay",
      googlePay: "Google Pay",
      mealVoucher: "Meal voucher",
      save: "Save",
    },
    home: {
      sessionReturn: {
        title: "Welcome back",
        body: "We brought you back here so you can continue calmly. If your session is still active, you will go straight back to your space.",
        cta: "Resume my session",
      },
      notProvided: "Not provided",
      storeFallback: "Store",
      visual: "visual",
      lastVisit: "Last visit",
      closed: "Closed",
      open: "Open",
      distanceAria: "Distance {{value}} kilometers",
      featuredBadge: "Featured",
      categoryFallback: "this category",
      discoverInCategory: "Discover in {{category}}",
      view: "View",
      featuredProductSubtitle: "Featured promo pick on Riveltime",
      discover: "Discover",
      offer: "Offer",
      sections: {
        recents: "Your recent visits",
        discoverForYou: "Discover for you",
        bestSellers: "Local best sellers",
        allStores: "All stores",
      },
      categories: {
        food: "Food",
        restaurant: "Restaurant",
        fashion: "Fashion",
        health: "Health",
        tech: "Tech",
        mobility: "Mobility",
        diy: "DIY",
        garden: "Garden",
      },
      filters: {
        quickTitle: "Quick actions",
        openNow: "Open now",
        popular: "Popular",
        delivery: "Delivery",
        free: "free",
        nearby: "Nearby",
        categoriesTitle: "Categories",
        distanceOption: "≤ {{km}} km",
      },
      search: {
        defaultPlaceholder: "Search a store or product...",
        morningPlaceholder: "Need something this morning?",
        dayPlaceholder: "Find what you need nearby",
        eveningPlaceholder: "Treat yourself without moving",
        aria: "Search a store or product",
      },
      featuredMessages: {
        1: "A local gem you should discover",
        2: "Passionate craftsmanship, curated selection",
        3: "This is not a typical store...",
        4: "Step in, explore, enjoy",
        5: "Customers love it, you'll see why",
        6: "Picked for you today",
        7: "What if this is your next favorite?",
      },
      announcement: {
        sunny: { title: "Sunny day today", subtitle: "Enjoy the best local spots" },
        rainy: { title: "Rainy today", subtitle: "Get delivered and stay cozy" },
        cold: { title: "Cold outside", subtitle: "Stay warm, we handle the rest" },
        morning: { title: "Good morning", subtitle: "Start your day with a great local pick" },
        evening: { title: "Quiet evening?", subtitle: "Order from your couch" },
      },
      prelaunch: {
        badge: "Coming soon",
        title: "Riveltime is coming soon",
        description: "We are finalizing the local seller and courier network in your area.",
        bannerText: "Riveltime is coming soon",
        bannerAction: "Learn more",
        orderDisabled: "Order (soon)",
        modalHeader: "Riveltime is coming soon",
        modalTitle: "Just a few steps before launch",
        modalDescription: "Progressive opening",
        modalBody: "We are finalizing the local seller and courier network in your area.",
        waitlistLabel: "Stay informed",
        waitlistPlaceholder: "Your email address",
        waitlistHint: "Get notified as soon as Riveltime opens in your area.",
        waitlistSubmit: "Stay informed",
        waitlistSubmitting: "Submitting...",
        waitlistInvalidEmail: "Please enter a valid email address.",
        waitlistSuccessFallback: "Thanks, you will be notified about launch.",
        waitlistErrorFallback: "Unable to subscribe right now.",
        ctaPrimary: "See public preview",
        ctaSecondary: "I am a seller",
        illustrationAlt: "Riveltime prelaunch illustration",
      },
      accountLink: {
        close: "Close",
        modalHeader: "Riveltime is coming soon",
        modalTitle: "This email is already linked to an account",
        modalBody: "To keep a single profile, securely link your sign-in methods.",
        emailLabel: "Detected email",
        linkCta: "Link my sign-in methods",
        signInExistingCta: "Sign in with existing method",
        processing: "Verifying...",
        success: "Linking completed. Please sign in again.",
        errorFallback: "Unable to link these sign-in methods right now.",
      },
    },
    clientHome: {
      prelaunch: {
        badge: "Coming soon",
        title: "Riveltime is coming soon in your area",
        description: "No active stores for now. We are opening progressively, please check back soon.",
        ctaPrimary: "Back to home",
        ctaSecondary: "Join the network",
        illustrationAlt: "Network opening waiting illustration",
      },
    },
  },
  "es-ES": {
    notificationBanner: {
      close: "Cerrar",
      updateAvailable: "Nueva version disponible. Haz clic para actualizar la aplicacion.",
    },
    header: {
      sections: {
        vendor: {
          dashboard: "Panel",
          inventory: "Inventario",
          orders: "Pedidos",
          profile: "Perfil",
          messages: "Mensajes",
        },
        courier: {
          dashboard: "Panel",
          runs: "Rutas",
          route: "Recorrido",
          profile: "Perfil",
          messages: "Mensajes",
        },
        ambassador: {
          dashboard: "Panel",
          network: "Red",
          accounts: "Agregar",
          profile: "Perfil",
        },
      },
      labels: {
        deliverTo: "Entregar a",
      },
      connection: {
        connected: "Conectado",
        reconnecting: "Reconectando...",
        offline: "Sin conexion",
      },
      gps: {
        ok: "GPS OK",
        disabledActivate: "GPS desactivado - Activar",
        unavailableRetry: "GPS no disponible - Reintentar",
        locating: "Localizando...",
        retryTitle: "Reintentar ubicacion",
        activateTitle: "Activar ubicacion",
      },
      boutiques: {
        loading: "Tiendas...",
        count_one: "{{count}} tienda",
        count_other: "{{count}} tiendas",
      },
      address: {
        chooseTitle: "Elegir una direccion de entrega",
        choose: "Elegir una direccion",
        currentSelected: "Direccion actual seleccionada: {{label}}",
        undetermined: "sin definir",
      },
      syncBanner: {
        pending_one: "Sincronizacion pendiente ({{count}} accion).",
        pending_other: "Sincronizacion pendiente ({{count}} acciones).",
        syncing: "Sincronizacion en curso.",
        retryNeeded_one: "Una accion no pudo sincronizarse.",
        retryNeeded_other: "{{count}} acciones no pudieron sincronizarse.",
        blockedActions_one: "Una accion requiere tu atencion.",
        blockedActions_other: "{{count}} acciones requieren tu atencion.",
        viewDetails: "Ver detalles",
        retryNow: "Reintentar",
      },
    },
    offlineQueue: {
      title: "Sincronizacion",
      description: "Tus cambios estan guardados. Se enviaran automaticamente.",
      summary: {
        title: "Estado actual",
        upToDate: "Todo esta al dia.",
        sending: "Enviando...",
        pending_one: "{{count}} actualizacion esta pendiente de envio.",
        pending_other: "{{count}} actualizaciones estan pendientes de envio.",
        attention_one: "{{count}} actualizacion requiere tu atencion.",
        attention_other: "{{count}} actualizaciones requieren tu atencion.",
      },
      badges: {
        upToDate: "Al dia",
        sending: "Enviando",
        pending_one: "{{count}} pendiente",
        pending_other: "{{count}} pendientes",
        attention_one: "{{count}} por revisar",
        attention_other: "{{count}} por revisar",
      },
      status: {
        pending: "Pendiente de envio",
        sending: "Enviando",
        attention: "Requiere tu atencion",
      },
      createdAt: "Guardado el {{date}}",
      empty: "No hay actualizaciones pendientes.",
      error: {
        generic: "Esta actualizacion no pudo enviarse por ahora.",
      },
      cta: {
        sending: "Enviando...",
        retryNow: "Reintentar ahora",
        retry: "Reintentar",
        removeUpdate: "Eliminar esta actualizacion",
        removeFromList: "Quitar de la lista",
      },
      actions: {
        preparing: "Pedido: preparacion",
        markOnTheWay: "Pedido: en reparto",
        delay: "Pedido: ajuste de ETA",
        cancel: "Pedido: cancelacion",
        markDelivered: "Pedido: confirmacion de entrega",
        supportTicket: "Soporte: nuevo reporte",
        updateProfile: "Perfil: actualizacion",
        generic: "Actualizacion",
      },
      technical: {
        toggle: "Detalles tecnicos",
        itemToggle: "Detalles tecnicos de esta actualizacion",
        pendingCount_one: "Pendiente: {{count}}",
        pendingCount_other: "Pendientes: {{count}}",
        failedCount_one: "Fallo temporal: {{count}}",
        failedCount_other: "Fallos temporales: {{count}}",
        blockedCount_one: "Bloqueada: {{count}}",
        blockedCount_other: "Bloqueadas: {{count}}",
        successRate: "Tasa de exito: {{value}}%",
        attempts: "Intentos: {{attempts}}/{{maxAttempts}}",
        priority: "Prioridad: {{value}}",
        aggregateId: "Referencia: {{value}}",
        lastError: "Error tecnico: {{value}}",
        stripeNotice: "Pagos Stripe: confirmacion en linea obligatoria.",
      },
      na: "n/a",
    },
    magicImport: {
      entry: {
        title: "Ahorra tiempo en tu catalogo",
        subtitle: "Importa una foto, PDF o CSV y valida el borrador.",
        cta: "Importar una tienda",
      },
      title: "Generar mi tienda",
      subtitle: "Asistente rapido con revision obligatoria antes de publicar.",
      currentStep: "Paso: {{step}}",
      steps: {
        source: "Elegir fuente",
        upload: "Subir archivo",
        processing: "Analisis",
        review: "Revision",
        publish: "Publicacion",
      },
      source: {
        description: "Elige el origen de los datos.",
        photo: {
          label: "Foto",
          hint: "Menu, ticket o imagen",
        },
        pdf: {
          label: "PDF",
          hint: "Catalogo o menu en PDF",
        },
        csv: {
          label: "CSV",
          hint: "Exportacion de hoja o TPV",
        },
      },
      upload: {
        description: "Sube un archivo y lanza el analisis automatico.",
        selectedSource: "Fuente seleccionada: {{source}}",
        fileAria: "Seleccionar archivo para analizar",
        noFile: "Todavia no hay archivo seleccionado.",
        fileMeta: "Tamano aprox. {{size}} KB",
        previewAlt: "Vista previa del documento importado",
      },
      processing: {
        description: "Estamos preparando un borrador de productos. Tu validas antes de publicar.",
        progressLabel: "Progreso: {{value}}%",
        currentStage: "Subetapa: {{stage}}",
        etaSec: "Tiempo estimado restante: {{value}} s",
        stages: {
          upload: "Preparacion del archivo",
          ocr: "Lectura OCR",
          structuring: "Estructuracion IA",
          reviewPrep: "Verificacion final",
          review: "Revision lista",
        },
      },
      review: {
        itemsCount_one: "{{count}} producto por revisar",
        itemsCount_other: "{{count}} productos por revisar",
        blockingCount: "{{count}} punto(s) por corregir antes de validar",
        noBlockingIssues: "No hay bloqueos. Ya puedes validar la revision.",
        requiredMissingTitle: "Informacion obligatoria faltante",
        blockingRow: "Correccion obligatoria",
        needsReview: "Revisar",
        boutique: {
          title: "Tienda a crear",
          subtitle: "Revisa los datos de la tienda antes de publicar los productos.",
          fields: {
            name: "Nombre de la tienda",
            category: "Categoria de la tienda",
            address: "Direccion de la tienda",
            longitude: "Longitud",
            latitude: "Latitud",
          },
          locationReady: "Ubicacion: lon {{lon}}, lat {{lat}}",
          locationMissing: "Falta la ubicacion. Completa la direccion del vendedor para continuar.",
        },
        required: {
          missing_name: "El nombre es obligatorio.",
          missing_category: "La categoria es obligatoria.",
          invalid_category: "Categoria de tienda invalida.",
          missing_address: "La direccion de la tienda es obligatoria.",
          missing_location: "La ubicacion de la tienda es obligatoria.",
          invalid_price: "Precio de producto invalido.",
          missing_collection_name: "Categoria/coleccion del producto obligatoria.",
          invalid_currency: "Moneda no soportada (EUR o MAD).",
          price_unparsed: "No se pudo interpretar el precio automaticamente.",
        },
        fields: {
          name: "Nombre",
          price: "Precio",
          category: "Coleccion del producto",
          description: "Descripcion",
        },
        options: {
          title: "Opciones sugeridas",
          single: "Eleccion unica",
          multiple: "Eleccion multiple",
          required: "Obligatorio",
          optional: "Opcional",
          maxSelections: "Max {{count}} seleccion(es)",
        },
      },
      publish: {
        readyTitle: "Listo para publicar",
        readyDescription_one: "El borrador incluye {{count}} producto. Ya puedes publicar.",
        readyDescription_other: "El borrador incluye {{count}} productos. Ya puedes publicar.",
        successTitle: "Borrador publicado",
        successDescription_one: "{{count}} producto ya esta listo en tu catalogo.",
        successDescription_other: "{{count}} productos ya estan listos en tu catalogo.",
        publishedAt: "Publicado a las {{value}}",
      },
      actions: {
        close: "Cerrar",
        back: "Atras",
        startAnalysis: "Iniciar analisis",
        retry: "Reintentar",
        readyToPublish: "Validar revision",
        publish: "Publicar",
        publishing: "Publicando...",
        newImport: "Nuevo import",
      },
      status: {
        analyzing: "Analisis en curso",
        review: "Por revisar",
        readyToPublish: "Listo para publicar",
        publishing: "Publicando",
        published: "Publicado",
        failed: "Analisis interrumpido",
      },
      errors: {
        sourceRequired: "Elige una fuente antes de continuar.",
        fileRequired: "Agrega un archivo para empezar.",
        offline: "Se necesita conexion para analizar o publicar.",
        adapterUnavailable: "El modulo de importacion no esta disponible.",
        analysisFailed: "El analisis fallo. Intentalo de nuevo.",
        analysisTooNoisy: "El analisis es demasiado ruidoso para crear un borrador fiable. Prueba con un archivo mas claro.",
        reviewFailed: "No se pudo validar la revision.",
        reviewBlockingRequired: "Corrige los campos obligatorios antes de validar la revision.",
        publishFailed: "La publicacion fallo.",
        publishUnavailable: "Este borrador no esta listo para publicar.",
        publishBlockingRequired: "La publicacion esta bloqueada hasta corregir los campos obligatorios.",
        fileTypeMismatch: "El tipo de archivo no coincide con la fuente seleccionada.",
        fileUnreadable: "El archivo importado ya no esta accesible. Reinicia el import con el documento original.",
        quotaExceeded: "Se alcanzo la cuota diaria de importaciones.",
        noItemsDetected: "No se detectaron filas utilizables en este archivo.",
        generic: "Se produjo un error durante la importacion.",
      },
      confidence: {
        high: "Confianza alta ({{value}}%)",
        medium: "Confianza media ({{value}}%)",
        low: "Confianza baja ({{value}}%)",
      },
      banner: {
        offline: "Estas sin conexion. La importacion continuara al volver la red.",
      },
    },
    gestionProduits: {
      hiddenBadge: "Oculto",
      defaultStoreName: "Tu tienda",
      loadingProducts: "Cargando productos",
      search: {
        label: "Buscar producto",
        placeholder: "Buscar producto...",
      },
      filters: {
        all: "Todos",
      },
      empty: {
        searchNoMatch: "Ningun producto coincide con tu busqueda.",
        noProductsYet: "No hay productos para esta tienda por ahora.",
        noStoreSelectedTitle: "Ninguna tienda seleccionada",
        noStoreSelectedSubtitle: "Elige una tienda arriba para gestionar tus productos.",
        noStoreImageAlt: "Ninguna tienda",
      },
      actions: {
        addStore: "Agregar tienda",
        createStore: "Crear tienda",
        editStore: "Editar tienda",
        addProduct: "Agregar producto",
        editProduct: "Editar",
        showOnStorefront: "Mostrar en vitrina",
        hideFromStorefront: "Ocultar de la vitrina",
        toggleView: "Cambiar vista",
      },
      selector: {
        deselectStore: "Deseleccionar {{name}}",
        storeImageAlt: "Imagen de {{name}}",
        deselectStoreAvatar: "Deseleccionar {{name}} (avatar)",
        vendorFallback: "Vendedor",
        avatarAlt: "Avatar de {{name}}",
        storeAria: "Tienda {{name}}",
      },
      confirm: {
        deleteStoreMessage: "Esta accion eliminara la tienda definitivamente. Confirmar?",
        deleteStore: "Eliminar tienda",
        deleting: "Eliminando...",
      },
      errors: {
        loadingProducts: "Error al cargar productos.",
        unknown: "Ocurrio un error inesperado.",
        saveStoreFailed: "No se pudo guardar la tienda.",
        deleteStoreFailed: "Error al eliminar la tienda.",
        saveProductFailed: "Error al guardar el producto.",
        deleteProductFailed: "Error al eliminar el producto.",
        updateVisibilityFailed: "No se pudo actualizar la visibilidad.",
        missingLocalProduct:
          "No se pudo encontrar este producto localmente. Recarga la lista e intentalo de nuevo.",
      },
      notifications: {
        reconnect: "Reconectar",
        retry: "Reintentar",
        addressSelectionRequired: "Elige una direccion valida de la lista para ubicar la tienda.",
        addressAmbiguous: "Direccion ambigua: elige una sugerencia precisa.",
        addressNotFound: "Direccion no encontrada: elige una sugerencia o reintenta.",
        storeSaved: "Tienda guardada correctamente.",
        storeDeleted: "Tienda eliminada.",
        productUpdated: "Producto actualizado.",
        productAdded: "Producto agregado.",
        productDeleted: "Producto eliminado.",
        productHidden: "Producto ocultado de la vitrina.",
        productVisible: "Producto visible de nuevo.",
        savePrefix: "Error al guardar",
        networkOrServerError: "Error de red o servidor.",
      },
    },
    checkout: {
      saveAddressError: "No se pudo guardar la direccion. Intenta de nuevo en un momento.",
      estimateUpdateError: "No se pudo actualizar la estimacion.",
      loadingUser: "Cargando tu informacion",
      missingData: "No se puede confirmar el pedido: faltan datos.",
      successPaid: "Pago validado. Gracias por tu pedido.",
      title: "Confirmacion del pedido",
      deliveryAddress: "Direccion de entrega",
      chooseAddress: "Elegir direccion",
      estimateUpdating: "Actualizando estimacion...",
      changeAddress: "Cambiar",
      orderDetails: "Detalles del pedido",
      deliveryFeeLabel: "Costo de entrega {{vehicle}} - {{boutique}}",
      storeFallback: "Tienda",
      participationLabel: "Aporte de {{boutique}}",
      totalToPay: "Total a pagar",
      saveAddressPromptTitle: "Pedido confirmado - guardar esta direccion?",
      saveAddressPromptDescription: "Para reutilizarla en un toque la proxima vez",
      home: "Casa",
      work: "Trabajo",
      later: "Mas tarde",
    },
    checkoutForm: {
      paymentGenericError: "Ocurrio un error de pago.",
      cardInsufficientFunds: "Tarjeta rechazada: fondos insuficientes.",
      cardDeclined: "Tarjeta rechazada por tu banco.",
      cardInvalidCvc: "CVC invalido. Verifica y reintenta.",
      cardExpired: "Esta tarjeta ha expirado.",
      processingGenericError: "Ocurrio un error de procesamiento.",
      preparePaymentError: "Error al preparar el pago.",
      missingPrerequisites: "Faltan datos o Stripe no esta listo.",
      addressRequired: "Elige una direccion de entrega para continuar.",
      cardFieldMissing: "No se encontro el campo de tarjeta.",
      paymentIntentMissing: "Stripe no devolvio un id de pago.",
      unexpectedConfirmError: "Error inesperado durante la confirmacion del pago.",
      createOrderError: "Error al crear el pedido.",
      orderConfirmed: "Pedido validado correctamente.",
      processing: "Procesando...",
      chooseAddress: "Elegir direccion",
      pay: "Pagar",
    },
    deliveryClient: {
      justNow: "ahora mismo",
      secondsSuffix: "s",
      minutesSuffix: "min",
      hoursSuffix: "h",
      ordersCountLabel: "pedidos",
      emptyOrdersForStatus: "No hay pedidos {{status}}.",
      orderNumber: "Pedido n° {{number}}",
      placedOn: "Realizado el {{date}}",
      placedOnLabel: "Realizado el: {{date}}",
      orderPaused: "Pedido en pausa: el tratamiento esta suspendido temporalmente.",
      deliverBefore: "Entregar antes de {{time}}",
      driverDelay: "{{value}} min reportados",
      preparationEstimated: "Preparacion estimada",
      minutesValue: "{{value}} min",
      products: "Productos",
      deliveryFee: "Costo de entrega",
      totalPaid: "Total pagado",
      lastPositionReceived: "Ultima posicion recibida hace {{age}}.",
      deliveryCode: "Codigo de entrega",
      cancel: "Cancelar pedido",
      cancelling: "Cancelando...",
      cancelQueued: "Cancelacion en espera de sincronizacion.",
      cancelImpossible: "Cancelacion no disponible.",
      cancelSuccess: "Pedido cancelado.",
      tabs: {
        inProgress: "En curso",
        history: "Historial",
      },
    },
    deliveryCourier: {
      noCurrentDelivery: "No hay entregas en curso",
      noCurrentDeliveryDescription: "Las entregas asignadas apareceran aqui en cuanto haya un pedido disponible.",
      noDeliveryAlt: "Sin entregas",
      goToCourses: "Ir a repartos",
      noDeliveryForStatus: "No hay entregas para este estado",
      noDeliveryForStatusDescription: "Todavia no hay entregas que coincidan con este filtro.",
      badges: {
        toPickup: "Para recoger",
        toDeliver: "Para entregar",
        paused: "En pausa",
      },
      orderNumber: "Pedido n° {{number}}",
      status: {
        accepted: "Aceptado",
        preparing: "Preparacion",
        onTheWay: "En camino",
        onHold: "En pausa",
      },
      syncPending: "Sincronizacion pendiente",
      onHoldNotice: "Pedido en pausa: no hay acciones posibles hasta reactivacion o reasignacion por admin.",
      preparationEstimated: "Preparacion estimada",
      minutesValue: "{{value}} min",
      readyAround: "listo sobre {{time}}",
      address: "Direccion",
      totalLabel: "Total:",
      store: "Tienda",
      client: "Cliente",
      unknownNumber: "Numero desconocido",
      unknownTime: "desconocida",
      deliverBefore: "Entregar antes de {{time}}",
      delayReported: "{{value}} min reportados",
      delayQuestion: "Retraso?",
      minutesPlus: "+{{value}} min",
      processing: "Procesando...",
      orderPickedUp: "Pedido recogido",
      validationCodePlaceholder: "Codigo de validacion",
      deliver: "Entregar",
      tabs: {
        inProgress: "En curso",
        history: "Historial",
      },
      deliveryCount_one: "entrega",
      deliveryCount_other: "entregas",
      validationCodeRequired: "Introduce el codigo de validacion.",
      actionQueuedOffline: "Accion guardada sin conexion. Sincronizacion automatica.",
      orderPickupSuccess: "Pedido recogido con exito",
      actionImpossible: "Accion no disponible.",
      deliveryQueued: "Entrega en espera de sincronizacion.",
      deliveryConfirmed: "Entrega confirmada",
      validationImpossible: "Validacion imposible.",
      paymentUnavailableDoNotDeliver: "Pago no disponible. No entregar. Devuelve el paquete a la tienda; soporte compensara tras confirmacion.",
      unexpectedError: "Error: {{message}}",
      etaSavedQueued: "ETA guardado ({{value}} min), pendiente de sincronizacion.",
      etaAdjusted: "ETA ajustado ({{value}} min)",
      adjustImpossible: "Ajuste no disponible",
      incidentTitle: "Pedido cancelado - pago no disponible",
      todoTitle: "A hacer",
      todoNoDeliver: "No entregar al cliente.",
      todoReturnPackage: "Devolver el paquete a la tienda.",
      todoSupportCompensation: "Soporte compensara despues de la confirmacion de la tienda.",
      reportSent: "Incidente enviado al soporte.",
      reportError: "Error al enviar el incidente.",
      reportSentDone: "Incidente enviado",
      sending: "Enviando...",
      reportIncident: "Reportar incidente",
      backToFlow: "Volver al flujo",
      storeLabel: "Tienda: {{value}}",
      clientLabel: "Cliente: {{value}}",
      courierTotal: "Total repartidor: {{amount}}",
      avatarAltStore: "Avatar de {{value}}",
      avatarAltClient: "Avatar de {{value}}",
    },
    deliveryVendor: {
      justNow: "ahora",
      secondsSuffix: "s",
      minutesSuffix: "min",
      hoursSuffix: "h",
      status: {
        accepted: "Aceptado",
        onHold: "En pausa",
        preparing: "Preparado",
        onTheWay: "En reparto",
        delivered: "Entregado",
        cancelled: "Cancelado",
      },
      incidentTitle: "Pedido cancelado",
      incidentDefaultMessage: "Pago no disponible. No preparar el pedido.",
      todoTitle: "Tareas",
      todoNoPrepare: "No preparar / no enviar.",
      todoInformCourier: "Informar al repartidor si es necesario de que el pedido esta cancelado.",
      understood: "Entendido",
      preparationTime: "Tiempo de preparacion",
      preparationHint: "Indica una estimacion para el cliente y el repartidor.",
      cancel: "Cancelar",
      actionQueuedOffline: "Accion guardada sin conexion. Sincronizacion automatica.",
      incidentPaymentUnavailable: "Pedido cancelado: pago no disponible. No preparar.",
      actionImpossible: "Accion no disponible.",
      validate: "Validar",
      emptyForStatus: "No hay pedidos {{status}}",
      emptyText: {
        accepted: "Los pedidos apareceran aqui cuando un cliente haga uno.",
        onHold: "Los pedidos en pausa apareceran aqui.",
        preparing: "Aun no marcaste pedidos como en preparacion.",
        onTheWay: "Los pedidos en reparto apareceran aqui.",
        delivered: "Ningun pedido fue marcado como entregado aun.",
        cancelled: "No cancelaste pedidos recientemente.",
      },
      noOrderAlt: "Sin pedidos",
      orderNumber: "Pedido n° {{number}}",
      unknownStatus: "Estado desconocido",
      syncPending: "Sincronizacion pendiente",
      lastPositionReceived: "Ultima posicion recibida hace {{age}}.",
      onHoldNotice: "Pedido en pausa: procesamiento suspendido (cuenta inactiva o reasignacion en curso).",
      clientPromise: "Promesa al cliente: {{time}}",
      driverDelay: "{{value}} min reportado",
      preparationEstimated: "Preparacion estimada",
      minutesValue: "{{value}} min",
      readyAround: "listo hacia {{time}}",
      products: "Productos",
      deliveryFee: "Costo de entrega",
      riveltimeCommission: "Comision Riveltime",
      vendorNet: "Neto vendedor",
      deliverer: "Repartidor",
      avatarAlt: "Avatar de {{value}}",
      client: "Cliente",
      cancelQueued: "Cancelacion en espera de sincronizacion.",
      cancelImpossible: "Cancelacion no disponible.",
      markPreparing: "En preparacion",
      storeFilterLabel: "Tienda",
      storeFilterAll: "Todas",
      unknownStore: "Tienda desconocida",
    },
    orderCard: {
      orderNumber: "Pedido #{{id}}",
      placedOn: "Realizado el {{date}}",
      store: "Tienda",
      deliveryFee: "Costo de entrega",
      vendorContribution: "Aporte del vendedor",
      storeTotal: "Total tienda",
      paymentStatusLabel: "Estado de pago:",
      deliveryStatusLabel: "Estado de entrega:",
      orderTotal: "Total del pedido:",
      paymentStatus: {
        authorized: "Autorizado",
        succeeded: "Pagado",
        canceled: "Cancelado",
        failed: "Fallido",
        unknown: "Desconocido",
      },
      deliveryStatus: {
        pending: "Pendiente",
        accepted: "Aceptado",
        preparing: "En preparacion",
        on_the_way: "En camino",
        delivered: "Entregado",
        cancelled: "Cancelado",
        on_hold: "En pausa",
        unknown: "Desconocido",
      },
    },
    userForm: {
      fullname: "Nombre completo",
      phone: "Telefono",
      phoneTitle: "Introduce un telefono valido (7 a 15 digitos)",
      fullAddress: "Direccion completa",
      addressPlaceholder: "Introduce una direccion",
      category: "Categoria",
      selectCategory: "-- Selecciona una categoria --",
      categories: {
        alimentation: "Alimentacion",
        mobiliteElectrique: "Movilidad electrica",
        pretAPorter: "Moda",
        informatique: "Informatica",
        restaurantTraiteur: "Restaurante / Catering",
        pharmacieSante: "Farmacia / Salud",
        bricolageMaison: "Bricolaje / Hogar",
        fleuristeJardin: "Floristeria / Jardin",
      },
      transportType: "Tipo de transporte",
      selectTransport: "-- Elige un transporte --",
      transports: {
        bike: "Bicicleta",
        scooter: "Scooter",
        car: "Coche",
        truck: "Camion",
        walk: "A pie",
      },
      save: "Guardar mi informacion",
      errors: {
        noAddressSuggestion: "No se encontraron sugerencias",
        searchError: "Error de busqueda",
      },
    },
    orderMutations: {
      actionQueuedOffline: "Accion guardada sin conexion.",
      orderNotFound: "Pedido no encontrado.",
      preparingError: "Error al pasar a preparacion",
      onTheWayError: "Error al pasar a reparto",
      invalidDelta: "Delta invalido",
      adjustEtaError: "Error al ajustar el ETA",
      missingCode: "Codigo faltante",
      deliveryQueued: "Entrega en espera de sincronizacion.",
      deliveryError: "Error durante la entrega",
      cancelError: "Error al cancelar",
    },
    orderQueries: {
      adminOrdersLoadError: "No se pudieron cargar los pedidos admin.",
      ordersLoadError: "No se pudieron cargar los pedidos.",
      driverAssignedLoadError: "No se pudieron cargar las entregas.",
      syncWarnings: {
        adminOrdersSessionExpired:
          "La sesion expiro: no se pueden actualizar los pedidos. Inicia sesion de nuevo.",
        adminOrdersCache: "No se pueden actualizar los pedidos (mostrando cache).",
        vendorOrdersSessionExpired:
          "La sesion expiro: no se pueden actualizar los pedidos. Inicia sesion de nuevo.",
        vendorOrdersCache: "No se pueden actualizar los pedidos (mostrando cache).",
        clientOrdersSessionExpired:
          "La sesion expiro: no se pueden actualizar tus pedidos. Inicia sesion de nuevo.",
        clientOrdersCache: "No se pueden actualizar tus pedidos (mostrando cache).",
        driverAssignedSessionExpired:
          "La sesion expiro: no se pueden actualizar tus entregas. Inicia sesion de nuevo.",
        driverAssignedCache:
          "No se pueden actualizar tus entregas (mostrando cache).",
      },
    },
    adminCatalogue: {
      title: "Tiendas y productos",
      subtitle: "Catalogo global con filtros y acciones rapidas.",
      tabs: {
        stores: "Tiendas",
        products: "Productos",
      },
      searchPlaceholder: "Buscar (nombre, tienda, vendedor, email)",
      loading: "Cargando",
      vendorFallback: "Vendedor",
      storeFallback: "Tienda",
      storeClosure: "Cierre",
      hidden: "Oculto",
      emptyStores: "No hay tiendas.",
      emptyProducts: "No hay productos.",
      errors: {
        load: "No se pudo cargar el catalogo.",
        updateStore: "No se pudo actualizar la tienda.",
        updateProduct: "No se pudo actualizar el producto.",
      },
    },
    liveSocket: {
      inactiveVendor: "Cuenta inactiva: tus tiendas estan ocultas y los pedidos bloqueados.",
      inactiveCourier: "Cuenta inactiva: no hay repartos disponibles hasta reactivar la cuenta.",
      reactivated: "Cuenta reactivada.",
      deactivated: "Cuenta desactivada.",
      realtimeUnavailableSubscription: "Tiempo real no disponible (suscripcion de posiciones)",
      retry: "Reintentar",
      diagnosticCopied: "Diagnostico copiado",
      copyDiagnosticPrompt: "Copia este diagnostico:",
      diagnosticTitle: "Diagnostico Socket.IO",
      diagnosticDescription: "Comparte este bloque (captura o copia) para identificar por que falla el polling.",
      close: "Cerrar",
      copy: "Copiar",
      ok: "OK",
    },
    userStore: {
      emailAlreadyLinkedOtherAccount: "Este correo ya esta asociado a otra cuenta. Inicia sesion con el metodo correcto o solicita un enlace de acceso.",
    },
    apiErrors: {
      unknown: "Ocurrio un error inesperado.",
      codes: {
        ACTIVE_ORDERS: "Eliminacion bloqueada: hay pedidos activos.",
        ACCOUNT_DELETED_OR_MISSING: "Cuenta inexistente o eliminada. Inicia sesion de nuevo.",
        EMAIL_NOT_VERIFIED: "Verifica tu correo para continuar.",
        INVALID_TOKEN: "Sesion invalida. Inicia sesion de nuevo.",
        SESSION_EXPIRED: "Sesion expirada. Inicia sesion de nuevo.",
        SUPPORT_COOLDOWN: "Estas enviando demasiado rapido. Reintenta en unos segundos.",
        SUPPORT_RATE_LIMIT_USER: "Demasiados reportes recientes. Reintenta mas tarde.",
        SUPPORT_RATE_LIMIT_IP: "Limite de reportes alcanzado para esta conexion. Reintenta mas tarde.",
        PRELAUNCH_EMAIL_INVALID: "Correo electronico invalido.",
        PRELAUNCH_SUBSCRIBE_FAILED: "No se pudo registrar tu correo por ahora.",
        LINK_SESSION_INVALID: "Sesion de vinculacion invalida.",
        LINK_SESSION_EXPIRED: "La sesion de vinculacion expiro. Inicia de nuevo.",
        LINK_CONFIRMATION_REQUIRED: "Se requiere confirmacion para vincular estos metodos de acceso.",
        LINK_FORBIDDEN: "La vinculacion de cuenta fue rechazada para esta solicitud.",
        LINK_FAILED: "No se pudo completar la vinculacion de metodos de acceso.",
        LINK_ALREADY_DONE: "Estos metodos de acceso ya estan vinculados.",
        LINK_RATE_LIMITED: "Demasiados intentos de vinculacion. Intentalo de nuevo pronto.",
        AMBASSADOR_DETACH_FAILED: "No se pudo completar la eliminacion de la cuenta ahora. Intentalo de nuevo o contacta al admin.",
        INVALID_TARGET_AMBASSADOR: "Embajador destino invalido o no disponible.",
        VENDOR_ALREADY_ASSIGNED_TO_TARGET: "Este vendedor ya esta vinculado a este embajador.",
        VENDOR_IDS_REQUIRED: "Debes seleccionar vendedores para transferir.",
        VENDOR_BULK_LIMIT_EXCEEDED: "Hay demasiados vendedores para una transferencia masiva.",
        VENDOR_REASSIGN_BULK_FAILED: "La transferencia masiva fallo.",
        ORDER_CANCEL_CLIENT_PENDING_ONLY: "Solo puedes cancelar un pedido que siga pendiente.",
        ORDER_PAYMENT_CAPTURED_CANCEL_IMPOSSIBLE: "El pago ya fue capturado: no se puede cancelar.",
        ORDER_CANCEL_FORBIDDEN: "No tienes permiso para cancelar este pedido.",
        ORDER_CANCEL_VENDOR_INACTIVE: "Cuenta inactiva: cancelacion bloqueada.",
        ORDER_CANCEL_SERVER_ERROR: "Error del servidor al cancelar el pedido.",
      },
    },
    addressSheet: {
      home: "Casa",
      work: "Trabajo",
      searchError: "No se pudo buscar direccion. Revisa tu conexion.",
      geoUnavailable: "Ubicacion no disponible - escribe una direccion.",
      geoDenied: "Ubicacion denegada - puedes escribir una direccion.",
      myLocation: "Mi ubicacion",
      myLocationFast: "Mi ubicacion (mas rapido)",
      addressFallback: "Direccion",
      mapSelectedPoint: "Punto seleccionado",
      mapUnavailable: "Mapa no disponible en este dispositivo.",
      searchPlaceholder: "Direccion, ciudad, pais",
      searchAria: "Buscar direccion",
      searching: "Buscando...",
      noResults: "Sin resultados. Prueba numero + calle + ciudad.",
      locating: "Localizando...",
      howToEnable: "Como activar?",
      adjustMap: "Ajustar en el mapa",
      title: "Direccion de entrega",
      description: "Para calcular costo y plazo.",
      currentAddress: "Actual: {{label}}",
      chooseForEstimate: "Elige una direccion para estimar la entrega",
      emptyRecents: "Tus direcciones apareceran aqui.",
      mapLoadingAria: "Cargando mapa",
      back: "Volver",
      confirmPoint: "Confirmar este punto",
    },
    cityStore: {
      defaultCity: "Tu ciudad",
      geolocationUnsupported: "La geolocalizacion no es compatible con este navegador.",
      invalidCoords: "El GPS devolvio coordenadas no validas.",
      reverseGeocodeFailed: "No se pudo recuperar el nombre de la ciudad.",
      geolocationError: "Error de geolocalizacion.",
      permissionDenied:
        "Permiso denegado. Activa la ubicacion en los ajustes y vuelve a intentarlo.",
      positionUnavailable:
        "Posicion no disponible (GPS/red). Intentalo cerca de una ventana.",
      timeout: "Tiempo agotado. Intentalo de nuevo.",
    },
    locationModal: {
      title: "Activar ubicacion",
      body: "Para usar \"Mi ubicacion\", permite acceso a ubicacion. Si no, escribe una direccion.",
      iosTitle: "iPhone (PWA / Safari / Chrome)",
      iosStep1: "Abre Ajustes.",
      iosStep2: "Elige Safari o Chrome.",
      iosStep3: "Abre Ubicacion.",
      iosStep4: "Selecciona \"Mientras se usa la app\".",
      iosStep5: "Vuelve a Riveltime y reintenta.",
      androidTitle: "Android / Desktop",
      androidStep1: "Haz clic en el icono de candado en la barra.",
      androidStep2: "Abre ajustes del sitio.",
      androidStep3: "Pon ubicacion en permitir.",
      androidStep4: "Recarga la pagina si hace falta.",
      later: "Mas tarde",
      wait: "Espera...",
      retry: "Reintentar",
    },
    admin: {
      pageTitle: "Cuentas",
      pageSubtitle: "Clientes, vendedores, repartidores: validacion y control.",
      emptyTitle: "Sin usuarios",
      emptySubtitle: "Ajusta la busqueda o los filtros.",
      retry: "Reintentar",
      searchPlaceholder: "Buscar cuenta (nombre o correo)...",
      searchAria: "Buscar cuenta",
      clearSearch: "Limpiar busqueda",
      deleteConfirm: "Esta accion es irreversible. Confirmar eliminacion de cuenta?",
      unknownName: "Nombre desconocido",
      identity: {
        title: "Identidad de acceso",
        subtitle: "Datos enviados por el proveedor de identidad cuando existen.",
        provider: "Proveedor",
        providerUnknown: "Proveedor desconocido",
        displayName: "Nombre",
        nickname: "Alias",
        email: "Correo",
        emailUnavailable: "Correo no disponible",
        providerUserId: "ID del proveedor",
        auth0Id: "ID de Auth0",
        notProvided: "No proporcionado",
      },
      providers: {
        google: "Google",
        auth0: "Auth0",
        apple: "Apple",
        facebook: "Facebook",
        linkedin: "LinkedIn",
        other: "Otro",
      },
      accountValidated: "Cuenta validada",
      account: "Cuenta",
      close: "Cerrar",
      closeAria: "Cerrar modal de cuenta",
      activeStatus: "Estado activo",
      activeToggleAria: "Activar o desactivar esta cuenta",
      active: "Activo",
      inactive: "Inactivo",
      createdOn: "Creado el",
      phone: "Telefono",
      approving: "Validando...",
      updating: "Actualizando...",
      deleteDisabledForAdmin: "La eliminacion de cuentas admin esta bloqueada.",
      feedback: {
        approveSuccess: "Cuenta validada correctamente.",
        activateSuccess: "Cuenta activada correctamente.",
        deactivateSuccess: "Cuenta desactivada correctamente.",
      },
      accountHolder: {
        title: "Titular de la cuenta",
        subtitle: "Ingresa el nombre y apellido del titular.",
        firstName: "Nombre",
        lastName: "Apellido",
        firstNamePlaceholder: "Ej: Amira",
        lastNamePlaceholder: "Ej: Fkir",
        firstNameRequired: "El nombre es obligatorio.",
        lastNameRequired: "El apellido es obligatorio.",
        save: "Guardar",
        saving: "Guardando...",
        updateSuccess: "Titular de la cuenta actualizado.",
        updateError: "No se pudo actualizar el titular de la cuenta.",
      },
      approve: "Validar",
      ok: "OK",
      delete: "Eliminar",
      transfer: {
        title: "Transferir vendedores",
        subtitle: "Reasigna un vendedor a otro embajador con motivo obligatorio.",
        actions: {
          enableMode: "Modo transferir",
          disableMode: "Salir del modo",
          processing: "Procesando...",
        },
        filters: {
          sourceAmbassador: "Embajador origen",
          sourceAll: "Todos los embajadores",
          sourceUnassigned: "Vendedores sin asignar",
          handover: "Handover",
          handoverAll: "Todos",
          handoverPending: "Pendientes",
          handoverNotPending: "Tratados",
        },
        bulk: {
          targetLabel: "Nuevo embajador",
          targetPlaceholder: "Selecciona un embajador",
          reasonLabel: "Motivo del traspaso",
          reasonPlaceholder: "Ej: continuidad comercial local",
          selectAllVisible: "Seleccionar visibles",
          clearSelection: "Limpiar seleccion",
          submit: "Transferir ({{count}})",
          selectVendor: "Seleccionar vendedor",
          unselectVendor: "Quitar vendedor de la seleccion",
        },
        single: {
          title: "Transferir este vendedor",
          subtitle: "El traspaso actualiza la red sin cambiar el estado de verificacion.",
          currentAmbassador: "Embajador actual",
          targetLabel: "Embajador destino",
          targetPlaceholder: "Selecciona un embajador",
          reasonLabel: "Motivo",
          reasonPlaceholder: "Motivo obligatorio",
          submit: "Transferir vendedor",
          noAmbassadorAvailable: "No hay embajadores disponibles para este traspaso.",
        },
        labels: {
          unassigned: "Sin asignar",
        },
        errors: {
          targetRequired: "Selecciona un embajador destino.",
          reasonRequired: "El motivo es obligatorio (minimo 3 caracteres).",
        },
        confirm: {
          message: "Confirmar transferencia de {{count}} vendedor(es)? Motivo: {{reason}}",
          confirm: "Confirmar",
          cancel: "Cancelar",
          processing: "Transfiriendo...",
        },
        feedback: {
          selectionRequired: "Selecciona al menos un vendedor.",
          targetRequired: "Selecciona un embajador destino.",
          singleSuccess: "Vendedor transferido correctamente.",
          singleError: "No se pudo transferir este vendedor.",
          bulkSuccess: "{{count}} vendedor(es) transferidos correctamente.",
          bulkPartial: "{{success}} transferencia(s) correctas, {{failed}} con error.",
          bulkError: "La transferencia masiva fallo.",
        },
      },
      roles: {
        all: "Todos",
        client: "Clientes",
        vendeur: "Vendedores",
        livreur: "Repartidores",
        admin: "Admin",
        ambassadeur: "Embajadores",
        unknown: "Desconocido",
      },
      status: {
        approved: "Validado",
        pending: "Pendiente",
        suspended: "Suspendido",
        unknown: "Desconocido",
      },
      errors: {
        loadUsers: "No se pudieron cargar los usuarios. Reintenta.",
        approveUser: "Error al validar usuario.",
        toggleActive: "No se pudo cambiar el estado activo.",
        deleteUser: "Error al eliminar usuario.",
      },
    },
    ambassador: {
      dashboard: {
        title: "Panel embajador",
        subtitle: "Sigue el rendimiento de tu red local.",
        kpis: {
          sectionTitle: "KPI globales",
          monthlyRevenue: "Facturacion mensual",
          ordersCount: "Numero de pedidos",
          averageBasket: "Ticket medio",
          growthRate: "Tasa de crecimiento",
          ambassadorCommission: "Comision generada (4%)",
          total: "Total red",
          inReview: "En revision",
          certified: "Certificados",
          restricted: "Restringidos",
        },
        period: {
          label: "Periodo",
        },
        search: {
          label: "Busqueda rapida",
          placeholder: "Nombre, correo o telefono",
          cta: "Buscar en cuentas",
        },
        actions: {
          refresh: "Actualizar",
          openNetwork: "Integrar vendedor",
          manageNetwork: "Gestionar mi red",
        },
        activity: {
          title: "Actividad reciente",
          empty: "No hay actividad reciente por ahora.",
          statusPrefix: "Accion: {{status}}",
        },
        activityKinds: {
          preparing: "Perfil en preparacion",
          in_review: "Cuenta en revision",
          certified: "Vendedor certificado",
          restricted: "Cuenta restringida",
          unknown: "Actualizacion",
        },
        states: {
          loading: "Cargando indicadores...",
          retry: "Reintentar",
        },
        labels: {
          na: "No informado",
          unknownDate: "Fecha no disponible",
        },
        feedback: {
          loadError: "No se pudieron cargar los KPI del panel.",
        },
      },
      network: {
        title: "Red de vendedores",
        subtitle: "Usa solo el codigo de integracion de red del vendedor.",
        form: {
          title: "Agregar vendedor a tu red",
          whereToFind: "El vendedor encuentra este codigo en su perfil, seccion Generar codigo.",
          claimCodeLabel: "Codigo vendedor (6 digitos)",
          claimCodePlaceholder: "Ej: 493821",
          claimCodeHint: "Introduce solo los 6 digitos.",
          resolve: "Validar codigo",
          resolving: "Validando...",
        },
        states: {
          loading: "Verificando codigo...",
          success: "Codigo valido. Vendedor listo para certificar.",
          error: "No se pudo validar este codigo.",
          expired: "Codigo expirado. Pide al vendedor regenerarlo.",
          used: "Codigo ya usado. Pide un nuevo codigo.",
        },
        preview: {
          title: "Vista previa vendedor",
          vendorLabel: "Vendedor",
          emailLabel: "Correo",
          phoneLabel: "Telefono",
          accountStatusLabel: "Estado de cuenta",
          verificationStatusLabel: "Estado de verificacion",
          activityLabel: "Visibilidad",
          mainBoutiqueLabel: "Tienda principal",
          completenessLabel: "Completitud",
          claimExpiresAtLabel: "Expiracion codigo",
          resolutionExpiresAtLabel: "Expiracion sesion",
        },
        labels: {
          na: "No informado",
        },
        activity: {
          active: "Activo",
          inactive: "Inactivo",
        },
        verificationStatus: {
          preparing: "En preparacion",
          in_review: "En revision",
          certified: "Certificado",
          restricted: "Restringido",
          unknown: "Desconocido",
        },
        accountStatus: {
          pending: "Pendiente",
          approved: "Aprobado",
          suspended: "Suspendido",
          unknown: "Desconocido",
        },
        actions: {
          certify: "Certificar",
          certifying: "Certificando...",
          requestCorrection: "Pedir correccion",
          requestingCorrection: "Solicitando...",
          restrict: "Restringir",
          restricting: "Restringiendo...",
        },
        restrict: {
          reasonLabel: "Motivo de restriccion",
          reasonPlaceholder: "Explica por que esta cuenta debe restringirse",
        },
        feedback: {
          codeRequired: "Introduce un codigo de vendedor para continuar.",
          resolveSuccess: "Vendedor encontrado. Ya puedes confirmar la certificacion.",
          resolveError: "No se pudo resolver este codigo de vendedor.",
          certifySuccess: "Vendedor certificado y activado en tu red.",
          certifyError: "La certificacion fallo.",
          correctionSuccess: "Cuenta puesta en correccion pendiente de actualizacion del vendedor.",
          correctionError: "No se pudo solicitar correccion.",
          restrictSuccess: "Cuenta restringida correctamente.",
          restrictError: "No se pudo restringir esta cuenta.",
          restrictReasonRequired: "El motivo de restriccion es obligatorio.",
          vendorMissing: "No hay vendedor seleccionado.",
        },
      },
      accounts: {
        title: "Mi red",
        subtitle: "Gestiona tus vendedores con acciones simples y rapidas.",
        count: "{{count}} vendedores",
        scopeNotice: "Solo ves vendedores de tu propia red.",
        filters: {
          searchLabel: "Busqueda de vendedor",
          searchPlaceholder: "Nombre, correo o telefono",
          quick: {
            all: "Todos",
            in_review: "En revision",
            certified: "Certificados",
            restricted: "Restringidos",
            inactive: "Inactivos",
          },
          statusLabel: "Estado de cuenta",
          verificationLabel: "Estado de verificacion",
          activeLabel: "Estado activo",
          status: {
            all: "Todos",
            pending: "Pendientes",
            approved: "Aprobadas",
            suspended: "Suspendidas",
          },
          verification: {
            all: "Todos",
            preparing: "En preparacion",
            inReview: "En revision",
            certified: "Certificados",
            restricted: "Restringidos",
          },
          active: {
            all: "Todos",
            active: "Activos",
            inactive: "Inactivos",
          },
        },
        actions: {
          applyFilters: "Aplicar",
          resetFilters: "Reiniciar",
          refresh: "Actualizar",
          reactivate: "Reactivar cuenta",
          suspend: "Suspender cuenta",
          activate: "Activar cuenta",
          deactivate: "Desactivar cuenta",
          unrestrict: "Quitar restriccion",
          details: "Detalles",
          hideDetails: "Ocultar",
          restrict: "Restringir cuenta",
          consequences: {
            reactivate: "El vendedor vuelve a estar visible.",
            suspend: "La cuenta queda suspendida hasta su correccion.",
            activate: "El vendedor vuelve a estar visible.",
            deactivate: "El vendedor queda oculto.",
            unrestrict: "El vendedor vuelve a estar operativo.",
            restrict: "La cuenta queda suspendida hasta su correccion.",
          },
        },
        list: {
          title: "Vendedores de la red",
          statusLine: "{{status}} • {{verification}}",
          mainBoutiqueFallback: "Tienda principal no informada",
        },
        states: {
          loading: "Cargando cuentas...",
          empty: "No hay vendedores con estos filtros.",
          emptyDescription: "Tu red esta vacia por ahora. Agrega vendedores para comenzar.",
          emptyAlt: "Sin vendedor",
          emptyCta: "Agregar vendedor",
          retry: "Reintentar",
        },
        details: {
          title: "Detalle de cuenta",
          sheetTitle: "Detalles del vendedor",
          sheetSubtitle: "Revisa la informacion antes de confirmar una accion.",
          identityBlock: "Identidad del vendedor",
          restrictionBlock: "Contexto de restriccion",
          vendorId: "Correo",
          phone: "Telefono",
          mainBoutique: "Tienda principal",
          name: "Nombre",
          status: "Estado de cuenta",
          verification: "Verificacion",
          activity: "Estado activo",
          lastUpdate: "Ultima actualizacion",
          restrictReason: "Motivo de restriccion",
          restrictReasonNone: "No hay motivo de restriccion activo.",
        },
        restrict: {
          reasonLabel: "Motivo de restriccion",
          reasonPlaceholder: "Indica el motivo para esta cuenta",
          templates: {
            missingInfo: "Informacion faltante",
            lowQuality: "Calidad insuficiente",
            prohibited: "Productos prohibidos",
          },
        },
        confirm: {
          actionMessage: "Confirmar accion para {{vendor}}? {{consequence}}",
          restrictMessage: "Confirmar restriccion para {{vendor}}? {{consequence}} Motivo: {{reason}}",
          confirm: "Confirmar",
          cancel: "Cancelar",
          processing: "Procesando...",
        },
        badges: {
          status: {
            pending: "Pendiente",
            approved: "Aprobada",
            suspended: "Suspendida",
            unknown: "Desconocido",
          },
          verification: {
            preparing: "En preparacion",
            in_review: "En revision",
            certified: "Certificado",
            restricted: "Restringido",
            unknown: "Desconocido",
          },
          active: {
            active: "Activo",
            inactive: "Inactivo",
          },
        },
        labels: {
          na: "No informado",
          unknownDate: "Fecha no disponible",
        },
        feedback: {
          loadError: "No se pudieron cargar las cuentas de la red.",
          reactivateSuccess: "Cuenta reactivada correctamente.",
          reactivateError: "No se pudo reactivar esta cuenta.",
          suspendSuccess: "Cuenta suspendida correctamente.",
          suspendError: "No se pudo suspender esta cuenta.",
          activateSuccess: "Cuenta activada correctamente.",
          deactivateSuccess: "Cuenta desactivada correctamente.",
          unrestrictSuccess: "Restriccion levantada correctamente.",
          activeError: "No se pudo cambiar el estado activo.",
          restrictReasonRequired: "El motivo de restriccion es obligatorio.",
          restrictSuccess: "Cuenta restringida correctamente.",
          restrictError: "No se pudo restringir esta cuenta.",
        },
      },
    },
    profile: {
      syncQueuedOffline: "Actualizacion guardada sin conexion. Se sincronizara automaticamente.",
      updateSuccess: "Perfil actualizado correctamente.",
      updateFailed: "La actualizacion del perfil fallo.",
      addressNotFound: "Direccion no encontrada. Introduce una direccion mas precisa o elige una sugerencia.",
      geocodeFailed: "Error de geocodificacion. Revisa tu conexion.",
      languageQueuedOffline: "Idioma actualizado localmente. Se sincronizara al volver la red.",
      languageUpdated: "Idioma actualizado.",
      languageUpdateFailed: "No se pudo actualizar el idioma.",
      redirecting: "Redireccionando...",
      sessionInvalid: "Sesion invalida - vuelve a iniciar sesion.",
      incompleteWarning: "Tu perfil esta incompleto. Completalo.",
      fullnamePlaceholder: "Nombre completo",
      phonePlaceholder: "Telefono",
      phoneTitle: "Introduce un telefono valido (7 a 15 digitos, espacios y guiones permitidos)",
      addressPlaceholder: "Direccion completa",
      transportPlaceholder: "-- Elige transporte --",
      save: "Guardar",
      edit: "Editar",
      complete: "Completar",
      editInfo: "Editar mi informacion",
      infoTitleCompact: "Info",
      notificationsByEmail: "Recibir alertas por email",
      languageHint: "Elige el idioma de la aplicacion.",
      languageUpdating: "Actualizando...",
      languageImmediate: "El cambio se aplica inmediatamente en este dispositivo.",
      supportDescription: "Reporta un problema en menos de 30 segundos. Respuesta objetivo en 24 horas habiles.",
      supportCta: "Reportar un problema",
      securityChangePassword: "Cambiar mi contrasena",
      passwordResetRequesting: "Enviando...",
      passwordResetRequestSent: "Se ha enviado un correo para restablecer la contrasena.",
      passwordResetRequestFailed: "No se pudo enviar el correo de restablecimiento.",
      passwordResetMissingEmail: "Direccion de correo no disponible.",
      accepted: "Aceptado",
      onDate: "el {{date}}",
      viewOnly: "Consulta",
      supportTicketSent: "Ticket de soporte #{{id}} enviado.",
      notProvided: "No informado",
      fullnameLockedByLegal: "El nombre completo queda bloqueado tras la firma de los terminos.",
      emailManagedByProvider: "Este correo esta gestionado por tu proveedor de acceso.",
      infoStatus: {
        complete: "Perfil completo",
        incomplete: "Informacion faltante",
        actionRequired: "Accion requerida",
      },
      emailStatus: {
        verified: "Correo verificado",
        pending: "Correo por verificar",
        provider: "Correo gestionado por proveedor",
      },
      infoLabels: {
        fullname: "Nombre completo",
        email: "Correo electronico",
        phone: "Telefono",
        address: "Direccion",
        transport: "Transporte",
        certificationStatus: "Estado de certificacion del vendedor",
      },
      infoSheet: {
        title: "Editar mi informacion",
        description: "Estos datos se usan para la entrega y la seguridad de la cuenta.",
        save: "Guardar",
        saving: "Guardando...",
      },
      validation: {
        fullnameRequired: "El nombre completo es obligatorio.",
        phoneRequired: "El telefono es obligatorio.",
        phoneInvalid: "Introduce un telefono valido.",
        addressRequired: "La direccion es obligatoria.",
        transportRequired: "El tipo de transporte es obligatorio.",
      },
      avatarUploadFailed: "Fallo al subir el avatar",
      editAvatar: "Editar tu avatar",
      avatarAlt: "Avatar de usuario",
      greeting: "Hola {{name}}!",
      userFallback: "Usuario",
      desktopSidebarTitle: "Navegacion del perfil",
      desktopSidebarDescription: "Accede rapido a las secciones de tu cuenta.",
      desktopSidebarAria: "Navegacion de secciones del perfil",
      desktopSidebarCompletionLabel: "Completado",
      desktopSidebarCompletionValue: "{{percent}}%",
      desktopQuickActionsTitle: "Acciones rapidas",
      desktopQuickSupport: "Abrir soporte",
      desktopQuickSecurity: "Ir a seguridad",
      desktopWorkspaceTitle: "Espacio de perfil",
      desktopWorkspaceSubtitle: "Gestiona tus ajustes personales desde un panel claro en escritorio.",
      desktopTileCompletion: "Perfil",
      desktopCompletionReady: "Perfil completo y operativo.",
      desktopTileLanguage: "Idioma activo",
      desktopLanguageHint: "Se usa para interfaz y mensajes.",
      desktopTileNotifications: "Notificaciones",
      desktopTileSync: "Sincronizacion",
      desktopStateEnabled: "Activadas",
      desktopStateDisabled: "Desactivadas",
      desktopStateOnline: "En linea",
      desktopStateOffline: "Sin conexion",
      desktopSyncHintOnline: "Los cambios se envian al instante.",
      desktopSyncHintOffline: "Los cambios se encolan y se sincronizan luego.",
      sections: {
        info: "Mi informacion",
        claimCode: "Generar codigo",
        certification: "Certificacion vendedor",
        notifications: "Notificaciones",
        language: "Idioma",
        support: "Ayuda y soporte",
        legals: "Documentos legales",
        security: "Seguridad",
      },
      transport: {
        bike: "Bicicleta",
        scooter: "Scooter",
        car: "Coche",
        truck: "Camion",
        walk: "A pie",
      },
      supportClaim: {
        description: "Usa este codigo para identificarte rapidamente con soporte.",
        codeLabel: "Codigo de soporte",
        noCodeHint: "No hay codigo activo. Genera uno para empezar.",
        activeCodeHint: "Ya hay un codigo activo. Regeneralo para mostrar uno nuevo.",
        expiresAt: "Expira el: {{date}}",
        generate: "Generar codigo",
        regenerate: "Regenerar",
        generating: "Generando...",
        copyCta: "Copiar codigo",
        feedback: {
          generateSuccess: "Codigo de soporte generado correctamente.",
          generateFailed: "No se pudo generar el codigo de soporte.",
          copySuccess: "Codigo copiado.",
          copyFailed: "No se pudo copiar el codigo.",
        },
      },
      certification: {
        statusLabel: "Estado de verificacion",
        ambassadorClaimDescription: "Genera el codigo de vendedor para la integracion en la red del embajador.",
        ambassadorLabel: "Embajador",
        certifiedByLabel: "Certificado por",
        certifiedAtLabel: "Certificado el",
        restrictedReasonLabel: "Motivo de restriccion",
        seeDetails: "Ver detalles",
        codeLabel: "Codigo de integracion de red",
        noCodeHint: "No hay codigo activo. Genera uno para empezar.",
        activeCodeHint: "Ya hay un codigo activo. Regeneralo para mostrar uno nuevo.",
        expiresAt: "Expira el: {{date}}",
        generate: "Generar codigo",
        regenerate: "Regenerar",
        generating: "Generando...",
        copyCta: "Copiar codigo",
        feedback: {
          generateSuccess: "Codigo de integracion generado correctamente.",
          generateFailed: "No se pudo generar el codigo de integracion.",
          copySuccess: "Codigo copiado.",
          copyFailed: "No se pudo copiar el codigo.",
        },
        status: {
          preparing: "En preparacion",
          in_review: "En revision",
          certified: "Certificado",
          restricted: "Restringido",
          unknown: "Desconocido",
        },
      },
      roleSubtitle: {
        client: "Bienvenido a tu espacio cliente",
        vendeur: "Gracias por impulsar tu barrio",
        livreur: "Repartir tambien crea conexion local",
        ambassadeur: "Estas construyendo la red local de Riveltime",
        admin: "Estas coordinando las operaciones de la plataforma",
      },
    },
    stripe: {
      redirectError: "Error al redirigir a Stripe.",
      genericError: "Ha ocurrido un error.",
      sessionExpired: "Sesion expirada. Vuelve a iniciar sesion para continuar.",
      emailNotVerifiedSync: "Tu correo acaba de verificarse? Espera unos segundos y reintenta.",
      reconnectActionRequired: "La cuenta Stripe no esta disponible en este entorno. Pulsa Activar Stripe para reconectar.",
      serverUnreachable: "No se puede contactar con el servidor.",
      reconnectRequired: "Cuenta Stripe no disponible en este entorno. Se requiere reconexion.",
      manageAccountAria: "Gestionar mi cuenta Stripe",
      manageAccount: "Gestionar mi cuenta Stripe",
      loadingAria: "Cargando Stripe",
      connecting: "Conectando...",
      activateAria: "Activar Stripe",
      activate: "Activar Stripe",
      dashboardLoadError: "Error al cargar datos de Stripe.",
      connected: "Cuenta Stripe conectada",
      connectTitle: "Conexion a Stripe",
      connectDescription: "Conecta tu cuenta Stripe para seguir tus saldos y transferencias.",
      summaryTitle: "Resumen financiero",
      availableBalance: "Saldo disponible",
      pendingAmount: "Importe pendiente",
      payoutFrequency: "Frecuencia de transferencias",
      bankAccount: "Cuenta bancaria asociada",
      lastPayouts: "Ultimas transferencias",
      statusLabel: "Estado",
      statusPaid: "Pagado",
      statusPending: "Pendiente",
      feesLabel: "Comisiones Stripe",
      transferDestination: "Transferido a tu cuenta bancaria",
      bankAccountMasked: "•••• •••• 1234",
      na: "N/A",
      frequency: {
        daily: "diario",
        weekly: "semanal",
        monthly: "mensual",
        unknown: "desconocido",
      },
    },
    paymentMethods: {
      card: "Tarjeta",
      cash: "Efectivo",
      applePay: "Apple Pay",
      googlePay: "Google Pay",
      mealVoucher: "Vale comida",
      save: "Guardar",
    },
    home: {
      sessionReturn: {
        title: "Encantados de verte de nuevo",
        body: "Te hemos traido aqui para que continues con calma. Si tu sesion sigue activa, volveras directamente a tu espacio.",
        cta: "Reanudar mi sesion",
      },
      notProvided: "No informado",
      storeFallback: "Comercio",
      visual: "visual",
      lastVisit: "Ultima visita",
      closed: "Cerrado",
      open: "Abierto",
      distanceAria: "Distancia {{value}} kilometros",
      featuredBadge: "Seleccion",
      categoryFallback: "esta categoria",
      discoverInCategory: "Descubrir en {{category}}",
      view: "Ver",
      featuredProductSubtitle: "Favorito en promocion en Riveltime",
      discover: "Descubrir",
      offer: "Oferta",
      sections: {
        recents: "Tus visitas recientes",
        discoverForYou: "Descubrir para ti",
        bestSellers: "Best sellers locales",
        allStores: "Todos los comercios",
      },
      categories: {
        food: "Alimentacion",
        restaurant: "Restaurante",
        fashion: "Moda",
        health: "Salud",
        tech: "Informatica",
        mobility: "Movilidad",
        diy: "Bricolaje",
        garden: "Jardin",
      },
      filters: {
        quickTitle: "Acciones rapidas",
        openNow: "Abierto ahora",
        popular: "Popular",
        delivery: "Entrega",
        free: "gratis",
        nearby: "Cerca",
        categoriesTitle: "Categorias",
        distanceOption: "≤ {{km}} km",
      },
      search: {
        defaultPlaceholder: "Buscar comercio o producto...",
        morningPlaceholder: "Necesitas algo esta manana?",
        dayPlaceholder: "Encuentra lo que necesitas cerca",
        eveningPlaceholder: "Date un gusto sin moverte",
        aria: "Buscar comercio o producto",
      },
      featuredMessages: {
        1: "Una joya local para descubrir",
        2: "Artesania con pasion, seleccion cuidada",
        3: "No es una tienda como las demas...",
        4: "Entra, explora y disfruta",
        5: "A los clientes les encanta, veras por que",
        6: "Solo para ti hoy",
        7: "Y si aqui esta tu proximo favorito?",
      },
      announcement: {
        sunny: { title: "Hace buen tiempo hoy", subtitle: "Disfruta las mejores direcciones locales" },
        rainy: { title: "Hoy llueve", subtitle: "Recibe tu pedido y quedate comodo" },
        cold: { title: "Hace frio afuera", subtitle: "Quedate caliente, nosotros nos ocupamos" },
        morning: { title: "Buenos dias", subtitle: "Empieza el dia con una buena direccion local" },
        evening: { title: "Noche tranquila?", subtitle: "Pide desde tu sofa" },
      },
      prelaunch: {
        badge: "Llega pronto",
        title: "Riveltime llega pronto",
        description: "Estamos finalizando la red local de vendedores y repartidores en tu zona.",
        bannerText: "Riveltime llega pronto",
        bannerAction: "Saber mas",
        orderDisabled: "Pedir (pronto)",
        modalHeader: "Riveltime llega pronto",
        modalTitle: "Solo unos pasos para la apertura",
        modalDescription: "Apertura progresiva",
        modalBody: "Estamos finalizando la red local de vendedores y repartidores en tu zona.",
        waitlistLabel: "Mantenerme informado",
        waitlistPlaceholder: "Tu correo electronico",
        waitlistHint: "Recibe una alerta cuando Riveltime abra en tu zona.",
        waitlistSubmit: "Mantenerme informado",
        waitlistSubmitting: "Enviando...",
        waitlistInvalidEmail: "Ingresa un correo electronico valido.",
        waitlistSuccessFallback: "Gracias, te avisaremos del lanzamiento.",
        waitlistErrorFallback: "No se pudo registrar tu correo por ahora.",
        ctaPrimary: "Ver vista publica",
        ctaSecondary: "Soy vendedor",
        illustrationAlt: "Ilustracion de prelanzamiento de Riveltime",
      },
      accountLink: {
        close: "Cerrar",
        modalHeader: "Riveltime llega pronto",
        modalTitle: "Este correo ya esta vinculado a una cuenta",
        modalBody: "Para mantener un solo perfil, vincula de forma segura tus metodos de acceso.",
        emailLabel: "Correo detectado",
        linkCta: "Vincular mis metodos de acceso",
        signInExistingCta: "Entrar con el metodo existente",
        processing: "Verificando...",
        success: "Vinculacion completada. Inicia sesion de nuevo.",
        errorFallback: "No se pudo vincular estos metodos de acceso ahora.",
      },
    },
    clientHome: {
      prelaunch: {
        badge: "Llega pronto",
        title: "Riveltime llega pronto a tu zona",
        description: "No hay tiendas activas por ahora. Abrimos progresivamente, vuelve pronto.",
        ctaPrimary: "Volver al inicio",
        ctaSecondary: "Quiero unirme a la red",
        illustrationAlt: "Ilustracion de espera para apertura de red",
      },
    },
  },
  ar: {
    notificationBanner: {
      close: "اغلاق",
      updateAvailable: "يتوفر اصدار جديد. انقر لتحديث التطبيق.",
    },
    header: {
      sections: {
        vendor: {
          dashboard: "لوحة التحكم",
          inventory: "المخزون",
          orders: "الطلبات",
          profile: "الملف",
          messages: "الرسائل",
        },
        courier: {
          dashboard: "لوحة التحكم",
          runs: "المهام",
          route: "المسار",
          profile: "الملف",
          messages: "الرسائل",
        },
        ambassador: {
          dashboard: "لوحة التحكم",
          network: "الشبكة",
          accounts: "إضافة",
          profile: "الملف",
        },
      },
      labels: {
        deliverTo: "التوصيل الى",
      },
      connection: {
        connected: "متصل",
        reconnecting: "اعادة الاتصال...",
        offline: "غير متصل",
      },
      gps: {
        ok: "GPS OK",
        disabledActivate: "GPS معطل - تفعيل",
        unavailableRetry: "GPS غير متاح - اعد المحاولة",
        locating: "جار تحديد الموقع...",
        retryTitle: "اعد محاولة تحديد الموقع",
        activateTitle: "تفعيل تحديد الموقع",
      },
      boutiques: {
        loading: "المتاجر...",
        count_one: "{{count}} متجر",
        count_other: "{{count}} متجر",
      },
      address: {
        chooseTitle: "اختر عنوان التوصيل",
        choose: "اختر عنوانا",
        currentSelected: "العنوان الحالي المحدد: {{label}}",
        undetermined: "غير محدد",
      },
      syncBanner: {
        pending_one: "مزامنة قيد الانتظار ({{count}} اجراء).",
        pending_other: "مزامنة قيد الانتظار ({{count}} اجراءات).",
        syncing: "المزامنة قيد التنفيذ.",
        retryNeeded_one: "تعذر مزامنة اجراء واحد.",
        retryNeeded_other: "تعذر مزامنة {{count}} اجراءات.",
        blockedActions_one: "يوجد اجراء يتطلب انتباهك.",
        blockedActions_other: "توجد {{count}} اجراءات تتطلب انتباهك.",
        viewDetails: "عرض التفاصيل",
        retryNow: "اعادة المحاولة",
      },
    },
    offlineQueue: {
      title: "المزامنة",
      description: "تم حفظ التغييرات. سيتم ارسالها تلقائيا.",
      summary: {
        title: "الحالة الحالية",
        upToDate: "كل شيء محدث.",
        sending: "جار الارسال...",
        pending_one: "يوجد {{count}} تحديث بانتظار الارسال.",
        pending_other: "توجد {{count}} تحديثات بانتظار الارسال.",
        attention_one: "يوجد {{count}} تحديث يتطلب انتباهك.",
        attention_other: "توجد {{count}} تحديثات تتطلب انتباهك.",
      },
      badges: {
        upToDate: "محدث",
        sending: "جار الارسال",
        pending_one: "{{count}} بانتظار الارسال",
        pending_other: "{{count}} بانتظار الارسال",
        attention_one: "{{count}} للمراجعة",
        attention_other: "{{count}} للمراجعة",
      },
      status: {
        pending: "بانتظار الارسال",
        sending: "جار الارسال",
        attention: "يتطلب انتباهك",
      },
      createdAt: "تم الحفظ في {{date}}",
      empty: "لا توجد تحديثات بانتظار الارسال.",
      error: {
        generic: "تعذر ارسال هذا التحديث حاليا.",
      },
      cta: {
        sending: "جار الارسال...",
        retryNow: "اعادة المحاولة الان",
        retry: "اعادة المحاولة",
        removeUpdate: "حذف هذا التحديث",
        removeFromList: "ازالة من القائمة",
      },
      actions: {
        preparing: "طلب: التحضير",
        markOnTheWay: "طلب: بدأ التوصيل",
        delay: "طلب: تعديل وقت الوصول",
        cancel: "طلب: الغاء",
        markDelivered: "طلب: تاكيد التسليم",
        supportTicket: "الدعم: بلاغ جديد",
        updateProfile: "الملف: تحديث",
        generic: "تحديث",
      },
      technical: {
        toggle: "تفاصيل تقنية",
        itemToggle: "تفاصيل تقنية لهذا التحديث",
        pendingCount_one: "بانتظار الارسال: {{count}}",
        pendingCount_other: "بانتظار الارسال: {{count}}",
        failedCount_one: "فشل مؤقت: {{count}}",
        failedCount_other: "فشل مؤقت: {{count}}",
        blockedCount_one: "محجوب: {{count}}",
        blockedCount_other: "محجوبة: {{count}}",
        successRate: "نسبة النجاح: {{value}}%",
        attempts: "المحاولات: {{attempts}}/{{maxAttempts}}",
        priority: "الاولوية: {{value}}",
        aggregateId: "المرجع: {{value}}",
        lastError: "خطا تقني: {{value}}",
        stripeNotice: "مدفوعات Stripe: يلزم تاكيد عبر الاتصال.",
      },
      na: "n/a",
    },
    magicImport: {
      entry: {
        title: "وفر الوقت في الكتالوج",
        subtitle: "استورد صورة او PDF او CSV ثم راجع المسودة قبل النشر.",
        cta: "استيراد متجر",
      },
      title: "انشاء متجري",
      subtitle: "مساعد سريع مع مراجعة الزامية قبل النشر.",
      currentStep: "المرحلة: {{step}}",
      steps: {
        source: "اختيار المصدر",
        upload: "رفع الملف",
        processing: "التحليل",
        review: "المراجعة",
        publish: "النشر",
      },
      source: {
        description: "اختر مصدر بيانات المنتجات.",
        photo: {
          label: "صورة",
          hint: "قائمة او ايصال او صورة",
        },
        pdf: {
          label: "PDF",
          hint: "كتالوج او قائمة بصيغة PDF",
        },
        csv: {
          label: "CSV",
          hint: "تصدير جدول او نظام نقاط البيع",
        },
      },
      upload: {
        description: "ارفع ملفا واحدا ثم ابدأ التحليل التلقائي.",
        selectedSource: "المصدر المختار: {{source}}",
        fileAria: "اختيار ملف للتحليل",
        noFile: "لم يتم اختيار ملف بعد.",
        fileMeta: "الحجم التقريبي {{size}} كيلوبايت",
        previewAlt: "معاينة الملف المستورد",
      },
      processing: {
        description: "نقوم بتحضير مسودة منتجات. ستقوم بالمراجعة قبل النشر.",
        progressLabel: "التقدم: {{value}}%",
        currentStage: "المرحلة الفرعية: {{stage}}",
        etaSec: "الوقت المتبقي التقريبي: {{value}} ث",
        stages: {
          upload: "تجهيز الملف",
          ocr: "قراءة OCR",
          structuring: "هيكلة بالذكاء الاصطناعي",
          reviewPrep: "التحقق النهائي",
          review: "المراجعة جاهزة",
        },
      },
      review: {
        itemsCount_one: "{{count}} منتج للمراجعة",
        itemsCount_other: "{{count}} منتجات للمراجعة",
        blockingCount: "يوجد {{count}} عنصر(عناصر) يجب تصحيحه قبل التاكيد",
        noBlockingIssues: "لا توجد مشاكل مانعة. يمكنك تاكيد المراجعة.",
        requiredMissingTitle: "بيانات مطلوبة غير مكتملة",
        blockingRow: "تصحيح مطلوب",
        needsReview: "تحتاج مراجعة",
        boutique: {
          title: "المتجر الذي سيتم انشاؤه",
          subtitle: "راجع بيانات المتجر قبل نشر المنتجات.",
          fields: {
            name: "اسم المتجر",
            category: "فئة المتجر",
            address: "عنوان المتجر",
            longitude: "خط الطول",
            latitude: "خط العرض",
          },
          locationReady: "الموقع: خط طول {{lon}}، خط عرض {{lat}}",
          locationMissing: "الموقع غير متوفر. اكمل عنوان البائع للمتابعة.",
        },
        required: {
          missing_name: "الاسم مطلوب.",
          missing_category: "الفئة مطلوبة.",
          invalid_category: "فئة المتجر غير صالحة.",
          missing_address: "عنوان المتجر مطلوب.",
          missing_location: "موقع المتجر مطلوب.",
          invalid_price: "سعر المنتج غير صالح.",
          missing_collection_name: "فئة/مجموعة المنتج مطلوبة.",
          invalid_currency: "العملة غير مدعومة (EUR او MAD).",
          price_unparsed: "تعذر قراءة السعر تلقائيا.",
        },
        fields: {
          name: "الاسم",
          price: "السعر",
          category: "مجموعة المنتج",
          description: "الوصف",
        },
        options: {
          title: "خيارات مقترحة",
          single: "اختيار واحد",
          multiple: "اختيارات متعددة",
          required: "اجباري",
          optional: "اختياري",
          maxSelections: "الحد الاقصى {{count}} اختيار",
        },
      },
      publish: {
        readyTitle: "جاهز للنشر",
        readyDescription_one: "المسودة تحتوي على {{count}} منتج. يمكنك النشر الان.",
        readyDescription_other: "المسودة تحتوي على {{count}} منتجات. يمكنك النشر الان.",
        successTitle: "تم نشر المسودة",
        successDescription_one: "تم تجهيز {{count}} منتج في الكتالوج.",
        successDescription_other: "تم تجهيز {{count}} منتجات في الكتالوج.",
        publishedAt: "تم النشر عند {{value}}",
      },
      actions: {
        close: "اغلاق",
        back: "رجوع",
        startAnalysis: "بدء التحليل",
        retry: "اعادة المحاولة",
        readyToPublish: "تاكيد المراجعة",
        publish: "نشر",
        publishing: "جار النشر...",
        newImport: "استيراد جديد",
      },
      status: {
        analyzing: "التحليل قيد التنفيذ",
        review: "بانتظار المراجعة",
        readyToPublish: "جاهز للنشر",
        publishing: "جار النشر",
        published: "تم النشر",
        failed: "توقف التحليل",
      },
      errors: {
        sourceRequired: "اختر مصدرا قبل المتابعة.",
        fileRequired: "اضف ملفا للبدء.",
        offline: "الاتصال مطلوب للتحليل او النشر.",
        adapterUnavailable: "وحدة الاستيراد غير متاحة حاليا.",
        analysisFailed: "فشل التحليل. حاول مرة اخرى.",
        analysisTooNoisy: "التحليل يحتوي على ضوضاء عالية ولا يمكن إنشاء مسودة موثوقة. استخدم ملفا اوضح.",
        reviewFailed: "تعذر تاكيد المراجعة.",
        reviewBlockingRequired: "صحح الحقول المطلوبة قبل تاكيد المراجعة.",
        publishFailed: "فشل النشر.",
        publishUnavailable: "هذه المسودة غير جاهزة للنشر.",
        publishBlockingRequired: "النشر متوقف حتى تصحيح الحقول المطلوبة.",
        fileTypeMismatch: "نوع الملف لا يطابق المصدر المحدد.",
        fileUnreadable: "الملف المستورد لم يعد متاحا. اعد بدء الاستيراد باستخدام الملف الاصلي.",
        quotaExceeded: "تم الوصول الى الحد اليومي للاستيراد.",
        noItemsDetected: "لم يتم العثور على صفوف قابلة للاستخدام في هذا الملف.",
        generic: "حدث خطا اثناء الاستيراد.",
      },
      confidence: {
        high: "ثقة عالية ({{value}}%)",
        medium: "ثقة متوسطة ({{value}}%)",
        low: "ثقة منخفضة ({{value}}%)",
      },
      banner: {
        offline: "لا يوجد اتصال. ستستكمل عملية الاستيراد عند عودة الشبكة.",
      },
    },
    gestionProduits: {
      hiddenBadge: "مخفي",
      defaultStoreName: "متجرك",
      loadingProducts: "جار تحميل المنتجات",
      search: {
        label: "ابحث عن منتج",
        placeholder: "ابحث عن منتج...",
      },
      filters: {
        all: "الكل",
      },
      empty: {
        searchNoMatch: "لا يوجد منتج يطابق بحثك.",
        noProductsYet: "لا توجد منتجات لهذا المتجر حاليا.",
        noStoreSelectedTitle: "لم يتم اختيار متجر",
        noStoreSelectedSubtitle: "اختر متجرا من الاعلى لادارة المنتجات.",
        noStoreImageAlt: "لا يوجد متجر",
      },
      actions: {
        addStore: "اضافة متجر",
        createStore: "انشاء متجر",
        editStore: "تعديل المتجر",
        addProduct: "اضافة منتج",
        editProduct: "تعديل",
        showOnStorefront: "اظهار في الواجهة",
        hideFromStorefront: "اخفاء من الواجهة",
        toggleView: "تبديل العرض",
      },
      selector: {
        deselectStore: "الغاء تحديد {{name}}",
        storeImageAlt: "صورة {{name}}",
        deselectStoreAvatar: "الغاء تحديد {{name}} (الصورة الرمزية)",
        vendorFallback: "بائع",
        avatarAlt: "الصورة الرمزية لـ {{name}}",
        storeAria: "متجر {{name}}",
      },
      confirm: {
        deleteStoreMessage: "سيتم حذف المتجر نهائيا. هل تؤكد؟",
        deleteStore: "حذف المتجر",
        deleting: "جار الحذف...",
      },
      errors: {
        loadingProducts: "خطا اثناء تحميل المنتجات.",
        unknown: "حدث خطا غير متوقع.",
        saveStoreFailed: "تعذر حفظ المتجر.",
        deleteStoreFailed: "خطا اثناء حذف المتجر.",
        saveProductFailed: "خطا اثناء حفظ المنتج.",
        deleteProductFailed: "خطا اثناء حذف المنتج.",
        updateVisibilityFailed: "تعذر تحديث الظهور.",
        missingLocalProduct:
          "تعذر العثور على هذا المنتج محليا. اعد تحميل القائمة ثم حاول مرة اخرى.",
      },
      notifications: {
        reconnect: "اعادة الاتصال",
        retry: "اعادة المحاولة",
        addressSelectionRequired: "اختر عنوانا صحيحا من القائمة لتحديد موقع المتجر.",
        addressAmbiguous: "العنوان غير واضح: اختر اقتراحا دقيقا.",
        addressNotFound: "العنوان غير موجود: اختر اقتراحا او اعد المحاولة.",
        storeSaved: "تم حفظ المتجر بنجاح.",
        storeDeleted: "تم حذف المتجر.",
        productUpdated: "تم تحديث المنتج.",
        productAdded: "تمت اضافة المنتج.",
        productDeleted: "تم حذف المنتج.",
        productHidden: "تم اخفاء المنتج من الواجهة.",
        productVisible: "اصبح المنتج ظاهرا مجددا.",
        savePrefix: "فشل الحفظ",
        networkOrServerError: "خطا في الشبكة او الخادم.",
      },
    },
    checkout: {
      saveAddressError: "تعذر حفظ العنوان. حاول مرة اخرى بعد قليل.",
      estimateUpdateError: "تعذر تحديث التقدير.",
      loadingUser: "جار تحميل معلوماتك",
      missingData: "لا يمكن تاكيد الطلب: بيانات ناقصة.",
      successPaid: "تم تاكيد الدفع. شكرا لطلبك.",
      title: "تاكيد الطلب",
      deliveryAddress: "عنوان التوصيل",
      chooseAddress: "اختر عنوانا",
      estimateUpdating: "جار تحديث التقدير...",
      changeAddress: "تغيير",
      orderDetails: "تفاصيل الطلب",
      deliveryFeeLabel: "رسوم التوصيل {{vehicle}} - {{boutique}}",
      storeFallback: "متجر",
      participationLabel: "مساهمة {{boutique}}",
      totalToPay: "الاجمالي للدفع",
      saveAddressPromptTitle: "تم تاكيد الطلب - حفظ هذا العنوان؟",
      saveAddressPromptDescription: "لتجده بسرعة في المرة القادمة",
      home: "المنزل",
      work: "العمل",
      later: "لاحقا",
    },
    checkoutForm: {
      paymentGenericError: "حدث خطا في الدفع.",
      cardInsufficientFunds: "تم رفض البطاقة: الرصيد غير كاف.",
      cardDeclined: "تم رفض البطاقة من البنك.",
      cardInvalidCvc: "رمز CVC غير صحيح. تحقق وحاول مرة اخرى.",
      cardExpired: "هذه البطاقة منتهية.",
      processingGenericError: "حدث خطا في المعالجة.",
      preparePaymentError: "خطا اثناء تجهيز الدفع.",
      missingPrerequisites: "بيانات ناقصة او Stripe غير جاهز.",
      addressRequired: "اختر عنوان توصيل للمتابعة.",
      cardFieldMissing: "حقل البطاقة غير موجود.",
      paymentIntentMissing: "لم يرجع Stripe معرف دفع.",
      unexpectedConfirmError: "خطا غير متوقع اثناء تاكيد الدفع.",
      createOrderError: "خطا اثناء انشاء الطلب.",
      orderConfirmed: "تم تاكيد الطلب بنجاح.",
      processing: "جار المعالجة...",
      chooseAddress: "اختر عنوانا",
      pay: "ادفع",
    },
    deliveryClient: {
      justNow: "الان",
      secondsSuffix: "ث",
      minutesSuffix: "د",
      hoursSuffix: "س",
      ordersCountLabel: "طلبات",
      emptyOrdersForStatus: "لا توجد طلبات {{status}}.",
      orderNumber: "طلب رقم {{number}}",
      placedOn: "تم الطلب في {{date}}",
      placedOnLabel: "تم الطلب في: {{date}}",
      orderPaused: "الطلب في وضع التجميد: المعالجة متوقفة مؤقتا.",
      deliverBefore: "التسليم قبل {{time}}",
      driverDelay: "تم الابلاغ عن {{value}} دقيقة",
      preparationEstimated: "التحضير المتوقع",
      minutesValue: "{{value}} دقيقة",
      products: "المنتجات",
      deliveryFee: "رسوم التوصيل",
      totalPaid: "الاجمالي المدفوع",
      lastPositionReceived: "اخر موقع تم استلامه منذ {{age}}.",
      deliveryCode: "رمز التسليم",
      cancel: "الغاء الطلب",
      cancelling: "جار الالغاء...",
      cancelQueued: "تم وضع الالغاء في انتظار المزامنة.",
      cancelImpossible: "تعذر الالغاء.",
      cancelSuccess: "تم الغاء الطلب.",
      tabs: {
        inProgress: "قيد التنفيذ",
        history: "السجل",
      },
    },
    deliveryCourier: {
      noCurrentDelivery: "لا توجد عمليات توصيل جارية",
      noCurrentDeliveryDescription: "ستظهر عمليات التوصيل المعينة هنا بمجرد توفر طلب.",
      noDeliveryAlt: "لا توجد عمليات توصيل",
      goToCourses: "الانتقال الى الجولات",
      noDeliveryForStatus: "لا توجد عمليات توصيل لهذه الحالة",
      noDeliveryForStatusDescription: "لا توجد عمليات توصيل مطابقة لهذا الفلتر حاليا.",
      badges: {
        toPickup: "للاستلام",
        toDeliver: "للتسليم",
        paused: "معلق",
      },
      orderNumber: "طلب رقم {{number}}",
      status: {
        accepted: "مقبول",
        preparing: "قيد التحضير",
        onTheWay: "في الطريق",
        onHold: "معلق",
      },
      syncPending: "مزامنة قيد الانتظار",
      onHoldNotice: "الطلب معلق: لا يمكن اتخاذ اجراء حتى اعادة التفعيل او اعادة التعيين من الادمن.",
      preparationEstimated: "التحضير المتوقع",
      minutesValue: "{{value}} دقيقة",
      readyAround: "جاهز حوالي {{time}}",
      address: "العنوان",
      totalLabel: "الاجمالي:",
      store: "المتجر",
      client: "العميل",
      unknownNumber: "رقم غير معروف",
      unknownTime: "غير معروف",
      deliverBefore: "سلم قبل {{time}}",
      delayReported: "تم الابلاغ عن {{value}} دقيقة",
      delayQuestion: "تاخير؟",
      minutesPlus: "+{{value}} دقيقة",
      processing: "جار المعالجة...",
      orderPickedUp: "تم استلام الطلب",
      validationCodePlaceholder: "رمز التحقق",
      deliver: "تسليم",
      tabs: {
        inProgress: "قيد التنفيذ",
        history: "السجل",
      },
      deliveryCount_one: "توصيل",
      deliveryCount_other: "توصيلات",
      validationCodeRequired: "يرجى ادخال رمز التحقق.",
      actionQueuedOffline: "تم حفظ الاجراء بدون اتصال. ستتم المزامنة تلقائيا.",
      orderPickupSuccess: "تم استلام الطلب بنجاح",
      actionImpossible: "الاجراء غير متاح.",
      deliveryQueued: "التسليم بانتظار المزامنة.",
      deliveryConfirmed: "تم تاكيد التسليم",
      validationImpossible: "تعذر التحقق.",
      paymentUnavailableDoNotDeliver: "الدفع غير متاح. لا تقم بالتسليم. اعد الطرد الى المتجر وسيتم التعويض بعد التاكيد.",
      unexpectedError: "خطا: {{message}}",
      etaSavedQueued: "تم حفظ ETA ({{value}} دقيقة) بانتظار المزامنة.",
      etaAdjusted: "تم تعديل ETA ({{value}} دقيقة)",
      adjustImpossible: "التعديل غير متاح",
      incidentTitle: "تم الغاء الطلب - الدفع غير متاح",
      todoTitle: "المطلوب",
      todoNoDeliver: "لا تقم بالتسليم للعميل.",
      todoReturnPackage: "اعد الطرد الى المتجر.",
      todoSupportCompensation: "سيتم التعويض بعد تاكيد المتجر.",
      reportSent: "تم ارسال البلاغ الى الدعم.",
      reportError: "خطا اثناء ارسال البلاغ.",
      reportSentDone: "تم ارسال البلاغ",
      sending: "جار الارسال...",
      reportIncident: "ابلغ عن الحادث",
      backToFlow: "العودة للمسار",
      storeLabel: "المتجر: {{value}}",
      clientLabel: "العميل: {{value}}",
      courierTotal: "اجمالي السائق: {{amount}}",
      avatarAltStore: "الصورة الرمزية لـ {{value}}",
      avatarAltClient: "الصورة الرمزية لـ {{value}}",
    },
    deliveryVendor: {
      justNow: "الان",
      secondsSuffix: "ث",
      minutesSuffix: "د",
      hoursSuffix: "س",
      status: {
        accepted: "تم القبول",
        onHold: "معلق",
        preparing: "تم التحضير",
        onTheWay: "قيد التوصيل",
        delivered: "تم التسليم",
        cancelled: "ملغي",
      },
      incidentTitle: "تم الغاء الطلب",
      incidentDefaultMessage: "الدفع غير متاح. لا تقم بتحضير الطلب.",
      todoTitle: "المطلوب",
      todoNoPrepare: "لا تحضر / لا تشحن.",
      todoInformCourier: "ابلغ السائق عند الحاجة ان الطلب ملغي.",
      understood: "تم",
      preparationTime: "وقت التحضير",
      preparationHint: "حدد تقديرا للعميل والسائق.",
      cancel: "الغاء",
      actionQueuedOffline: "تم حفظ الاجراء بدون اتصال. ستتم المزامنة تلقائيا.",
      incidentPaymentUnavailable: "تم الغاء الطلب: الدفع غير متاح. لا تقم بالتحضير.",
      actionImpossible: "الاجراء غير متاح.",
      validate: "تأكيد",
      emptyForStatus: "لا توجد طلبات {{status}}",
      emptyText: {
        accepted: "ستظهر الطلبات هنا عند انشاء طلب جديد.",
        onHold: "ستظهر الطلبات المعلقة هنا.",
        preparing: "لم يتم وضع اي طلب في حالة التحضير بعد.",
        onTheWay: "ستظهر الطلبات قيد التوصيل هنا.",
        delivered: "لا توجد طلبات تم تسليمها بعد.",
        cancelled: "لم تقم بالغاء اي طلب مؤخرا.",
      },
      noOrderAlt: "لا توجد طلبات",
      orderNumber: "طلب رقم {{number}}",
      unknownStatus: "حالة غير معروفة",
      syncPending: "المزامنة قيد الانتظار",
      lastPositionReceived: "اخر موقع تم استلامه قبل {{age}}.",
      onHoldNotice: "الطلب في وضع التوقف: المعالجة متوقفة (حساب غير نشط او اعادة تعيين جارية).",
      clientPromise: "وعد العميل: {{time}}",
      driverDelay: "{{value}} دقيقة تم الابلاغ",
      preparationEstimated: "التحضير المتوقع",
      minutesValue: "{{value}} دقيقة",
      readyAround: "جاهز حوالي {{time}}",
      products: "المنتجات",
      deliveryFee: "رسوم التوصيل",
      riveltimeCommission: "عمولة Riveltime",
      vendorNet: "صافي البائع",
      deliverer: "السائق",
      avatarAlt: "الصورة الرمزية لـ {{value}}",
      client: "العميل",
      cancelQueued: "تم وضع الالغاء في قائمة المزامنة.",
      cancelImpossible: "تعذر الالغاء.",
      markPreparing: "قيد التحضير",
      storeFilterLabel: "المتجر",
      storeFilterAll: "الكل",
      unknownStore: "متجر غير معروف",
    },
    orderCard: {
      orderNumber: "طلب #{{id}}",
      placedOn: "تم الطلب في {{date}}",
      store: "المتجر",
      deliveryFee: "رسوم التوصيل",
      vendorContribution: "مساهمة البائع",
      storeTotal: "اجمالي المتجر",
      paymentStatusLabel: "حالة الدفع:",
      deliveryStatusLabel: "حالة التوصيل:",
      orderTotal: "اجمالي الطلب:",
      paymentStatus: {
        authorized: "مفوض",
        succeeded: "مدفوع",
        canceled: "ملغي",
        failed: "فشل",
        unknown: "غير معروف",
      },
      deliveryStatus: {
        pending: "قيد الانتظار",
        accepted: "تم القبول",
        preparing: "قيد التحضير",
        on_the_way: "في الطريق",
        delivered: "تم التسليم",
        cancelled: "ملغي",
        on_hold: "معلق",
        unknown: "غير معروف",
      },
    },
    userForm: {
      fullname: "الاسم الكامل",
      phone: "الهاتف",
      phoneTitle: "ادخل رقم هاتف صحيح (من 7 الى 15 رقما)",
      fullAddress: "العنوان الكامل",
      addressPlaceholder: "اكتب عنوانا",
      category: "الفئة",
      selectCategory: "-- اختر فئة --",
      categories: {
        alimentation: "الاغذية",
        mobiliteElectrique: "التنقل الكهربائي",
        pretAPorter: "الازياء",
        informatique: "المعلوماتية",
        restaurantTraiteur: "مطعم / تموين",
        pharmacieSante: "صيدلية / صحة",
        bricolageMaison: "اشغال منزلية",
        fleuristeJardin: "زهور / حديقة",
      },
      transportType: "نوع وسيلة النقل",
      selectTransport: "-- اختر وسيلة نقل --",
      transports: {
        bike: "دراجة",
        scooter: "سكوتر",
        car: "سيارة",
        truck: "شاحنة",
        walk: "سيرا",
      },
      save: "حفظ معلوماتي",
      errors: {
        noAddressSuggestion: "لم يتم العثور على اقتراحات",
        searchError: "خطا في البحث",
      },
    },
    orderMutations: {
      actionQueuedOffline: "تم حفظ الاجراء بدون اتصال.",
      orderNotFound: "الطلب غير موجود.",
      preparingError: "تعذر نقل الطلب الى التحضير",
      onTheWayError: "تعذر نقل الطلب الى التوصيل",
      invalidDelta: "قيمة التعديل غير صالحة",
      adjustEtaError: "تعذر تعديل وقت الوصول",
      missingCode: "الرمز مفقود",
      deliveryQueued: "التسليم بانتظار المزامنة.",
      deliveryError: "حدث خطا اثناء التسليم",
      cancelError: "تعذر الالغاء",
    },
    orderQueries: {
      adminOrdersLoadError: "تعذر تحميل طلبات الادارة.",
      ordersLoadError: "تعذر تحميل الطلبات.",
      driverAssignedLoadError: "تعذر تحميل عمليات التوصيل.",
      syncWarnings: {
        adminOrdersSessionExpired:
          "انتهت الجلسة: تعذر تحديث الطلبات. سجل الدخول مرة اخرى.",
        adminOrdersCache: "تعذر تحديث الطلبات (يتم عرض البيانات المخزنة).",
        vendorOrdersSessionExpired:
          "انتهت الجلسة: تعذر تحديث الطلبات. سجل الدخول مرة اخرى.",
        vendorOrdersCache: "تعذر تحديث الطلبات (يتم عرض البيانات المخزنة).",
        clientOrdersSessionExpired:
          "انتهت الجلسة: تعذر تحديث طلباتك. سجل الدخول مرة اخرى.",
        clientOrdersCache: "تعذر تحديث طلباتك (يتم عرض البيانات المخزنة).",
        driverAssignedSessionExpired:
          "انتهت الجلسة: تعذر تحديث عمليات التوصيل الخاصة بك. سجل الدخول مرة اخرى.",
        driverAssignedCache:
          "تعذر تحديث عمليات التوصيل الخاصة بك (يتم عرض البيانات المخزنة).",
      },
    },
    adminCatalogue: {
      title: "المتاجر والمنتجات",
      subtitle: "كتالوج شامل مع فلاتر واجراءات سريعة.",
      tabs: {
        stores: "المتاجر",
        products: "المنتجات",
      },
      searchPlaceholder: "ابحث (الاسم، المتجر، البائع، البريد)",
      loading: "جار التحميل",
      vendorFallback: "بائع",
      storeFallback: "متجر",
      storeClosure: "اغلاق",
      hidden: "مخفي",
      emptyStores: "لا توجد متاجر.",
      emptyProducts: "لا توجد منتجات.",
      errors: {
        load: "تعذر تحميل الكتالوج.",
        updateStore: "تعذر تحديث المتجر.",
        updateProduct: "تعذر تحديث المنتج.",
      },
    },
    liveSocket: {
      inactiveVendor: "الحساب غير نشط: متاجرك مخفية والطلبات متوقفة.",
      inactiveCourier: "الحساب غير نشط: لا توجد مهام توصيل حتى اعادة التفعيل.",
      reactivated: "تمت اعادة تفعيل الحساب.",
      deactivated: "تم تعطيل الحساب.",
      realtimeUnavailableSubscription: "الوقت الحقيقي غير متاح (اشتراك المواقع)",
      retry: "اعادة المحاولة",
      diagnosticCopied: "تم نسخ التشخيص",
      copyDiagnosticPrompt: "انسخ هذا التشخيص:",
      diagnosticTitle: "تشخيص Socket.IO",
      diagnosticDescription: "شارك هذا النص (لقطة او نسخ) لمعرفة سبب فشل polling.",
      close: "اغلاق",
      copy: "نسخ",
      ok: "موافق",
    },
    userStore: {
      emailAlreadyLinkedOtherAccount: "هذا البريد مرتبط بحساب اخر. سجل الدخول بالطريقة الصحيحة او اطلب رابط تسجيل الدخول.",
    },
    apiErrors: {
      unknown: "حدث خطا غير متوقع.",
      codes: {
        ACTIVE_ORDERS: "تعذر الحذف: توجد طلبات نشطة.",
        ACCOUNT_DELETED_OR_MISSING: "الحساب مفقود او محذوف. سجل الدخول مرة اخرى.",
        EMAIL_NOT_VERIFIED: "يرجى التحقق من بريدك الالكتروني للمتابعة.",
        INVALID_TOKEN: "جلسة غير صالحة. سجل الدخول مرة اخرى.",
        SESSION_EXPIRED: "انتهت الجلسة. سجل الدخول مرة اخرى.",
        SUPPORT_COOLDOWN: "ترسل بسرعة كبيرة. حاول مرة اخرى بعد ثوان.",
        SUPPORT_RATE_LIMIT_USER: "عدد كبير من البلاغات مؤخرا. حاول لاحقا.",
        SUPPORT_RATE_LIMIT_IP: "تم بلوغ حد البلاغات لهذا الاتصال. حاول لاحقا.",
        PRELAUNCH_EMAIL_INVALID: "عنوان البريد الالكتروني غير صالح.",
        PRELAUNCH_SUBSCRIBE_FAILED: "تعذر تسجيلك حاليا.",
        LINK_SESSION_INVALID: "جلسة الربط غير صالحة.",
        LINK_SESSION_EXPIRED: "انتهت جلسة الربط. ابدأ من جديد.",
        LINK_CONFIRMATION_REQUIRED: "يلزم تاكيد لربط طرق تسجيل الدخول هذه.",
        LINK_FORBIDDEN: "تم رفض ربط الحساب لهذا الطلب.",
        LINK_FAILED: "تعذر اكمال ربط طرق تسجيل الدخول.",
        LINK_ALREADY_DONE: "طرق تسجيل الدخول هذه مرتبطة مسبقا.",
        LINK_RATE_LIMITED: "محاولات الربط كثيرة جدا. حاول بعد قليل.",
        AMBASSADOR_DETACH_FAILED: "تعذر اكمال حذف الحساب حاليا. حاول مرة اخرى او تواصل مع الادارة.",
        INVALID_TARGET_AMBASSADOR: "السفير الهدف غير صالح او غير متاح.",
        VENDOR_ALREADY_ASSIGNED_TO_TARGET: "هذا البائع مرتبط بالفعل بهذا السفير.",
        VENDOR_IDS_REQUIRED: "يجب تحديد الباعة قبل التحويل.",
        VENDOR_BULK_LIMIT_EXCEEDED: "عدد الباعة كبير جدا للتحويل الجماعي.",
        VENDOR_REASSIGN_BULK_FAILED: "فشل التحويل الجماعي.",
        ORDER_CANCEL_CLIENT_PENDING_ONLY: "يمكنك الغاء الطلب فقط عندما يكون قيد الانتظار.",
        ORDER_PAYMENT_CAPTURED_CANCEL_IMPOSSIBLE: "تم تحصيل الدفع بالفعل: يتعذر الالغاء.",
        ORDER_CANCEL_FORBIDDEN: "لا تملك صلاحية الغاء هذا الطلب.",
        ORDER_CANCEL_VENDOR_INACTIVE: "الحساب غير نشط: تم حظر الالغاء.",
        ORDER_CANCEL_SERVER_ERROR: "خطا في الخادم اثناء الغاء الطلب.",
      },
    },
    addressSheet: {
      home: "المنزل",
      work: "العمل",
      searchError: "تعذر البحث عن عنوان. تحقق من الاتصال.",
      geoUnavailable: "الموقع غير متاح - اكتب عنوانا.",
      geoDenied: "تم رفض الوصول للموقع - يمكنك كتابة عنوان.",
      myLocation: "موقعي",
      myLocationFast: "موقعي (الاسرع)",
      addressFallback: "عنوان",
      mapSelectedPoint: "النقطة المختارة",
      mapUnavailable: "الخريطة غير متاحة على هذا الجهاز.",
      searchPlaceholder: "عنوان، مدينة، دولة",
      searchAria: "ابحث عن عنوان",
      searching: "جار البحث...",
      noResults: "لا توجد نتائج. جرب رقم + شارع + مدينة.",
      locating: "جار تحديد الموقع...",
      howToEnable: "كيف افعلها؟",
      adjustMap: "ضبط على الخريطة",
      title: "عنوان التوصيل",
      description: "لحساب الرسوم ووقت الوصول.",
      currentAddress: "الحالي: {{label}}",
      chooseForEstimate: "اختر عنوانا لتقدير التوصيل",
      emptyRecents: "ستظهر عناوينك هنا.",
      mapLoadingAria: "جار تحميل الخريطة",
      back: "رجوع",
      confirmPoint: "تاكيد هذه النقطة",
    },
    cityStore: {
      defaultCity: "مدينتك",
      geolocationUnsupported: "تحديد الموقع غير مدعوم في هذا المتصفح.",
      invalidCoords: "تم ارجاع احداثيات غير صالحة من GPS.",
      reverseGeocodeFailed: "تعذر استرجاع اسم المدينة.",
      geolocationError: "خطا في تحديد الموقع.",
      permissionDenied:
        "تم رفض الاذن. فعّل الموقع من الاعدادات ثم حاول مرة اخرى.",
      positionUnavailable: "الموقع غير متاح (GPS/الشبكة). حاول قرب نافذة.",
      timeout: "انتهت المهلة. حاول مرة اخرى.",
    },
    locationModal: {
      title: "تفعيل الموقع",
      body: "لاستخدام \"موقعي\" اسمح بالوصول للموقع. او اكتب عنوانا.",
      iosTitle: "ايفون (PWA / Safari / Chrome)",
      iosStep1: "افتح الاعدادات.",
      iosStep2: "اختر Safari او Chrome.",
      iosStep3: "افتح الموقع.",
      iosStep4: "اختر \"اثناء استخدام التطبيق\".",
      iosStep5: "ارجع الى Riveltime وحاول مجددا.",
      androidTitle: "Android / Desktop",
      androidStep1: "اضغط ايقونة القفل في شريط العنوان.",
      androidStep2: "افتح اعدادات الموقع.",
      androidStep3: "اجعل الموقع على السماح.",
      androidStep4: "اعد تحميل الصفحة عند الحاجة.",
      later: "لاحقا",
      wait: "انتظر...",
      retry: "اعادة المحاولة",
    },
    admin: {
      pageTitle: "الحسابات",
      pageSubtitle: "عملاء وباعة وسائقون: مراجعة وتحكم.",
      emptyTitle: "لا يوجد مستخدمون",
      emptySubtitle: "عدّل البحث او الفلاتر.",
      retry: "اعادة المحاولة",
      searchPlaceholder: "ابحث عن حساب (اسم او بريد)...",
      searchAria: "ابحث عن حساب",
      clearSearch: "مسح البحث",
      deleteConfirm: "هذا الاجراء لا يمكن التراجع عنه. تاكيد حذف الحساب؟",
      unknownName: "اسم غير معروف",
      identity: {
        title: "هوية تسجيل الدخول",
        subtitle: "تفاصيل يرسلها مزود الهوية عندما تكون متاحة.",
        provider: "المزود",
        providerUnknown: "مزود غير معروف",
        displayName: "الاسم",
        nickname: "الاسم المستعار",
        email: "البريد الإلكتروني",
        emailUnavailable: "البريد غير متاح",
        providerUserId: "معرف المزود",
        auth0Id: "معرف Auth0",
        notProvided: "غير متوفر",
      },
      providers: {
        google: "جوجل",
        auth0: "Auth0",
        apple: "آبل",
        facebook: "فيسبوك",
        linkedin: "لينكدإن",
        other: "أخرى",
      },
      accountValidated: "حساب معتمد",
      account: "الحساب",
      close: "اغلاق",
      closeAria: "اغلاق نافذة الحساب",
      activeStatus: "حالة النشاط",
      activeToggleAria: "تفعيل او تعطيل هذا الحساب",
      active: "نشط",
      inactive: "غير نشط",
      createdOn: "تاريخ الانشاء",
      phone: "الهاتف",
      approving: "جار الاعتماد...",
      updating: "جار التحديث...",
      deleteDisabledForAdmin: "حذف حساب الادمن محظور.",
      feedback: {
        approveSuccess: "تم اعتماد الحساب بنجاح.",
        activateSuccess: "تم تفعيل الحساب بنجاح.",
        deactivateSuccess: "تم تعطيل الحساب بنجاح.",
      },
      accountHolder: {
        title: "صاحب الحساب",
        subtitle: "ادخل الاسم الاول واسم العائلة لصاحب الحساب.",
        firstName: "الاسم الاول",
        lastName: "اسم العائلة",
        firstNamePlaceholder: "مثال: اميرة",
        lastNamePlaceholder: "مثال: فكير",
        firstNameRequired: "الاسم الاول مطلوب.",
        lastNameRequired: "اسم العائلة مطلوب.",
        save: "حفظ",
        saving: "جار الحفظ...",
        updateSuccess: "تم تحديث صاحب الحساب.",
        updateError: "تعذر تحديث صاحب الحساب.",
      },
      approve: "اعتماد",
      ok: "حسنا",
      delete: "حذف",
      transfer: {
        title: "تحويل الباعة",
        subtitle: "اعد تعيين البائع الى سفير اخر مع سبب الزامي.",
        actions: {
          enableMode: "وضع التحويل",
          disableMode: "الخروج من الوضع",
          processing: "جار المعالجة...",
        },
        filters: {
          sourceAmbassador: "السفير المصدر",
          sourceAll: "كل السفراء",
          sourceUnassigned: "باعة غير مرتبطين",
          handover: "التسليم",
          handoverAll: "الكل",
          handoverPending: "قيد الانتظار",
          handoverNotPending: "تمت المعالجة",
        },
        bulk: {
          targetLabel: "السفير الجديد",
          targetPlaceholder: "اختر سفيرا",
          reasonLabel: "سبب التحويل",
          reasonPlaceholder: "مثال: استمرارية النشاط المحلي",
          selectAllVisible: "اختيار الظاهرين",
          clearSelection: "مسح التحديد",
          submit: "تحويل ({{count}})",
          selectVendor: "اختيار البائع",
          unselectVendor: "ازالة البائع من التحديد",
        },
        single: {
          title: "تحويل هذا البائع",
          subtitle: "التحويل يحدّث الربط الشبكي دون تغيير حالة التحقق.",
          currentAmbassador: "السفير الحالي",
          targetLabel: "السفير الهدف",
          targetPlaceholder: "اختر سفيرا",
          reasonLabel: "السبب",
          reasonPlaceholder: "سبب الزامي",
          submit: "تحويل البائع",
          noAmbassadorAvailable: "لا يوجد سفير متاح لهذا التحويل.",
        },
        labels: {
          unassigned: "غير مرتبط",
        },
        errors: {
          targetRequired: "يرجى اختيار السفير الهدف.",
          reasonRequired: "السبب مطلوب (3 احرف على الاقل).",
        },
        confirm: {
          message: "تأكيد تحويل {{count}} بائع(ين)؟ السبب: {{reason}}",
          confirm: "تأكيد",
          cancel: "الغاء",
          processing: "جار التحويل...",
        },
        feedback: {
          selectionRequired: "اختر بائعا واحدا على الاقل.",
          targetRequired: "اختر السفير الهدف.",
          singleSuccess: "تم تحويل البائع بنجاح.",
          singleError: "تعذر تحويل هذا البائع.",
          bulkSuccess: "تم تحويل {{count}} بائع(ين) بنجاح.",
          bulkPartial: "نجح {{success}} وفشل {{failed}}.",
          bulkError: "فشل التحويل الجماعي.",
        },
      },
      roles: {
        all: "الكل",
        client: "عملاء",
        vendeur: "باعة",
        livreur: "سائقون",
        admin: "ادمن",
        ambassadeur: "سفراء",
        unknown: "غير معروف",
      },
      status: {
        approved: "معتمد",
        pending: "قيد المراجعة",
        suspended: "موقوف",
        unknown: "غير معروف",
      },
      errors: {
        loadUsers: "تعذر تحميل المستخدمين. حاول مجددا.",
        approveUser: "خطا في اعتماد المستخدم.",
        toggleActive: "تعذر تغيير حالة النشاط.",
        deleteUser: "خطا في حذف المستخدم.",
      },
    },
    ambassador: {
      dashboard: {
        title: "لوحة السفير",
        subtitle: "تابع اداء شبكتك المحلية.",
        kpis: {
          sectionTitle: "المؤشرات العامة",
          monthlyRevenue: "ايراد شهري",
          ordersCount: "عدد الطلبات",
          averageBasket: "متوسط السلة",
          growthRate: "معدل النمو",
          ambassadorCommission: "العمولة المتولدة (4%)",
          total: "اجمالي الشبكة",
          inReview: "قيد المراجعة",
          certified: "معتمدون",
          restricted: "مقيدون",
        },
        period: {
          label: "الفترة",
        },
        search: {
          label: "بحث سريع",
          placeholder: "الاسم او البريد او الهاتف",
          cta: "ابحث في الحسابات",
        },
        actions: {
          refresh: "تحديث",
          openNetwork: "دمج بائع",
          manageNetwork: "ادارة شبكتي",
        },
        activity: {
          title: "نشاط حديث",
          empty: "لا يوجد نشاط حديث حاليا.",
          statusPrefix: "الاجراء: {{status}}",
        },
        activityKinds: {
          preparing: "الملف قيد الاعداد",
          in_review: "الحساب قيد المراجعة",
          certified: "تم اعتماد البائع",
          restricted: "تم تقييد الحساب",
          unknown: "تحديث",
        },
        states: {
          loading: "جار تحميل المؤشرات...",
          retry: "اعادة المحاولة",
        },
        labels: {
          na: "غير متوفر",
          unknownDate: "تاريخ غير متاح",
        },
        feedback: {
          loadError: "تعذر تحميل مؤشرات لوحة القيادة.",
        },
      },
      network: {
        title: "شبكة الباعة",
        subtitle: "استخدم فقط رمز ربط شبكة البائع.",
        form: {
          title: "اضافة بائع الى شبكتك",
          whereToFind: "يمكن للبائع العثور على هذا الرمز في الملف الشخصي ضمن قسم توليد رمز.",
          claimCodeLabel: "رمز البائع (6 ارقام)",
          claimCodePlaceholder: "مثال: 493821",
          claimCodeHint: "ادخل الارقام الستة فقط.",
          resolve: "تأكيد الرمز",
          resolving: "جار التحقق...",
        },
        states: {
          loading: "جار التحقق من الرمز...",
          success: "الرمز صالح. البائع جاهز للاعتماد.",
          error: "تعذر التحقق من هذا الرمز.",
          expired: "انتهت صلاحية الرمز. اطلب توليد رمز جديد.",
          used: "تم استخدام الرمز مسبقا. اطلب رمزا جديدا.",
        },
        preview: {
          title: "معاينة البائع",
          vendorLabel: "البائع",
          emailLabel: "البريد",
          phoneLabel: "الهاتف",
          accountStatusLabel: "حالة الحساب",
          verificationStatusLabel: "حالة التحقق",
          activityLabel: "الظهور",
          mainBoutiqueLabel: "المتجر الرئيسي",
          completenessLabel: "اكتمال الملف",
          claimExpiresAtLabel: "انتهاء الرمز",
          resolutionExpiresAtLabel: "انتهاء الجلسة",
        },
        labels: {
          na: "غير متوفر",
        },
        activity: {
          active: "نشط",
          inactive: "غير نشط",
        },
        verificationStatus: {
          preparing: "قيد الاعداد",
          in_review: "قيد المراجعة",
          certified: "معتمد",
          restricted: "مقيد",
          unknown: "غير معروف",
        },
        accountStatus: {
          pending: "قيد الانتظار",
          approved: "مقبول",
          suspended: "موقوف",
          unknown: "غير معروف",
        },
        actions: {
          certify: "اعتماد",
          certifying: "جار الاعتماد...",
          requestCorrection: "طلب تصحيح",
          requestingCorrection: "جار الطلب...",
          restrict: "تقييد",
          restricting: "جار التقييد...",
        },
        restrict: {
          reasonLabel: "سبب التقييد",
          reasonPlaceholder: "اشرح لماذا يجب تقييد هذا الحساب",
        },
        feedback: {
          codeRequired: "ادخل رمز البائع للمتابعة.",
          resolveSuccess: "تم العثور على البائع. يمكنك الان تأكيد الاعتماد.",
          resolveError: "تعذر حل رمز البائع هذا.",
          certifySuccess: "تم اعتماد البائع وتفعيله داخل شبكتك.",
          certifyError: "فشل اعتماد البائع.",
          correctionSuccess: "تم وضع الحساب في وضع التصحيح بانتظار تحديثات البائع.",
          correctionError: "تعذر طلب التصحيح.",
          restrictSuccess: "تم تقييد الحساب بنجاح.",
          restrictError: "تعذر تقييد هذا الحساب.",
          restrictReasonRequired: "سبب التقييد مطلوب.",
          vendorMissing: "لا يوجد بائع محدد.",
        },
      },
      accounts: {
        title: "شبكتي",
        subtitle: "ادِر الباعة لديك باجراءات بسيطة وسريعة.",
        count: "{{count}} بائعا",
        scopeNotice: "تظهر فقط حسابات الباعة ضمن شبكتك.",
        filters: {
          searchLabel: "بحث عن بائع",
          searchPlaceholder: "الاسم او البريد او الهاتف",
          quick: {
            all: "الكل",
            in_review: "قيد المراجعة",
            certified: "معتمد",
            restricted: "مقيد",
            inactive: "غير نشط",
          },
          statusLabel: "حالة الحساب",
          verificationLabel: "حالة التحقق",
          activeLabel: "حالة النشاط",
          status: {
            all: "الكل",
            pending: "قيد الانتظار",
            approved: "مقبولة",
            suspended: "موقوفة",
          },
          verification: {
            all: "الكل",
            preparing: "قيد الاعداد",
            inReview: "قيد المراجعة",
            certified: "معتمد",
            restricted: "مقيد",
          },
          active: {
            all: "الكل",
            active: "نشط",
            inactive: "غير نشط",
          },
        },
        actions: {
          applyFilters: "تطبيق",
          resetFilters: "اعادة ضبط",
          refresh: "تحديث",
          reactivate: "اعادة تفعيل الحساب",
          suspend: "تعليق الحساب",
          activate: "تفعيل الحساب",
          deactivate: "تعطيل الحساب",
          unrestrict: "رفع التقييد",
          details: "تفاصيل",
          hideDetails: "اخفاء",
          restrict: "تقييد الحساب",
          consequences: {
            reactivate: "يصبح البائع مرئيا من جديد.",
            suspend: "يتم تعليق الحساب حتى التصحيح.",
            activate: "يصبح البائع مرئيا من جديد.",
            deactivate: "يصبح البائع مخفيا.",
            unrestrict: "يعود البائع الى وضعه التشغيلي.",
            restrict: "يتم تعليق الحساب حتى التصحيح.",
          },
        },
        list: {
          title: "باعة الشبكة",
          statusLine: "{{status}} • {{verification}}",
          mainBoutiqueFallback: "المتجر الرئيسي غير متوفر",
        },
        states: {
          loading: "جار تحميل الحسابات...",
          empty: "لا يوجد باعة مطابقون لهذه الفلاتر.",
          emptyDescription: "شبكتك فارغة حاليا. اضف باعة للبدء.",
          emptyAlt: "لا يوجد بائع",
          emptyCta: "اضافة بائع",
          retry: "اعادة المحاولة",
        },
        details: {
          title: "تفاصيل الحساب",
          sheetTitle: "تفاصيل البائع",
          sheetSubtitle: "راجع المعلومات قبل تأكيد اي اجراء.",
          identityBlock: "هوية البائع",
          restrictionBlock: "سياق التقييد",
          vendorId: "البريد",
          phone: "الهاتف",
          mainBoutique: "المتجر الرئيسي",
          name: "الاسم",
          status: "حالة الحساب",
          verification: "التحقق",
          activity: "حالة النشاط",
          lastUpdate: "اخر تحديث",
          restrictReason: "سبب التقييد",
          restrictReasonNone: "لا يوجد سبب تقييد نشط حاليا.",
        },
        restrict: {
          reasonLabel: "سبب التقييد",
          reasonPlaceholder: "اكتب سبب تقييد هذا الحساب",
          templates: {
            missingInfo: "معلومات ناقصة",
            lowQuality: "جودة منخفضة",
            prohibited: "منتجات محظورة",
          },
        },
        confirm: {
          actionMessage: "تأكيد الاجراء للحساب {{vendor}}؟ {{consequence}}",
          restrictMessage: "تأكيد تقييد الحساب {{vendor}}؟ {{consequence}} السبب: {{reason}}",
          confirm: "تأكيد",
          cancel: "الغاء",
          processing: "جار المعالجة...",
        },
        badges: {
          status: {
            pending: "قيد الانتظار",
            approved: "مقبول",
            suspended: "موقوف",
            unknown: "غير معروف",
          },
          verification: {
            preparing: "قيد الاعداد",
            in_review: "قيد المراجعة",
            certified: "معتمد",
            restricted: "مقيد",
            unknown: "غير معروف",
          },
          active: {
            active: "نشط",
            inactive: "غير نشط",
          },
        },
        labels: {
          na: "غير متوفر",
          unknownDate: "تاريخ غير متاح",
        },
        feedback: {
          loadError: "تعذر تحميل حسابات الشبكة.",
          reactivateSuccess: "تمت اعادة تفعيل الحساب بنجاح.",
          reactivateError: "تعذرت اعادة تفعيل هذا الحساب.",
          suspendSuccess: "تم تعليق الحساب بنجاح.",
          suspendError: "تعذر تعليق هذا الحساب.",
          activateSuccess: "تم تفعيل الحساب بنجاح.",
          deactivateSuccess: "تم تعطيل الحساب بنجاح.",
          unrestrictSuccess: "تم رفع التقييد بنجاح.",
          activeError: "تعذر تغيير حالة النشاط.",
          restrictReasonRequired: "سبب التقييد مطلوب.",
          restrictSuccess: "تم تقييد الحساب بنجاح.",
          restrictError: "تعذر تقييد هذا الحساب.",
        },
      },
    },
    profile: {
      syncQueuedOffline: "تم حفظ التحديث بدون اتصال وسيتم المزامنة تلقائيا.",
      updateSuccess: "تم تحديث الملف بنجاح.",
      updateFailed: "فشل تحديث الملف.",
      addressNotFound: "لم يتم العثور على العنوان. ادخل عنوانا ادق او اختر اقتراحا.",
      geocodeFailed: "خطا في تحديد الموقع. تحقق من الاتصال.",
      languageQueuedOffline: "تم تحديث اللغة محليا وسيتم مزامنتها عند عودة الشبكة.",
      languageUpdated: "تم تحديث اللغة.",
      languageUpdateFailed: "تعذر تحديث اللغة.",
      redirecting: "جار التحويل...",
      sessionInvalid: "جلسة غير صالحة - سجل الدخول مجددا.",
      incompleteWarning: "ملفك غير مكتمل. يرجى اكماله.",
      fullnamePlaceholder: "الاسم الكامل",
      phonePlaceholder: "الهاتف",
      phoneTitle: "ادخل رقما صالحا (7 الى 15 رقما مع السماح بالمسافات والواصلات)",
      addressPlaceholder: "العنوان الكامل",
      transportPlaceholder: "-- اختر وسيلة النقل --",
      save: "حفظ",
      edit: "تعديل",
      complete: "اكمال",
      editInfo: "تعديل معلوماتي",
      infoTitleCompact: "المعلومات",
      notificationsByEmail: "استلام تنبيهات البريد",
      languageHint: "اختر لغة التطبيق.",
      languageUpdating: "جار التحديث...",
      languageImmediate: "يطبق التغيير فورا على هذا الجهاز.",
      supportDescription: "ابلغ عن مشكلة خلال 30 ثانية. الرد المستهدف خلال 24 ساعة عمل.",
      supportCta: "ابلاغ عن مشكلة",
      securityChangePassword: "تغيير كلمة المرور",
      passwordResetRequesting: "جار الارسال...",
      passwordResetRequestSent: "تم ارسال رسالة اعادة تعيين كلمة المرور.",
      passwordResetRequestFailed: "تعذر ارسال رسالة اعادة تعيين كلمة المرور.",
      passwordResetMissingEmail: "عنوان البريد الالكتروني غير متاح.",
      accepted: "تم القبول",
      onDate: "بتاريخ {{date}}",
      viewOnly: "عرض فقط",
      supportTicketSent: "تم ارسال تذكرة الدعم #{{id}}.",
      notProvided: "غير متوفر",
      fullnameLockedByLegal: "الاسم الكامل يصبح مقفلا بعد توقيع الشروط.",
      emailManagedByProvider: "هذا البريد تتم ادارته من مزود تسجيل الدخول.",
      infoStatus: {
        complete: "الملف مكتمل",
        incomplete: "معلومات ناقصة",
        actionRequired: "اجراء مطلوب",
      },
      emailStatus: {
        verified: "البريد موثق",
        pending: "البريد بانتظار التوثيق",
        provider: "البريد تتم ادارته من المزود",
      },
      infoLabels: {
        fullname: "الاسم الكامل",
        email: "البريد الالكتروني",
        phone: "الهاتف",
        address: "العنوان",
        transport: "وسيلة النقل",
        certificationStatus: "حالة توثيق البائع",
      },
      infoSheet: {
        title: "تعديل معلوماتي",
        description: "تستخدم هذه المعلومات للتوصيل وامان الحساب.",
        save: "حفظ",
        saving: "جار الحفظ...",
      },
      validation: {
        fullnameRequired: "الاسم الكامل مطلوب.",
        phoneRequired: "الهاتف مطلوب.",
        phoneInvalid: "ادخل رقما صحيحا.",
        addressRequired: "العنوان مطلوب.",
        transportRequired: "نوع وسيلة النقل مطلوب.",
      },
      avatarUploadFailed: "فشل رفع الصورة",
      editAvatar: "تعديل الصورة",
      avatarAlt: "صورة المستخدم",
      greeting: "مرحبا {{name}}!",
      userFallback: "مستخدم",
      desktopSidebarTitle: "تنقل الملف",
      desktopSidebarDescription: "انتقل بسرعة بين اقسام حسابك.",
      desktopSidebarAria: "تنقل اقسام الملف",
      desktopSidebarCompletionLabel: "الاكتمال",
      desktopSidebarCompletionValue: "{{percent}}%",
      desktopQuickActionsTitle: "اجراءات سريعة",
      desktopQuickSupport: "فتح الدعم",
      desktopQuickSecurity: "الذهاب الى الامان",
      desktopWorkspaceTitle: "مساحة الملف",
      desktopWorkspaceSubtitle: "ادِر اعداداتك الشخصية من لوحة سطح مكتب واضحة.",
      desktopTileCompletion: "الملف",
      desktopCompletionReady: "الملف مكتمل وجاهز.",
      desktopTileLanguage: "اللغة النشطة",
      desktopLanguageHint: "تستخدم للواجهة والرسائل.",
      desktopTileNotifications: "الاشعارات",
      desktopTileSync: "المزامنة",
      desktopStateEnabled: "مفعلة",
      desktopStateDisabled: "معطلة",
      desktopStateOnline: "متصل",
      desktopStateOffline: "غير متصل",
      desktopSyncHintOnline: "يتم ارسال التغييرات مباشرة.",
      desktopSyncHintOffline: "تُحفظ التغييرات في الطابور ثم تُزامن لاحقا.",
      sections: {
        info: "معلوماتي",
        claimCode: "توليد رمز",
        certification: "توثيق البائع",
        notifications: "الاشعارات",
        language: "اللغة",
        support: "المساعدة والدعم",
        legals: "المستندات القانونية",
        security: "الامان",
      },
      transport: {
        bike: "دراجة",
        scooter: "سكوتر",
        car: "سيارة",
        truck: "شاحنة",
        walk: "سيرا",
      },
      supportClaim: {
        description: "استخدم هذا الرمز للتحقق السريع مع الدعم.",
        codeLabel: "رمز الدعم",
        noCodeHint: "لا يوجد رمز نشط حاليا. ولّد رمزا للبدء.",
        activeCodeHint: "يوجد رمز نشط بالفعل. أعد التوليد لعرض رمز جديد.",
        expiresAt: "ينتهي في: {{date}}",
        generate: "توليد الرمز",
        regenerate: "اعادة التوليد",
        generating: "جار التوليد...",
        copyCta: "نسخ الرمز",
        feedback: {
          generateSuccess: "تم توليد رمز الدعم بنجاح.",
          generateFailed: "تعذر توليد رمز الدعم.",
          copySuccess: "تم نسخ الرمز.",
          copyFailed: "تعذر نسخ الرمز.",
        },
      },
      certification: {
        statusLabel: "حالة التحقق",
        ambassadorClaimDescription: "ولّد رمز البائع المستخدم للربط مع شبكة السفير.",
        ambassadorLabel: "السفير",
        certifiedByLabel: "تم التوثيق بواسطة",
        certifiedAtLabel: "تم التوثيق بتاريخ",
        restrictedReasonLabel: "سبب التقييد",
        seeDetails: "عرض التفاصيل",
        codeLabel: "رمز الربط بالشبكة",
        noCodeHint: "لا يوجد رمز نشط حاليا. ولّد رمزا للبدء.",
        activeCodeHint: "يوجد رمز نشط بالفعل. أعد التوليد لعرض رمز جديد.",
        expiresAt: "ينتهي في: {{date}}",
        generate: "توليد الرمز",
        regenerate: "اعادة التوليد",
        generating: "جار التوليد...",
        copyCta: "نسخ الرمز",
        feedback: {
          generateSuccess: "تم توليد رمز الربط بنجاح.",
          generateFailed: "تعذر توليد رمز الربط.",
          copySuccess: "تم نسخ الرمز.",
          copyFailed: "تعذر نسخ الرمز.",
        },
        status: {
          preparing: "قيد الاعداد",
          in_review: "قيد المراجعة",
          certified: "معتمد",
          restricted: "مقيد",
          unknown: "غير معروف",
        },
      },
      roleSubtitle: {
        client: "مرحبا بك في مساحة العميل",
        vendeur: "شكرا لدعمك التجارة المحلية",
        livreur: "التوصيل يصنع ايضا رابطا محليا",
        ambassadeur: "انت تبني شبكة Riveltime المحلية",
        admin: "انت تدير عمليات المنصة",
      },
    },
    stripe: {
      redirectError: "فشل التحويل الى Stripe.",
      genericError: "حدث خطا غير متوقع.",
      sessionExpired: "انتهت الجلسة. سجل الدخول من جديد.",
      emailNotVerifiedSync: "تم التحقق من البريد للتو؟ انتظر بضع ثوان ثم اعد المحاولة.",
      reconnectActionRequired: "حساب Stripe غير متاح في هذا البيئة. اضغط تفعيل Stripe لاعادة الربط.",
      serverUnreachable: "تعذر الاتصال بالخادم.",
      reconnectRequired: "حساب Stripe غير متاح في هذا البيئة. يلزم اعادة الربط.",
      manageAccountAria: "ادارة حساب Stripe",
      manageAccount: "ادارة حساب Stripe",
      loadingAria: "جار تحميل Stripe",
      connecting: "جار الاتصال...",
      activateAria: "تفعيل Stripe",
      activate: "تفعيل Stripe",
      dashboardLoadError: "تعذر تحميل بيانات Stripe.",
      connected: "تم ربط حساب Stripe",
      connectTitle: "الاتصال بـ Stripe",
      connectDescription: "اربط حساب Stripe لمتابعة الرصيد والتحويلات.",
      summaryTitle: "الملخص المالي",
      availableBalance: "الرصيد المتاح",
      pendingAmount: "المبلغ القادم",
      payoutFrequency: "وتيرة التحويلات",
      bankAccount: "الحساب البنكي المرتبط",
      lastPayouts: "اخر التحويلات",
      statusLabel: "الحالة",
      statusPaid: "مدفوع",
      statusPending: "قيد الانتظار",
      feesLabel: "رسوم Stripe",
      transferDestination: "تم التحويل الى حسابك البنكي",
      bankAccountMasked: "•••• •••• 1234",
      na: "N/A",
      frequency: {
        daily: "يومي",
        weekly: "اسبوعي",
        monthly: "شهري",
        unknown: "غير معروف",
      },
    },
    paymentMethods: {
      card: "بطاقة",
      cash: "نقدا",
      applePay: "Apple Pay",
      googlePay: "Google Pay",
      mealVoucher: "قسيمة طعام",
      save: "حفظ",
    },
    home: {
      sessionReturn: {
        title: "مرحبا بعودتك",
        body: "اعدناك الى هنا لتتابع بهدوء. اذا كانت جلستك ما زالت نشطة فستعود مباشرة الى مساحتك.",
        cta: "استئناف جلستي",
      },
      notProvided: "غير متوفر",
      storeFallback: "متجر",
      visual: "صورة",
      lastVisit: "اخر زيارة",
      closed: "مغلق",
      open: "مفتوح",
      distanceAria: "المسافة {{value}} كيلومتر",
      featuredBadge: "مميز",
      categoryFallback: "هذه الفئة",
      discoverInCategory: "اكتشف في {{category}}",
      view: "عرض",
      featuredProductSubtitle: "اختيار مميز بعرض على Riveltime",
      discover: "اكتشف",
      offer: "عرض",
      sections: {
        recents: "زياراتك الاخيرة",
        discoverForYou: "مقترحات لك",
        bestSellers: "الاكثر مبيعا محليا",
        allStores: "كل المتاجر",
      },
      categories: {
        food: "غذاء",
        restaurant: "مطعم",
        fashion: "ملابس",
        health: "صحة",
        tech: "تقنية",
        mobility: "تنقل",
        diy: "اعمال منزلية",
        garden: "حديقة",
      },
      filters: {
        quickTitle: "إجراءات سريعة",
        openNow: "مفتوح الان",
        popular: "شائع",
        delivery: "توصيل",
        free: "مجاني",
        nearby: "قريب",
        categoriesTitle: "فئات",
        distanceOption: "≤ {{km}} كم",
      },
      search: {
        defaultPlaceholder: "ابحث عن متجر او منتج...",
        morningPlaceholder: "تحتاج شيئا هذا الصباح؟",
        dayPlaceholder: "ابحث عما تحتاجه بالقرب منك",
        eveningPlaceholder: "دلل نفسك دون حركة",
        aria: "ابحث عن متجر او منتج",
      },
      featuredMessages: {
        1: "جوهرة محلية تستحق الاكتشاف",
        2: "حرفية بشغف واختيار دقيق",
        3: "ليست متجرا عاديا...",
        4: "ادخل واستكشف واستمتع",
        5: "العملاء يحبونها وستعرف السبب",
        6: "مختارة لك اليوم",
        7: "ماذا لو كانت هذه مفضلتك القادمة؟",
      },
      announcement: {
        sunny: { title: "الجو جميل اليوم", subtitle: "استمتع بافضل العناوين المحلية" },
        rainy: { title: "تمطر اليوم", subtitle: "اطلب التوصيل وابق دافئا" },
        cold: { title: "الجو بارد بالخارج", subtitle: "ابق دافئا ودعنا نتكفل بالباقي" },
        morning: { title: "صباح الخير", subtitle: "ابدأ يومك بعنوان محلي رائع" },
        evening: { title: "مساء هادئ؟", subtitle: "اطلب وانت على الاريكة" },
      },
      prelaunch: {
        badge: "قريبا",
        title: "Riveltime قادم قريبا",
        description: "نحن ننهي تجهيز شبكة البائعين والسعاة في منطقتك.",
        bannerText: "Riveltime قادم قريبا",
        bannerAction: "اعرف المزيد",
        orderDisabled: "الطلب (قريبا)",
        modalHeader: "Riveltime قادم قريبا",
        modalTitle: "بقيت خطوات قليلة قبل الافتتاح",
        modalDescription: "افتتاح تدريجي",
        modalBody: "نحن ننهي تجهيز شبكة البائعين والسعاة في منطقتك.",
        waitlistLabel: "ابقني على اطلاع",
        waitlistPlaceholder: "بريدك الالكتروني",
        waitlistHint: "سنرسل لك تنبيها فور افتتاح Riveltime في منطقتك.",
        waitlistSubmit: "ابقني على اطلاع",
        waitlistSubmitting: "جار الارسال...",
        waitlistInvalidEmail: "ادخل بريدا الكترونيا صالحا.",
        waitlistSuccessFallback: "شكرا، سنخبرك عند الاطلاق.",
        waitlistErrorFallback: "تعذر تسجيل بريدك حاليا.",
        ctaPrimary: "عرض النسخة العامة",
        ctaSecondary: "انا بائع",
        illustrationAlt: "رسم توضيحي لفترة ما قبل الاطلاق",
      },
      accountLink: {
        close: "اغلاق",
        modalHeader: "Riveltime قادم قريبا",
        modalTitle: "هذا البريد مرتبط مسبقا بحساب",
        modalBody: "للاحتفاظ بملف واحد، اربط طرق تسجيل الدخول الخاصة بك بشكل امن.",
        emailLabel: "البريد المكتشف",
        linkCta: "اربط طرق تسجيل الدخول",
        signInExistingCta: "الدخول بالطريقة الحالية",
        processing: "جار التحقق...",
        success: "اكتمل الربط. سجل الدخول من جديد للمتابعة.",
        errorFallback: "تعذر ربط طرق تسجيل الدخول حاليا.",
      },
    },
    clientHome: {
      prelaunch: {
        badge: "قريبا",
        title: "Riveltime قادم قريبا الى منطقتك",
        description: "لا توجد متاجر نشطة حاليا. نفتح تدريجيا، عد قريبا.",
        ctaPrimary: "العودة الى البداية",
        ctaSecondary: "اريد الانضمام الى الشبكة",
        illustrationAlt: "رسم انتظار فتح الشبكة",
      },
    },
  },
};

const AUTO_EXTRA_MESSAGES = {
  "en-US": {
    "liveSocket": {
      "originHintNetlify": "The front turns to {{origin}}. Checks the API URL variable and CORS rules.",
      "inferred": {
        "blockedOrNoResponse": "No response from the backend (network, proxy or CORS).",
        "endpointNotFound": "Endpoint Socket not found (path/proxy).",
        "forbidden": "Access denied (CORS or security rule).",
        "unauthorized": "Authentication refused (invalid/expired token).",
        "proxyUnavailable": "Server temporarily unavailable (5xx)."
      }
    },
    "userStore": {
      "unableToFetchProfile": "Unable to retrieve profile.",
      "invalidSessionReconnect": "Invalid session. Reconnect.",
      "deleteAccountFailed": "Account deletion failed.",
      "unexpectedError": "Unexpected error."
    },
    "boutiqueStore": {
      "sessionDesyncedReconnectRequired": "Session out of sync. Reconnection required.",
      "accountSyncInProgressRetry": "Account being synchronized. Try again in a few seconds or log in again.",
      "unableToLoadYourStores": "Unable to load your stores.",
      "storeDeleted": "Store deleted.",
      "unableToDeleteStore": "Unable to delete store."
    },
    "deliveryAdmin": {
      "adminView": "Administrator view",
      "activeOrders": "Active orders",
      "sidebarTitle": "My orders",
      "scopeTitle": "Tracking",
      "total": "Total",
      "order": "Order",
      "details": "Details",
      "unknown": "Unknown",
      "dash": "-",
      "paymentLabel": "Payment :",
      "tabs": {
        "inProgress": "In progress",
        "history": "Historical"
      },
      "captureStatus": {
        "authorized": "Allowed",
        "succeeded": "Successful",
        "captured": "Capture",
        "canceled": "Canceled",
        "failed": "Failed"
      },
      "emptyOrdersForStatus": "No {{status}} command.",
      "storeFallback": "Shop not specified",
      "clientFallback": "Customer not informed",
      "operationalStatus": "Operational status",
      "newStatus": "New status",
      "assignDelivererBeforeStatusChange": "Assign a delivery person before changing this status.",
      "apply": "Apply",
      "deliverer": "Delivery person",
      "assignOrReassign": "Assign or reassign",
      "loadingDeliverers": "Delivery men loading",
      "updateDeliverer": "Update the delivery person",
      "systemActions": "System actions",
      "resetToPending": "Iron on hold",
      "cancelOrder": "Cancel order",
      "forceCaptureTitle": "Force payment capture",
      "forceCaptureDescription": "Captures the payment and marks the order as delivered.",
      "reasonPlaceholder": "Reason (optional)",
      "captureAndDeliver": "Capture and deliver",
      "manageOrder": "Manage order",
      "actionImpossible": "Action impossible for this command.",
      "loadError": "Failed to load admin commands.",
      "orderPausedWithReason": "Command paused{{reason}}",
      "toasts": {
        "statusUpdated": "Status updated.",
        "orderResetPending": "Order placed again on hold.",
        "delivererUpdated": "Delivery man updated.",
        "orderCancelled": "Order canceled.",
        "paymentCapturedDelivered": "Payment captured and order delivered."
      }
    },
    "courses": {
      "tabs": {
        "aroundMe": "Around me",
        "route": "Itinerary"
      },
      "adsLabel": "Announcements available",
      "placeholders": {
        "addressAround": "Address around me",
        "departureAddress": "Departure address",
        "arrivalAddress": "Arrival address",
        "radiusKm": "Radius"
      },
      "banners": {
        "connectionRequired": "Login required to accept an order.",
        "orderAccepted": "Order accepted.",
        "orderUnavailable": "This command is no longer available.",
        "acceptNetworkError": "Network error during acceptance."
      },
      "emptyPendingOrders": "No pending orders.",
      "modal": {
        "orderDetails": "Order details",
        "noImage": "No pictures",
        "itemsCount": "{{count}} item(s)",
        "store": "Shop",
        "delivery": "Delivery",
        "storePhotoAlt": "Photo by {{store}}"
      },
      "aria": {
        "radiusInKm": "Radius in kilometers",
        "deliveryPrice": "Delivery price",
        "estimatedDelay": "Estimated deadline",
        "distance": "Distance",
        "recommendedVehicle": "Recommended vehicle",
        "totalWeight": "Total weight",
        "totalVolume": "Total volume",
        "billedWeight": "Invoice weight",
        "store": "Shop",
        "storeAddress": "Shop address",
        "storePhone": "Telephone shop",
        "client": "Customer",
        "deliveryAddress": "Delivery address",
        "clientPhone": "Customer telephone"
      },
      "notProvidedFemale": "Not specified",
      "notProvidedMale": "Not specified",
      "skip": "Pass",
      "accept": "Accept",
      "loading": "Loading",
      "km": "km",
      "kg": "kg",
      "m3": "m3"
    },
    "gestionModal": {
      "create": "Create",
      "edit": "To modify",
      "store": "shop",
      "product": "product",
      "deleteItem": "DELETE",
      "storeName": "Shop Name",
      "storeNamePlaceholder": "Shop Name",
      "category": "Category",
      "selectCategory": "Select a category",
      "categories": {
        "alimentation": "Food",
        "restaurant": "Restaurant",
        "sante": "Health",
        "mobilite": "Mobility",
        "pretAPorter": "Ready-to-wear",
        "informatique": "Computer science",
        "bricolage": "DIY",
        "jardin": "Garden"
      },
      "fullAddress": "Full address",
      "address": "Address",
      "defineOpeningHours": "Define opening hours",
      "exceptionalClosure": "Exceptional closure",
      "deliveryFeeParticipationTitle": "Contribution to delivery costs",
      "enableParticipation": "Enable",
      "enableParticipationAria": "Enable contribution to delivery costs",
      "participationShareLabel": "Share of delivery fee covered",
      "participationHelp": "Percentage of delivery fee covered by your store.",
      "participationOptions": {
        "25": "25% of delivery fee",
        "50": "50% of delivery fee",
        "75": "75% of delivery fee",
        "100": "100% of delivery fee"
      },
      "contributionCapLabel": "Maximum cap (% of cart)",
      "contributionOptions": {
        "10": "max 10% of cart",
        "20": "max 20% of cart",
        "30": "max 30% of cart"
      },
      "contributionHelp": "Maximum cap to protect your margin.",
      "participationPreview": "Example: fee {{deliveryFee}} EUR, cart {{cartAmount}} EUR -> you cover {{amount}} EUR.",
      "coverImage": "Cover image",
      "image": "Picture",
      "imageConstraints": "Formats accepted: JPG, PNG. Recommended size less than 2 MB.",
      "collection": "Collection",
      "productName": "Product Name",
      "name": "Name",
      "price": "Price",
      "description": "Description",
      "selectShippingFormat": "Select a transport format",
      "shippingGroups": {
        "smallPackages": "Small packages",
        "mediumPackages": "Medium packages",
        "largeObjects": "Large objects"
      },
      "shippingOptions": {
        "petit_colis": "Small package",
        "sac_ou_vetement": "Bag or clothing",
        "carton_moyen": "Medium carton",
        "fragile": "Fragile",
        "meuble": "Furniture",
        "gros_objet": "Large object"
      },
      "preparingProductOptions": "Preparing product options...",
      "save": "Save",
      "saving": "Registration..."
    },
    "variableEditor": {
      "productOptionsAria": "Editing product options",
      "productOptionsTitle": "Product options",
      "addOption": "Add an option",
      "emptyHelpPrefix": "You can create options like",
      "emptyHelpSuffix": "to personalize the product.",
      "examples": {
        "size": "Size",
        "dough": "Dough",
        "supplements": "Supplements"
      },
      "optionLegend": "Option {{index}}",
      "optionName": "Option name",
      "optionNamePlaceholder": "Ex: Size",
      "type": "Kind",
      "singleChoice": "Single choice",
      "multipleChoice": "Multiple choice",
      "required": "Mandatory",
      "hideDetails": "Hide details",
      "showDetails": "Show details",
      "deleteOptionAria": "Remove option {{index}}",
      "examplePrefix": "Example :",
      "exampleSingleRequired": "single choice required",
      "or": "Or",
      "exampleMultipleMax": "multiple choice with maximum",
      "groupHelpSrOnly": "Configures advanced options for this group.",
      "advancedOptionsAria": "Advanced options",
      "advancedOptions": "Advanced options",
      "hideAdvancedOptions": "Hide advanced options",
      "max": "Max",
      "maxSelectionsAria": "Maximum number of selections",
      "technicalKey": "Technical key",
      "technicalKeyPlaceholder": "Ex: size",
      "groupKeyAria": "Technical key of the group",
      "choiceLabel": "Word of choice",
      "choiceLabelPlaceholder": "Ex: Large",
      "extraCost": "Supplement",
      "extraCostHelpSrOnly": "Amount added to the base price.",
      "defaultChoiceSingle": "Default choice",
      "deleteChoiceAria": "Delete choice {{value}}",
      "addChoiceAria": "Add a choice",
      "addChoice": "Add a choice",
      "footerHelp": "Options will apply to this product only.",
      "defaultOptionLabel": "Option"
    },
    "panier": {
      "title": "Basket",
      "modalDescription_one": "{{count}} item in your basket",
      "modalDescription_other": "{{count}} items in your basket",
      "emptyCartDescription": "Your basket is empty.",
      "emptyCart": "No articles at the moment.",
      "discoverStores": "Discover the stores",
      "atStore": "At the house of",
      "quantityForProductAria": "Quantity for {{name}}",
      "removeOneAria": "Remove an article from {{name}}",
      "addOneAria": "Add an article from {{name}}",
      "products": "Products",
      "delivery": "Delivery",
      "participationOf": "Participation of {{store}}",
      "deliveryEstimateLoading": "Calculation of delivery costs...",
      "chooseAddressForEstimate": "Choose an address to estimate delivery.",
      "loginToEstimate": "Log in to get an estimate.",
      "login": "Log in",
      "estimatedTotal": "Total estimates",
      "doubleDash": "--",
      "selectAddressPrompt": "Select an address",
      "defaultRotatingMessage": "We calculate the best price for you.",
      "preparing": "Preparation...",
      "order": "Order",
      "chooseAddress": "Choose an address",
      "estimateError": "Impossible to estimate delivery.",
      "authRequiredToPay": "Login required to pay.",
      "serverError": "Server error.",
      "storeFallback": "Shop",
      "noPaymentPrepared": "No payment has been prepared.",
      "paymentInfoUnavailable": "Payment information unavailable.",
      "preparePaymentError": "Error during payment preparation.",
      "messages": {
        "1": "We prepare your order...",
        "2": "The best route is being calculated.",
        "3": "Your products are arriving soon.",
        "4": "We optimize delivery costs.",
        "5": "One more moment...",
        "6": "Your basket is in good hands.",
        "7": "We check the availability of the articles.",
        "8": "The stores are getting ready.",
        "9": "Thank you for your patience.",
        "10": "We're finalizing your estimate.",
        "11": "Almost finished.",
        "12": "Your checkout will be ready in a moment.",
        "13": "We synchronize the payment information.",
        "14": "Latest checks in progress."
      }
    },
    "home": {
      "welcomeTitle": "Welcome to Riveltime",
      "welcomeSubtitle": "The local marketplace to order in seconds.",
      "order": "Order",
      "continueWithoutAccount": "Continue without an account",
      "proQuestion": "Are you a merchant or a courier?",
      "accessVendor": "Seller access",
      "accessCourier": "Courier access",
      "hello": "Hello {{name}}",
      "yourRole": "Your role:",
      "preparingSpace": "Preparing your space...",
      "goToMySpace": "Access my space",
      "logout": "Log out",
      "installPrompt": "Install Riveltime for faster access",
      "install": "Install",
      "androidInstallTitle": "Installing on Android",
      "androidInstallHintGeneric": "Open the browser menu, then tap Install app or Add to Home screen.",
      "androidInstallHintSamsung": "In Samsung Internet, open the menu, then choose Install app or Add page to Home screen.",
      "androidInstallHintXiaomi": "In Mi Browser, open the menu, then choose Add to Home screen or Install app.",
      "iosInstallTitle": "Installing on iPhone",
      "iosInstallStep1": "Press",
      "iosInstallShare": "Share",
      "iosInstallStep2": "Then",
      "iosInstallHomeScreen": "On the home screen",
      "close": "Close",
      "logoAlt": "Riveltime Logo",
      "roles": {
        "client": "Customer",
        "vendeur": "Seller",
        "livreur": "Delivery person"
      }
    }
  },
  "es-ES": {
    "liveSocket": {
      "originHintNetlify": "El frente gira hacia {{origin}}. Comprueba la variable URL de API y las reglas CORS.",
      "inferred": {
        "blockedOrNoResponse": "No hay respuesta del backend (red, proxy o CORS).",
        "endpointNotFound": "No se encontró el socket del punto final (ruta/proxy).",
        "forbidden": "Acceso denegado (CORS o regla de seguridad).",
        "unauthorized": "Autenticación rechazada (token no válido/caducado).",
        "proxyUnavailable": "Servidor no disponible temporalmente (5xx)."
      }
    },
    "userStore": {
      "unableToFetchProfile": "No se puede recuperar el perfil.",
      "invalidSessionReconnect": "Sesión no válida. Vuelva a conectarse.",
      "deleteAccountFailed": "Error al eliminar la cuenta.",
      "unexpectedError": "Error inesperado."
    },
    "boutiqueStore": {
      "sessionDesyncedReconnectRequired": "Sesión no sincronizada. Se requiere reconexión.",
      "accountSyncInProgressRetry": "Cuenta en proceso de sincronización. Vuelve a intentarlo en unos segundos o inicia sesión nuevamente.",
      "unableToLoadYourStores": "No se pueden cargar tus tiendas.",
      "storeDeleted": "Tienda eliminada.",
      "unableToDeleteStore": "No se puede eliminar la tienda."
    },
    "deliveryAdmin": {
      "adminView": "Vista de administrador",
      "activeOrders": "Órdenes activas",
      "sidebarTitle": "Mis pedidos",
      "scopeTitle": "Seguimiento",
      "total": "Total",
      "order": "Orden",
      "details": "Detalles",
      "unknown": "Desconocido",
      "dash": "-",
      "paymentLabel": "Pago :",
      "tabs": {
        "inProgress": "En curso",
        "history": "Histórico"
      },
      "captureStatus": {
        "authorized": "Permitido",
        "succeeded": "Exitoso",
        "captured": "Captura",
        "canceled": "Cancelado",
        "failed": "Fallido"
      },
      "emptyOrdersForStatus": "Ningún comando {{status}}.",
      "storeFallback": "Tienda no especificada",
      "clientFallback": "Cliente no informado",
      "operationalStatus": "Estado operativo",
      "newStatus": "Nuevo estado",
      "assignDelivererBeforeStatusChange": "Asigna un repartidor antes de cambiar este estado.",
      "apply": "Aplicar",
      "deliverer": "persona de entrega",
      "assignOrReassign": "Asignar o reasignar",
      "loadingDeliverers": "Repartidores cargando",
      "updateDeliverer": "Actualizar al repartidor",
      "systemActions": "Acciones del sistema",
      "resetToPending": "Plancha en espera",
      "cancelOrder": "Cancelar pedido",
      "forceCaptureTitle": "Forzar captura de pago",
      "forceCaptureDescription": "Captura el pago y marca el pedido como entregado.",
      "reasonPlaceholder": "Razón (opcional)",
      "captureAndDeliver": "Capturar y entregar",
      "manageOrder": "Gestionar pedido",
      "actionImpossible": "Acción imposible para este comando.",
      "loadError": "No se pudieron cargar los comandos de administrador.",
      "orderPausedWithReason": "Comando en pausa{{reason}}",
      "toasts": {
        "statusUpdated": "Estado actualizado.",
        "orderResetPending": "Pedido realizado nuevamente en espera.",
        "delivererUpdated": "Repartidor actualizado.",
        "orderCancelled": "Pedido cancelado.",
        "paymentCapturedDelivered": "Pago capturado y pedido entregado."
      }
    },
    "courses": {
      "tabs": {
        "aroundMe": "a mi alrededor",
        "route": "Itinerario"
      },
      "adsLabel": "Anuncios disponibles",
      "placeholders": {
        "addressAround": "Dirección a mi alrededor",
        "departureAddress": "Dirección de salida",
        "arrivalAddress": "Dirección de llegada",
        "radiusKm": "Radio"
      },
      "banners": {
        "connectionRequired": "Es necesario iniciar sesión para aceptar un pedido.",
        "orderAccepted": "Pedido aceptado.",
        "orderUnavailable": "Este comando ya no está disponible.",
        "acceptNetworkError": "Error de red durante la aceptación."
      },
      "emptyPendingOrders": "Sin pedidos pendientes.",
      "modal": {
        "orderDetails": "Detalles del pedido",
        "noImage": "Sin fotos",
        "itemsCount": "{{count}} artículo(s)",
        "store": "Comercio",
        "delivery": "Entrega",
        "storePhotoAlt": "Foto de {{store}}"
      },
      "aria": {
        "radiusInKm": "Radio en kilómetros",
        "deliveryPrice": "Precio de entrega",
        "estimatedDelay": "Plazo estimado",
        "distance": "Distancia",
        "recommendedVehicle": "Vehículo recomendado",
        "totalWeight": "peso total",
        "totalVolume": "volumen total",
        "billedWeight": "Peso de la factura",
        "store": "Comercio",
        "storeAddress": "Dirección de la tienda",
        "storePhone": "tienda de telefonos",
        "client": "Cliente",
        "deliveryAddress": "Dirección de entrega",
        "clientPhone": "Teléfono del cliente"
      },
      "notProvidedFemale": "No especificado",
      "notProvidedMale": "No especificado",
      "skip": "Aprobar",
      "accept": "Aceptar",
      "loading": "Cargando",
      "km": "kilómetros",
      "kg": "kilos",
      "m3": "m3"
    },
    "gestionModal": {
      "create": "Crear",
      "edit": "para modificar",
      "store": "comercio",
      "product": "producto",
      "deleteItem": "BORRAR",
      "storeName": "Nombre de la tienda",
      "storeNamePlaceholder": "Nombre de la tienda",
      "category": "Categoría",
      "selectCategory": "Selecciona una categoría",
      "categories": {
        "alimentation": "Alimento",
        "restaurant": "Restaurante",
        "sante": "Salud",
        "mobilite": "Movilidad",
        "pretAPorter": "Listo para usar",
        "informatique": "Ciencias de la Computación",
        "bricolage": "bricolaje",
        "jardin": "Jardín"
      },
      "fullAddress": "dirección completa",
      "address": "DIRECCIÓN",
      "defineOpeningHours": "Definir horario de apertura",
      "exceptionalClosure": "Cierre excepcional",
      "deliveryFeeParticipationTitle": "Contribución a los gastos de envío.",
      "enableParticipation": "Activar",
      "enableParticipationAria": "Activar la contribución a los gastos de envío",
      "participationShareLabel": "Parte del envio asumida",
      "participationHelp": "Porcentaje del envio cubierto por tu comercio.",
      "participationOptions": {
        "25": "25 % del envio",
        "50": "50 % del envio",
        "75": "75 % del envio",
        "100": "100 % del envio"
      },
      "contributionCapLabel": "Tope maximo (% del carrito)",
      "contributionOptions": {
        "10": "max 10 % del carrito",
        "20": "max 20 % del carrito",
        "30": "max 30 % del carrito"
      },
      "contributionHelp": "Limite maximo para proteger tu margen.",
      "participationPreview": "Ejemplo: envio {{deliveryFee}} EUR, carrito {{cartAmount}} EUR -> cubres {{amount}} EUR.",
      "coverImage": "Imagen de portada",
      "image": "Imagen",
      "imageConstraints": "Formatos aceptados: JPG, PNG. Tamaño recomendado inferior a 2 MB.",
      "collection": "Recopilación",
      "productName": "Nombre del producto",
      "name": "Nombre",
      "price": "Precio",
      "description": "Descripción",
      "selectShippingFormat": "Seleccione un formato de transporte",
      "shippingGroups": {
        "smallPackages": "Paquetes pequeños",
        "mediumPackages": "Paquetes medianos",
        "largeObjects": "Objetos grandes"
      },
      "shippingOptions": {
        "petit_colis": "paquete pequeño",
        "sac_ou_vetement": "bolso o ropa",
        "carton_moyen": "Cartón mediano",
        "fragile": "Frágil",
        "meuble": "Muebles",
        "gros_objet": "Objeto grande"
      },
      "preparingProductOptions": "Preparando opciones de productos...",
      "save": "Ahorrar",
      "saving": "Registro..."
    },
    "variableEditor": {
      "productOptionsAria": "Editar opciones de producto",
      "productOptionsTitle": "Opciones de producto",
      "addOption": "Agregar una opción",
      "emptyHelpPrefix": "Puedes crear opciones como",
      "emptyHelpSuffix": "para personalizar el producto.",
      "examples": {
        "size": "Tamaño",
        "dough": "Masa",
        "supplements": "Suplementos"
      },
      "optionLegend": "Opción {{index}}",
      "optionName": "Nombre de la opción",
      "optionNamePlaceholder": "Ej: tamaño",
      "type": "Amable",
      "singleChoice": "elección única",
      "multipleChoice": "opción múltiple",
      "required": "Obligatorio",
      "hideDetails": "Ocultar detalles",
      "showDetails": "Mostrar detalles",
      "deleteOptionAria": "Eliminar opción {{index}}",
      "examplePrefix": "Ejemplo :",
      "exampleSingleRequired": "se requiere una sola opción",
      "or": "O",
      "exampleMultipleMax": "opción múltiple con máximo",
      "groupHelpSrOnly": "Configura opciones avanzadas para este grupo.",
      "advancedOptionsAria": "Opciones avanzadas",
      "advancedOptions": "Opciones avanzadas",
      "hideAdvancedOptions": "Ocultar opciones avanzadas",
      "max": "máx.",
      "maxSelectionsAria": "Número máximo de selecciones",
      "technicalKey": "Clave técnica",
      "technicalKeyPlaceholder": "Ej: tamaño",
      "groupKeyAria": "Clave técnica del grupo",
      "choiceLabel": "palabra de elección",
      "choiceLabelPlaceholder": "Ej: grande",
      "extraCost": "Suplemento",
      "extraCostHelpSrOnly": "Importe añadido al precio base.",
      "defaultChoiceSingle": "Elección predeterminada",
      "deleteChoiceAria": "Eliminar opción {{value}}",
      "addChoiceAria": "Agregar una opción",
      "addChoice": "Agregar una opción",
      "footerHelp": "Las opciones se aplicarán únicamente a este producto.",
      "defaultOptionLabel": "Opción"
    },
    "panier": {
      "title": "Cesta",
      "modalDescription_one": "{{count}} artículo en tu cesta",
      "modalDescription_other": "{{count}} artículos en tu cesta",
      "emptyCartDescription": "Tu cesta está vacía.",
      "emptyCart": "No hay artículos por el momento.",
      "discoverStores": "Descubre las tiendas",
      "atStore": "en la casa de",
      "quantityForProductAria": "Cantidad para {{name}}",
      "removeOneAria": "Eliminar un artículo de {{name}}",
      "addOneAria": "Agregar un artículo de {{name}}",
      "products": "Productos",
      "delivery": "Entrega",
      "participationOf": "Participación de {{store}}",
      "deliveryEstimateLoading": "Cálculo de gastos de envío...",
      "chooseAddressForEstimate": "Elija una dirección para estimar la entrega.",
      "loginToEstimate": "Inicie sesión para obtener un presupuesto.",
      "login": "Acceso",
      "estimatedTotal": "Estimaciones totales",
      "doubleDash": "--",
      "selectAddressPrompt": "Seleccione una dirección",
      "defaultRotatingMessage": "Calculamos el mejor precio para ti.",
      "preparing": "Preparación...",
      "order": "Orden",
      "chooseAddress": "Elige una dirección",
      "estimateError": "Imposible estimar la entrega.",
      "authRequiredToPay": "Es necesario iniciar sesión para pagar.",
      "serverError": "Error del servidor.",
      "storeFallback": "Comercio",
      "noPaymentPrepared": "No se ha preparado ningún pago.",
      "paymentInfoUnavailable": "Información de pago no disponible.",
      "preparePaymentError": "Error durante la preparación del pago.",
      "messages": {
        "1": "Preparamos tu pedido...",
        "2": "Se está calculando la mejor ruta.",
        "3": "Tus productos llegarán pronto.",
        "4": "Optimizamos los costes de envío.",
        "5": "Un momento más...",
        "6": "Tu cesta está en buenas manos.",
        "7": "Comprobamos la disponibilidad de los artículos.",
        "8": "Las tiendas se están preparando.",
        "9": "Gracias por tu paciencia.",
        "10": "Estamos ultimando tu presupuesto.",
        "11": "Casi terminado.",
        "12": "Su pago estará listo en un momento.",
        "13": "Sincronizamos la información de pago.",
        "14": "Últimas comprobaciones en curso."
      }
    },
    "home": {
      "welcomeTitle": "Bienvenido a Riveltime",
      "welcomeSubtitle": "El mercado local para realizar pedidos en segundos.",
      "order": "Pedir",
      "continueWithoutAccount": "Continuar sin cuenta",
      "proQuestion": "Eres comerciante o repartidor?",
      "accessVendor": "Acceso vendedor",
      "accessCourier": "Acceso repartidor",
      "hello": "Hola {{name}}",
      "yourRole": "Tu papel:",
      "preparingSpace": "Preparando tu espacio...",
      "goToMySpace": "Accede a mi espacio",
      "logout": "Finalizar la sesión",
      "installPrompt": "Instale Riveltime para un acceso más rápido",
      "install": "Instalar",
      "androidInstallTitle": "Instalacion en Android",
      "androidInstallHintGeneric": "Abre el menu del navegador y pulsa Instalar aplicacion o Anadir a la pantalla de inicio.",
      "androidInstallHintSamsung": "En Samsung Internet, abre el menu y elige Instalar aplicacion o Anadir pagina a la pantalla de inicio.",
      "androidInstallHintXiaomi": "En Mi Browser, abre el menu y elige Anadir a la pantalla de inicio o Instalar aplicacion.",
      "iosInstallTitle": "Instalación en iPhone",
      "iosInstallStep1": "Prensa",
      "iosInstallShare": "Compartir",
      "iosInstallStep2": "Entonces",
      "iosInstallHomeScreen": "En la pantalla de inicio",
      "close": "Cerca",
      "logoAlt": "Logotipo de Riveltime",
      "roles": {
        "client": "Cliente",
        "vendeur": "Vendedor",
        "livreur": "persona de entrega"
      }
    }
  },
  "ar": {
    "liveSocket": {
      "originHintNetlify": "تتحول الجبهة إلى {{origin}}. يتحقق من متغير عنوان URL لواجهة برمجة التطبيقات وقواعد CORS.",
      "inferred": {
        "blockedOrNoResponse": "لا توجد استجابة من الواجهة الخلفية (الشبكة أو الوكيل أو CORS).",
        "endpointNotFound": "لم يتم العثور على مقبس نقطة النهاية (المسار/الوكيل).",
        "forbidden": "تم رفض الوصول (CORS أو قاعدة الأمان).",
        "unauthorized": "تم رفض المصادقة (الرمز المميز غير صالح/منتهي الصلاحية).",
        "proxyUnavailable": "الخادم غير متاح مؤقتًا (5xx)."
      }
    },
    "userStore": {
      "unableToFetchProfile": "غير قادر على استرداد الملف الشخصي.",
      "invalidSessionReconnect": "جلسة غير صالحة. أعد الاتصال.",
      "deleteAccountFailed": "فشل حذف الحساب.",
      "unexpectedError": "خطأ غير متوقع."
    },
    "boutiqueStore": {
      "sessionDesyncedReconnectRequired": "الجلسة غير متزامنة. إعادة الاتصال مطلوبة.",
      "accountSyncInProgressRetry": "تتم مزامنة الحساب. حاول مرة أخرى خلال بضع ثوانٍ أو قم بتسجيل الدخول مرة أخرى.",
      "unableToLoadYourStores": "غير قادر على تحميل المتاجر الخاصة بك.",
      "storeDeleted": "تم حذف المتجر.",
      "unableToDeleteStore": "غير قادر على حذف المتجر."
    },
    "deliveryAdmin": {
      "adminView": "عرض المسؤول",
      "activeOrders": "أوامر نشطة",
      "sidebarTitle": "طلباتي",
      "scopeTitle": "المتابعة",
      "total": "المجموع",
      "order": "طلب",
      "details": "تفاصيل",
      "unknown": "مجهول",
      "dash": "-",
      "paymentLabel": "قسط :",
      "tabs": {
        "inProgress": "في تَقَدم",
        "history": "تاريخية"
      },
      "captureStatus": {
        "authorized": "مسموح",
        "succeeded": "ناجح",
        "captured": "يأسر",
        "canceled": "تم الإلغاء",
        "failed": "فشل"
      },
      "emptyOrdersForStatus": "لا يوجد أمر {{status}}.",
      "storeFallback": "المحل غير محدد",
      "clientFallback": "لم يتم إبلاغ العميل",
      "operationalStatus": "الحالة التشغيلية",
      "newStatus": "الوضع الجديد",
      "assignDelivererBeforeStatusChange": "قم بتعيين شخص التوصيل قبل تغيير هذه الحالة.",
      "apply": "يتقدم",
      "deliverer": "شخص التسليم",
      "assignOrReassign": "تعيين أو إعادة تعيين",
      "loadingDeliverers": "رجال التوصيل يقومون بالتحميل",
      "updateDeliverer": "تحديث شخص التسليم",
      "systemActions": "إجراءات النظام",
      "resetToPending": "الحديد في الانتظار",
      "cancelOrder": "إلغاء الطلب",
      "forceCaptureTitle": "فرض القبض على الدفع",
      "forceCaptureDescription": "يلتقط الدفع ويضع علامة على الطلب على أنه تم تسليمه.",
      "reasonPlaceholder": "السبب (اختياري)",
      "captureAndDeliver": "التقاط وتسليم",
      "manageOrder": "إدارة النظام",
      "actionImpossible": "العمل مستحيل لهذا الأمر.",
      "loadError": "فشل في تحميل أوامر المسؤول.",
      "orderPausedWithReason": "تم إيقاف الأمر مؤقتًا{{reason}}",
      "toasts": {
        "statusUpdated": "تم تحديث الحالة.",
        "orderResetPending": "تم تعليق الطلب مرة أخرى.",
        "delivererUpdated": "تم تحديث رجل التسليم.",
        "orderCancelled": "تم إلغاء الطلب.",
        "paymentCapturedDelivered": "تم القبض على الدفع وتم تسليم الطلب."
      }
    },
    "courses": {
      "tabs": {
        "aroundMe": "حولي",
        "route": "خط سير الرحلة"
      },
      "adsLabel": "الإعلانات المتاحة",
      "placeholders": {
        "addressAround": "العنوان من حولي",
        "departureAddress": "عنوان المغادرة",
        "arrivalAddress": "عنوان الوصول",
        "radiusKm": "نصف القطر"
      },
      "banners": {
        "connectionRequired": "تسجيل الدخول مطلوب لقبول الطلب.",
        "orderAccepted": "تم قبول الطلب.",
        "orderUnavailable": "هذا الأمر لم يعد متوفرا.",
        "acceptNetworkError": "خطأ في الشبكة أثناء القبول."
      },
      "emptyPendingOrders": "لا توجد أوامر معلقة.",
      "modal": {
        "orderDetails": "تفاصيل الطلب",
        "noImage": "لا توجد صور",
        "itemsCount": "{{count}} العناصر",
        "store": "محل",
        "delivery": "توصيل",
        "storePhotoAlt": "الصورة بواسطة {{store}}"
      },
      "aria": {
        "radiusInKm": "نصف القطر بالكيلومترات",
        "deliveryPrice": "سعر التسليم",
        "estimatedDelay": "الموعد النهائي المقدر",
        "distance": "مسافة",
        "recommendedVehicle": "السيارة الموصى بها",
        "totalWeight": "الوزن الإجمالي",
        "totalVolume": "الحجم الإجمالي",
        "billedWeight": "وزن الفاتورة",
        "store": "محل",
        "storeAddress": "عنوان المحل",
        "storePhone": "متجر الهاتف",
        "client": "عميل",
        "deliveryAddress": "عنوان التسليم",
        "clientPhone": "هاتف العميل"
      },
      "notProvidedFemale": "غير محدد",
      "notProvidedMale": "غير محدد",
      "skip": "يمر",
      "accept": "يقبل",
      "loading": "تحميل",
      "km": "كم",
      "kg": "كجم",
      "m3": "م3"
    },
    "gestionModal": {
      "create": "يخلق",
      "edit": "للتعديل",
      "store": "محل",
      "product": "منتج",
      "deleteItem": "يمسح",
      "storeName": "اسم المحل",
      "storeNamePlaceholder": "اسم المحل",
      "category": "فئة",
      "selectCategory": "حدد فئة",
      "categories": {
        "alimentation": "طعام",
        "restaurant": "مطعم",
        "sante": "صحة",
        "mobilite": "التنقل",
        "pretAPorter": "جاهز للارتداء",
        "informatique": "علوم الكمبيوتر",
        "bricolage": "DIY",
        "jardin": "حديقة"
      },
      "fullAddress": "العنوان الكامل",
      "address": "عنوان",
      "defineOpeningHours": "تحديد ساعات العمل",
      "exceptionalClosure": "إغلاق استثنائي",
      "deliveryFeeParticipationTitle": "المساهمة في تكاليف التسليم",
      "enableParticipation": "تفعيل",
      "enableParticipationAria": "تفعيل المساهمة في رسوم التوصيل",
      "participationShareLabel": "نسبة رسوم التوصيل التي تتكفل بها",
      "participationHelp": "النسبة من رسوم التوصيل التي يغطيها متجرك.",
      "participationOptions": {
        "25": "25٪ من رسوم التوصيل",
        "50": "50٪ من رسوم التوصيل",
        "75": "75٪ من رسوم التوصيل",
        "100": "100٪ من رسوم التوصيل"
      },
      "contributionCapLabel": "الحد الاقصى (% من السلة)",
      "contributionOptions": {
        "10": "حد اقصى 10٪ من السلة",
        "20": "حد اقصى 20٪ من السلة",
        "30": "حد اقصى 30٪ من السلة"
      },
      "contributionHelp": "حد اقصى لحماية هامش الربح.",
      "participationPreview": "مثال: رسوم {{deliveryFee}} EUR، سلة {{cartAmount}} EUR -> تتحمل {{amount}} EUR.",
      "coverImage": "صورة الغلاف",
      "image": "صورة",
      "imageConstraints": "التنسيقات المقبولة: JPG، PNG. الحجم الموصى به أقل من 2 ميغابايت.",
      "collection": "مجموعة",
      "productName": "اسم المنتج",
      "name": "اسم",
      "price": "سعر",
      "description": "وصف",
      "selectShippingFormat": "حدد تنسيق النقل",
      "shippingGroups": {
        "smallPackages": "حزم صغيرة",
        "mediumPackages": "العبوات المتوسطة",
        "largeObjects": "كائنات كبيرة"
      },
      "shippingOptions": {
        "petit_colis": "حزمة صغيرة",
        "sac_ou_vetement": "حقيبة أو ملابس",
        "carton_moyen": "كرتونة متوسطة",
        "fragile": "قابل للكسر",
        "meuble": "أثاث",
        "gros_objet": "كائن كبير"
      },
      "preparingProductOptions": "جارٍ إعداد خيارات المنتج...",
      "save": "يحفظ",
      "saving": "تسجيل..."
    },
    "variableEditor": {
      "productOptionsAria": "تحرير خيارات المنتج",
      "productOptionsTitle": "خيارات المنتج",
      "addOption": "إضافة خيار",
      "emptyHelpPrefix": "يمكنك إنشاء خيارات مثل",
      "emptyHelpSuffix": "لتخصيص المنتج.",
      "examples": {
        "size": "مقاس",
        "dough": "عجين",
        "supplements": "المكملات الغذائية"
      },
      "optionLegend": "الخيار {{index}}",
      "optionName": "اسم الخيار",
      "optionNamePlaceholder": "على سبيل المثال: الحجم",
      "type": "عطوف",
      "singleChoice": "اختيار واحد",
      "multipleChoice": "الاختيار من متعدد",
      "required": "إلزامي",
      "hideDetails": "إخفاء التفاصيل",
      "showDetails": "إظهار التفاصيل",
      "deleteOptionAria": "إزالة الخيار {{index}}",
      "examplePrefix": "مثال :",
      "exampleSingleRequired": "مطلوب اختيار واحد",
      "or": "أو",
      "exampleMultipleMax": "الاختيار من متعدد مع الحد الأقصى",
      "groupHelpSrOnly": "تكوين الخيارات المتقدمة لهذه المجموعة.",
      "advancedOptionsAria": "خيارات متقدمة",
      "advancedOptions": "خيارات متقدمة",
      "hideAdvancedOptions": "إخفاء الخيارات المتقدمة",
      "max": "الأعلى",
      "maxSelectionsAria": "الحد الأقصى لعدد الاختيارات",
      "technicalKey": "المفتاح الفني",
      "technicalKeyPlaceholder": "على سبيل المثال: الحجم",
      "groupKeyAria": "المفتاح الفني للمجموعة",
      "choiceLabel": "كلمة الاختيار",
      "choiceLabelPlaceholder": "على سبيل المثال: كبير",
      "extraCost": "ملحق",
      "extraCostHelpSrOnly": "المبلغ المضاف إلى السعر الأساسي.",
      "defaultChoiceSingle": "الاختيار الافتراضي",
      "deleteChoiceAria": "حذف الاختيار {{value}}",
      "addChoiceAria": "أضف خيارًا",
      "addChoice": "أضف خيارًا",
      "footerHelp": "سيتم تطبيق الخيارات على هذا المنتج فقط.",
      "defaultOptionLabel": "خيار"
    },
    "panier": {
      "title": "سلة",
      "modalDescription_one": "{{count}} عنصر في سلتك",
      "modalDescription_other": "{{count}} العناصر الموجودة في سلتك",
      "emptyCartDescription": "سلتك فارغة.",
      "emptyCart": "لا توجد مقالات في الوقت الراهن.",
      "discoverStores": "اكتشف المتاجر",
      "atStore": "في منزل",
      "quantityForProductAria": "الكمية لـ {{name}}",
      "removeOneAria": "إزالة مقالة من {{name}}",
      "addOneAria": "إضافة مقالة من {{name}}",
      "products": "منتجات",
      "delivery": "توصيل",
      "participationOf": "مشاركة {{store}}",
      "deliveryEstimateLoading": "حساب تكاليف التوصيل...",
      "chooseAddressForEstimate": "اختر عنوانًا لتقدير التسليم.",
      "loginToEstimate": "تسجيل الدخول للحصول على تقدير.",
      "login": "تسجيل الدخول",
      "estimatedTotal": "إجمالي التقديرات",
      "doubleDash": "--",
      "selectAddressPrompt": "حدد عنوانا",
      "defaultRotatingMessage": "نحن نحسب أفضل الأسعار بالنسبة لك.",
      "preparing": "تحضير...",
      "order": "طلب",
      "chooseAddress": "اختر عنوانا",
      "estimateError": "من المستحيل تقدير التسليم.",
      "authRequiredToPay": "تسجيل الدخول مطلوب للدفع.",
      "serverError": "خطأ في الخادم.",
      "storeFallback": "محل",
      "noPaymentPrepared": "لم يتم إعداد أي دفعة.",
      "paymentInfoUnavailable": "معلومات الدفع غير متاحة.",
      "preparePaymentError": "حدث خطأ أثناء إعداد الدفع.",
      "messages": {
        "1": "نحن نجهز طلبك...",
        "2": "يتم الآن حساب أفضل طريق.",
        "3": "منتجاتك تصل قريبا.",
        "4": "نحن نحسن تكاليف التسليم.",
        "5": "لحظة اخرى...",
        "6": "سلتك في أيدٍ أمينة.",
        "7": "نحن نتحقق من توافر المقالات.",
        "8": "المتاجر تستعد.",
        "9": "شكرا لك على صبركم.",
        "10": "نحن بصدد وضع اللمسات النهائية على تقديرك.",
        "11": "انتهى تقريبا.",
        "12": "الخروج الخاص بك سيكون جاهزا في لحظة.",
        "13": "نقوم بمزامنة معلومات الدفع.",
        "14": "أحدث الشيكات الجارية."
      }
    },
    "home": {
      "welcomeTitle": "مرحبا بكم في ريفيلتايم",
      "welcomeSubtitle": "السوق المحلي للطلب في ثواني.",
      "order": "اطلب",
      "continueWithoutAccount": "الاستمرار بدون حساب",
      "proQuestion": "هل انت تاجر ام سائق توصيل؟",
      "accessVendor": "دخول البائع",
      "accessCourier": "دخول السائق",
      "hello": "مرحبا {{name}}",
      "yourRole": "دورك:",
      "preparingSpace": "تجهيز مساحتك...",
      "goToMySpace": "الوصول إلى المساحة الخاصة بي",
      "logout": "تسجيل الخروج",
      "installPrompt": "قم بتثبيت Riveltime للوصول بشكل أسرع",
      "install": "ثَبَّتَ",
      "androidInstallTitle": "التثبيت على اندرويد",
      "androidInstallHintGeneric": "افتح قائمة المتصفح ثم اضغط على تثبيت التطبيق او اضافة الى الشاشة الرئيسية.",
      "androidInstallHintSamsung": "في Samsung Internet افتح القائمة ثم اختر تثبيت التطبيق او اضافة الصفحة الى الشاشة الرئيسية.",
      "androidInstallHintXiaomi": "في Mi Browser افتح القائمة ثم اختر اضافة الى الشاشة الرئيسية او تثبيت التطبيق.",
      "iosInstallTitle": "التثبيت على اي فون",
      "iosInstallStep1": "يضعط",
      "iosInstallShare": "يشارك",
      "iosInstallStep2": "ثم",
      "iosInstallHomeScreen": "على الشاشة الرئيسية",
      "close": "يغلق",
      "logoAlt": "شعار ريفيل تايم",
      "roles": {
        "client": "عميل",
        "vendeur": "بائع",
        "livreur": "شخص التسليم"
      }
    }
  }
};

const mergeMessages = (target, source) => {
  const out = { ...(target || {}) };
  Object.entries(source || {}).forEach(([key, value]) => {
    if (
      value &&
      typeof value === "object" &&
      !Array.isArray(value) &&
      typeof out[key] === "object" &&
      out[key] !== null &&
      !Array.isArray(out[key])
    ) {
      out[key] = mergeMessages(out[key], value);
      return;
    }
    out[key] = value;
  });
  return out;
};

const TURKISH_MESSAGE_OVERRIDES = {
  bottomNav: {
    courier: { runs: "Teslimatlar" },
    admin: { manage: "Yönetim" },
    ambassador: { accounts: "Ekle" },
  },
  notificationBanner: {
    close: "Kapat",
  },
  header: {
    sections: {
      courier: { runs: "Teslimatlar" },
      ambassador: { accounts: "Ekle" },
    },
  },
  supportIssue: {
    close: "Kapat",
    impact: "Etki",
    description: "Açıklama",
    categories: {
      ui_bug: "Arayüz hatası",
    },
  },
  verifyEmail: {
    invalidEmail: "Geçerli bir e-posta adresi girin.",
    cancel: "İptal",
    confirm: "Onayla",
    close: "Kapat",
    logout: "Oturumu kapat",
    activeOrders_one: "Silme mümkün değil: {{count}} aktif sipariş var",
    activeOrders_other: "Silme mümkün değil: {{count}} aktif sipariş var",
    activeOrdersGeneric: "Silme mümkün değil: aktif siparişler var",
  },
  home: {
    view: "Görüntüle",
    order: "Sipariş ver",
    install: "Yükle",
    close: "Kapat",
    filters: {
      free: "Ücretsiz",
    },
    prelaunch: {
      waitlistInvalidEmail: "Geçerli bir e-posta adresi girin.",
      ctaSecondary: "Satıcıyım",
    },
    accountLink: {
      close: "Kapat",
    },
  },
  profile: {
    save: "Kaydet",
    edit: "Düzenle",
    complete: "Tamamla",
    supportCta: "Sorun bildir",
    infoSheet: {
      save: "Kaydet",
    },
    desktopStateDisabled: "Devre dışı",
    certification: {
      ambassadorLabel: "Temsilci",
    },
  },
  panier: {
    atStore: "Mağaza:",
    order: "Sipariş ver",
  },
  magicImport: {
    steps: {
      review: "İncele",
    },
    actions: {
      close: "Kapat",
    },
    review: {
      boutique: {
        title: "Mağaza taslağı",
      },
    },
  },
  liveSocket: {
    close: "Kapat",
  },
  admin: {
    close: "Kapat",
    approve: "Onayla",
    roles: {
      ambassadeur: "Temsilciler",
    },
    accountHolder: {
      save: "Kaydet",
    },
    transfer: {
      confirm: {
        confirm: "Onayla",
        cancel: "İptal",
      },
    },
  },
  deliveryAdmin: {
    order: "Sipariş",
  },
  deliveryVendor: {
    cancel: "İptal",
    validate: "Onayla",
  },
  deliveryCourier: {
    goToCourses: "Teslimatlara git",
  },
  ambassador: {
    dashboard: {
      title: "Temsilci paneli",
    },
    accounts: {
      confirm: {
        confirm: "Onayla",
        cancel: "İptal",
      },
    },
  },
  gestionProduits: {
    actions: {
      editProduct: "Düzenle",
    },
  },
  paymentMethods: {
    save: "Kaydet",
  },
  gestionModal: {
    save: "Kaydet",
  },
};

Object.entries(EXTRA_MESSAGES).forEach(([locale, values]) => {
  MESSAGES[locale] = mergeMessages(MESSAGES[locale] || {}, values);
});

Object.entries(AUTO_EXTRA_MESSAGES).forEach(([locale, values]) => {
  MESSAGES[locale] = mergeMessages(MESSAGES[locale] || {}, values);
});

MESSAGES["tr-TR"] = mergeMessages(MESSAGES["fr-FR"] || {}, TURKISH_MESSAGES);
MESSAGES["tr-TR"] = mergeMessages(MESSAGES["tr-TR"] || {}, TURKISH_MESSAGE_OVERRIDES);
